export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "ESCRIME XXI N⁰. 106",
    "shortTitle": "",
    "description": "Fencing Magazine",
    "width": 1536,
    "height": 1152,
    "currentLanguage": "ES",
    "languages": [{
      "code": "EN",
      "text": "English",
      "href": "http://escrime-xxi.fie.org/106/en/1-1"
    },
    {
      "code": "FR",
      "text": "French",
      "href": "http://escrime-xxi.fie.org/106/fr/1-1"
    },
    {
      "code": "ES",
      "text": "Spanish",
      "href": "http://escrime-xxi.fie.org/106/es/1-1"
    }],
    "basePath": "/106/es",
    "companyLogo": "escrime-logo.png",
    "publishURL": "http://escrime-xxi.fie.org/106/es/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": false,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": false,
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": true,
      "mobileSwitch": true
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `<img id="1-0" class="halfScale" src="/106/es/static/_content/1-logo2.png" style="top: 0; left: 378px;opacity:1;" />
      <img id="1-1" class="halfScale" src="/106/es/static/_content/1-logo.png" style="top: 111px; left: 0px;" />
      <img id="1-2" class="halfScale" src="/106/es/static/_content/1-logo3.png" style="top: 277px; left: 69px;" />
      <img id="1-3" class="halfScale" src="/106/es/static/_content/1-logo4.png" style="top: 111px; left:1080px;" />
      <img id="1-5" class="1-text halfScale pointer" src="/106/es/static/_content/1-t1.png" style="top: 357px; left: 881px;" onclick="Publish.goToPage(8)" />
      <img id="1-6" class="1-text halfScale pointer" src="/106/es/static/_content/1-t2.png" style="top: 507px; left: 1058px;" onclick="Publish.goToPage(12)"/>
      <img id="1-7" class="1-text halfScale pointer" src="/106/es/static/_content/1-t3.png" style="top: 689px; left: 1060px;" onclick="Publish.goToPage(48)"/>
      <img id="1-8" class="halfScaleBR pointer" src="/106/es/static/_content/1-next.png" style="bottom:50px; right: -40px;" onclick="Publish.goToNextPage()"/>
    `,
    "script": `
      function onPageEnter() {
        page1Anim = new TimelineMax()
        page1Anim
        .fromTo(idOf("1-1"), 0.8, {x: -300, opacity:0}, {x: 0, opacity: 1}, 0.5)
        .fromTo(idOf("1-0"), 0.5, {x: -300, opacity:0}, {x: 0, opacity: 1, ease: Back.easeOut.config(1.7)},"-=0.2")
        .fromTo(idOf("1-2"), 0.5, {x: -30, opacity:0}, {x: 0, opacity:1},"-=0.2")
        .fromTo(idOf("1-3"), 0.5, {x: -30, opacity:0}, {x: 0, opacity:1},"-=0.2")
        .staggerFromTo(cOf("1-text"), 0.8, {x:-200, opacity:0}, {x:0,  opacity:1},0.2, "+=0",addContentLinks)
        .fromTo(idOf("1-8"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1})
      }

      function onPageLeave() {
        page1Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "N˚106 REVISTA DIGITAL  FÉDÉRATION INTERNATIONALE D’ESCRIME  JUNIOR & CADETS WORLD CHAMPIONSHIPS SEOUL TO CALI FIE GRAND PRIX KAZUYASU MINOBE OLYMPIC FEVER  Utilice el teclado o arrastre el dedo por la pantalla para desplazarse a la izquierda y a la derecha por toda la revista"
      ,
      "mobileHtml": `
      <img id="p1img" src="/106/es/static/_mobile/mob-front.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Instrucciones De Uso",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
      <img id="2-title" class="halfScale" style="top:109px;left:82px" src="/106/es/static/_content/2-title.png">
      <img id="howto-btn-desktop" class="halfScale howto-desktop" style="top:125px;left:1076px;opacity: 1; display: block;" src="/106/es/static/_content/2-desktop.png">
      <img id="howto-btn-ipad" class="halfScale howto-ipad" style="top:126px;left:1279px;opacity: 0; display: none;" src="/106/es/static/_content/2-ipad.png">
  
      <img id="2-main" class="halfScale howto-desktop" style="top:266px;left:86px;display:block;opacity:1" src="/106/es/static/_content/2-desktop-main.png">
      <img id="2-main" class="halfScale howto-ipad" style="top:250px;left:86px; display:none;opacity:0" src="/106/es/static/_content/2-ipad-main.png">
  
      <img class="halfScale 2-icons" style="top:865px;left:158px" src="/106/es/static/_content/2-pop.png">
      <img class="halfScale 2-icons" style="top:866px;left:460px" src="/106/es/static/_content/2-play.png">
      <img class="halfScale 2-icons" style="top:866px;left:830px" src="/106/es/static/_content/2-social.png">
      <img class="halfScale 2-icons" style="top:866px;left:1154px" src="/106/es/static/_content/2-numbers.png">
  
      <img class="abs pointer hover halfScaleR" onclick="switchPopHowto(true)" style="top:125px;right:285px;" src="/106/es/static/_content/2-desktop.png">
      <img class="abs hover pointer halfScaleR" onclick="switchPopHowto(false)" style="top:125px;right:82px;"src="/106/es/static/_content/2-ipad.png">
  
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
            <a href="http://www.fie.org/es" target="_blank"></a>
          </div>
  
      `,
      "script": `
          function onPageEnter() {
            page2Anim = new TimelineMax()
            page2Anim.staggerFromTo(cOf("2-icons"), 0.6, {y: 30, opacity:0}, {y: 0, opacity: 1}, 0.3, 1)
            addContentLinks()
          }
  
          function btnOverHowto(el){
            el.style.display = "block";
            TweenMax.to(el, 0.5, {opacity:1});
          }
  
          function btnOutHowto(el){
            TweenMax.to(el, 0.5, {opacity:0, onComplete:function(){
              el.style.display = "none";
            }});
          }
  
          function switchPopHowto(bool){
            if(bool){
              TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:0, onComplete:function(){
                cOf("howto-ipad")[0].style.display = "none";
                cOf("howto-ipad")[1].style.display = "none";
              }});
              cOf("howto-desktop")[0].style.display = "block";
              cOf("howto-desktop")[1].style.display = "block";
              TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:1});
            }else{
              cOf("howto-ipad")[0].style.display = "block";
              cOf("howto-ipad")[1].style.display = "block";
              TweenMax.to(cOf("howto-ipad"), 0.5, {opacity:1});
              TweenMax.to(cOf("howto-desktop"), 0.5, {opacity:0, onComplete:function(){
                cOf("howto-desktop")[0].style.display = "none";
                cOf("howto-desktop")[1].style.display = "none";
              }});
            }
          }
  
          function onPageLeave() {
            
            removeContentLinks()
          }
  
        function onPageLeave() {
        }
      `,
      "searchText": "INSTRUCCIONES DE USO  Haga clic para cambiar la vista  INSTRUCCIONES DE USO  IPAD  ESCRITORIO  Escrime XXI  La revista de esgrima utiliza la última tecnología digital. Presentamos algunas características de uso para disfrutar de la publicación.  NAVEGADOR DE PÁGINAS  C ONOZCA A LOS ATLE TAS  Pulse una vez para mostrar la barra de menú; eche un vistazo a las miniaturas de las páginas para encontrar su artículo preferido.  Navegación  Para ver la revista, arrastre el dedo por la pantalla para desplazarse a la izquierda y a la derecha por toda la publicación.  KAZUYASU MINOBE  NAVEGAR Arrastre el dedo por la pantalla para navegar vertical y horizontalmente por toda la revista.  EXPLORAR  r… Zonas interactivas en el interio  1 2 3 ELEMENTOS EMERGENTES  BOTÓN DE REPRODUCCIÓN  REDES SOCIALES  NÚMEROS  Pulse para mostrar u ocultar retazos de información.  En esta revista encontrará vídeos fantásticos. Pulse este botón para disfrutar de ellos.  Pulse los iconos de las redes sociales que encontrará por toda la revista.  Pulse los botones para mostrar más contenidos apasionantes.  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" style="bottom:25px;right:40px;width:280px; height:30px;">
          <a href="http://tissotwatches.com" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        addContentLinks()
      }
  
      function onPageLeave() {
        removeContentLinks()
      }
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://www.tissotwatches.com" target="_blank">
        <img id="tissotimg" src="/106/es/static/_mobile/pg3-tissot.jpg" alt="Tissot Advert">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "En Este Número",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `<img id="4-title" class="halfScale" style="top:74px;left:87px" src="/106/es/static/_content/4-title.png">

      <img class="cont-item cont-item-1-btn halfScale" style="top:328px;left:574px;opacity:0;" src="/106/es/static/_content/4-fore.jpg">
        <img class="cont-item cont-item-2-btn halfScale" style="top:339px;left:574px;opacity:0;" src="/106/es/static/_content/4-junior.jpg">
        <img class="cont-item cont-item-3-btn halfScale" style="top:359px;left:574px;opacity:0;" src="/106/es/static/_content/4-sport.jpg">
        <img class="cont-item cont-item-4-btn halfScale" style="top:352px;left:574px;opacity:0;" src="/106/es/static/_content/4-interview.jpg">
        <img class="cont-item cont-item-5-btn halfScale" style="top:328px;left:574px;opacity:0;" src="/106/es/static/_content/4-fie.jpg">
        <img class="cont-item cont-item-6-btn halfScale" style="top:352px;left:574px;opacity:0;" src="/106/es/static/_content/4-news.jpg">
        <img class="cont-item cont-item-7-btn halfScale" style="top:314px;left:574px;opacity:0;" src="/106/es/static/_content/4-obit.jpg">
  
        <div class="addContentLink" onclick="contentsBub(1);" style="top:359px; left:86px; width: 490px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(2);" style="top:451px; left:86px; width: 490px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(3);" style="top:544px; left:86px; width: 490px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(4);" style="top:636px; left:86px; width: 490px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(5);" style="top:728px; left:86px; width: 490px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(6);" style="top:820px; left:86px; width: 490px; height: 60px;"></div>
        <div class="addContentLink" onclick="contentsBub(7);" style="top:912px; left:86px; width: 490px; height: 60px;"></div>
        <div class="addContentLink" style="top: 185px; left:80px;width:145px; height: 50px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
        <div class="addContentLink" style="top: 75px; right:623px;width:55px; height: 55px;">
          <a href="https://www.facebook.com/fie.org" target="_blank"></a></div>
        <div class="addContentLink" style="top:130px; right:623px;width:55px; height: 55px;">
          <a href="https://twitter.com/FIE_fencing" target="_blank"></a></div>
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a></div>
        <div class="contentLink cont-item-1-link" onclick="Publish.goToPage(6)" style="top:359px;left:647px;width:570px;height:345px;display:none;"></div>
        <div class="contentLink cont-item-2-link" onclick="Publish.goToPage(8)" style="top:451px;left:648px;width:706px;height:526px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(12)" style="top:450px;left:648px;width:525px;height:64px;display:none;"></div>
        <div class="contentLink cont-item-3-link" onclick="Publish.goToPage(29)" style="top:543px;left:648px;width:525px;height:430px;display:none;"></div>
        <div class="contentLink cont-item-4-link" onclick="Publish.goToPage(48)" style="top:358px;left:648px;width:410px;height:340px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(50)" style="top:451px;left:648px;width:708px;height:63px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(52)" style="top:543px;left:648px;width:708px;height:63px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(55)" style="top:633px;left:648px;width:708px;height:63px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(59)" style="top:728px;left:648px;width:708px;height:63px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(61)" style="top:820px;left:648px;width:708px;height:63px;display:none;"></div>
        <div class="contentLink cont-item-5-link" onclick="Publish.goToPage(66)" style="top:912px;left:648px;width:708px;height:86px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(70); setTimeout(function(){showOverlay('news-pop-1');}, 200)" style="top:545px;left:648px;width:815px;height:62px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(70); setTimeout(function(){showOverlay('news-pop-2');}, 200)" style="top:637px;left:648px;width:815px;height:62px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(70); setTimeout(function(){showOverlay('news-pop-3');}, 200)" style="top:728px;left:648px;width:815px;height:62px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(70); setTimeout(function(){showOverlay('news-pop-4');}, 200)" style="top:821px;left:648px;width:815px;height:62px;display:none;"></div>
        <div class="contentLink cont-item-6-link" onclick="Publish.goToPage(70); setTimeout(function(){showOverlay('news-pop-5');}, 200)" style="top:913px;left:648px;width:746px;height:62px;display:none;"></div>
        <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(71);" style="top:728px;left:648px;width:382px;height:62px;display:none;"></div>
        <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(71); setTimeout(function(){pg72Show2()}, 200)" style="top:820px;left:648px;width:382px;height:62px;display:none;"></div>
        <div class="contentLink cont-item-7-link" onclick="Publish.goToPage(71); setTimeout(function(){pg72Show3()}, 200)" style="top:913px;left:648px;width:382px;height:62px;display:none;"></div>
        
  
      <img id="4-next" class="halfScale pointer" style="top:941px;left:1412px" src="/106/es/static/_content/5-next.png" onclick="Publish.goToNextPage()">
      `,
      "script": `
      function onPageEnter() {
        page4Anim = new TimelineMax();
        
        page4Anim.fromTo(idOf("4-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1}, 0.5)
        .fromTo(idOf("4-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},"-=0.2")
      }
  
  
      function contentsBub(index){
        TweenMax.to(cOf("cont-hide"), 0.5, {opacity:0})
        console.log("contentsBub", index)
        for(var i=1; i <= 8; i++){
          if(i == index){
            [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
              console.log(c)
              c.style.display = "";
            },0);
            TweenMax.to(cOf("cont-item-"+i+"-btn"), 0.5, {opacity:1, onComplete:function(){
              /*
              classc("cont-item-"+index+"-link")[0].style.display = ""
              if(classc("cont-item-"+index+"-link")[1]){
                classc("cont-item-"+index+"-link")[1].style.display = ""        
              }
              */
            }});
          }else{
            [].slice.call(cOf("cont-item-"+i+"-link")).reduce(function(p,c){
                c.style.display = "none";
              },0);
            TweenMax.to(cOf("cont-item-"+i+"-btn"), 0.5, {opacity:0});
          }
        }
      }
  
      function onPageLeave() {
        page4Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "ÍNDICE  EN ESTE NÚMERO  Le damos la bienvenida a la última edición de Escrime XXI, que llega repleta de las mejores imágenes, vídeos y artículos del mundo de la esgrima, y presenta una imagen totalmente fresca y renovada  WWW.FIE.ORG  EDITORIAL  CAMPEONATOS JUNIOR Y CADETE  Pulse los botones para revelar el contenido  DEPORTE  N˚106  ENTREVISTA  DIGITAL MAGAZINE  FÉDÉRATION INTERNATIONALE D’ESCRIME  NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES  NOTICIAS  NECROLÓGICAS  JUNIOR & CADETS WORLD CHAMPIONSHIPS SEOUL TO CALI FIE GRAND PRIX KAZUYASU MINOBE OLYMPIC FEVER  Use your keyboard keys, or swipe to navigate leftand right through the magazine  W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Comité Ejecutivo De La FIE",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `<img id="5-next" class="halfScale pointer" style="top:856px;left:1391px" src="/106/es/static/_content/5-next.png" onclick="Publish.goToNextPage()">
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="" class="halfScaleC pulse animatedpulse" style="top:1045px;left:84px" src="/106/es/static/_content/5-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="" class="halfScaleC pulse animatedpulse" style="top:1045px;left:154px" src="/106/es/static/_content/5-fb.png">
      </a>
        <a href="https://www.youtube.com/user/FIEvideo" target="_blank">
        <img id="" class="halfScaleC pulse animatedpulse" style="top:1045px;left:223px" src="/106/es/static/_content/5-yt.png">
      </a>
      <div class="addContentLink" style="bottom:245px;left:745px;width:100px;height:26px;">
        <a href="mailto:info@fie.ch"></a>
      </div>
        <div class="addContentLink" style="bottom:213px;left:686px;width:105px;height:26px;">
          <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
        <div class="addContentLink" style="bottom:156px;right:398px;width:220px;height:30px;">
          <a href="http://www.touchline.com" target="_blank"></a>
      </div>
        <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page5Anim = new TimelineMax();
        
        page5Anim.fromTo(idOf("5-next"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks}, 0.5)
      }
  
      function onPageLeave() {
        page5Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "COMITÉ E JECUTIVO DE L A FIE  Presidente: Alisher Usmanov (RUS) Secretario general: Emmanuel Katsiadakis (M.H.) (GRE) Secretaria tesorera: Ferial Nadira Salhi (ALG)  OFICINA CENTRAL DE LA FIE  Vicepresidentes: Ana Pascu (M.H.) (ROU) Donald Anthony (USA) Wei Wang (CHN) Miembros: Erika Aze (LAT) Jacek Bierkowski (POL) Velichka Hristeva (BUL) Isabelle Lamour (FRA) Yuki Ota (JPN) Novak Perovic (RSA) Oleg Peskov (KAZ) Giorgio Scarso (ITA) Bence Szabo (HUN) Pascal Tesch (LUX) Aldo Montano President of the FIE athletes commission (ITA)  Administración  Directora general Nathalie Rodriguez M.-H. (FRA)  Directora administrativa: Elena Murdaca (ITA) Gestora de contabilidad: Sandra Baroni (SUI) Asistente de dirección: Gabrielle Meylan (BRA) Asistente administrativa: Ylenia Murdaca (ITA) Deporte  Director técnico y deportivo: Evgeny Tsoukhlo (RUS)  Manager de la tecnología y de la administración del deporte: Natalia Bodrova (RUS) Manager de operaciones del deporte: Sophie Treyvaud (SUI) Comunicación, Marketing, TV  Directora del departamento CMTV:  Presidente de la Confederación Africana de Esgrima: Mbagnick Ndiaye (SEN) Presidente de la Confederación Panamericana de Esgrima: Vitaly Logvin (MEX) Presidente de la Confederación Asiática de Esgrima: Celso L. Dayrit (M.H.) (PHI) Presidente de la Confederación Europea de Esgrima: Stanislav Pozdnyakov (RUS) Presidente de la Confederación Oceánica de Esgrima: Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tel.: +41 21 320 31 15 Fax: +41 21 320 31 16 e-mail: info@fie.ch www.fie.org  Elena Grishina (RUS)  Coordinadora digital: Maria Ntanou (GRE)  Jefe de producción TV de la FIE: Barna Heder (HUN)  Asistente de producción TV de la FIE: Svetlana Krasnokoutskaya (RUS) Encargado de prensa: Serge Timacheff (USA) Fotógrafo: Augusto Bizzi (ITA) Design Touchline (www.touchline.com)  W W W.FIE .ORG"
      ,
    "mobileHtml": `<p>
      <b>Presidente</b>:<br> Alisher Usmanov (RUS)<br>
      <b>Secretario general</b>:<br> Emmanuel Katsiadakis (M.H.) (GRE)<br>
      <b>Secretaria tesorera</b>:<br> Ferial Nadira Salhi (ALG)</p>
      <p>
      <b>Vice Presidents</b>:<br>
      Ana Pascu (M.H.) (ROU)<br>
      Donald Anthony (USA)<br>
      Wei Wang (CHN)<br></p>
      <p>
      <b>Miembros</b>:<br>
      Erika Aze (LAT)<br>
      Jacek Bierkowski (POL)<br>
      Velichka Hristeva (BUL)<br>
      Isabelle Lamour (FRA)<br>
      Yuki Ota (JPN)<br>
      Novak Perovic (RSA)<br>
      Oleg Peskov (KAZ)<br>
      Giorgio Scarso (ITA)<br>
      Bence Szabo (HUN)<br>
      Pascal Tesch (LUX)<br>
      Aldo Montano (ITA)<br></p>

      <p>
        <b>Presidente de la Confederación Africana de Esgrima</b>: <br>Mbagnick Ndiaye (SEN) <br>
        <b>Presidente de la Confederación Panamericana de Esgrima</b>: <br>Vitaly Logvin (MEX) <br>
        <b>Presidente de la Confederación Asiática de Esgrima</b>: <br>Celso L. Dayrit (M.H.) (PHI) <br>
        <b>Presidente de la Confederación Europea de Esgrima</b>: <br>Stanislav Pozdnyakov (RUS)<br>
        <b>Presidente de la Confederación Oceánica de Esgrima</b>: <br>Helen Smith (M.H.) (AUS)<br>
      </p>
      
      <h2>OFICINA CENTRAL DE LA FIE</h2>
      <p>
      <b>Directora general</b><br>
      Nathalie Rodriguez M.-H. (FRA)
      </p>

      <h2>Administración</h2>
      <p>
      <b>Directora administrativa</b>:<br> Elena Murdaca (ITA)<br>
      <b>Gestora de contabilidad</b>:<br> Sandra Baroni (BUL) <br>
      <b>Asistente de dirección</b>:<br> Gabrielle Meylan (BRA)<br>
      <b>Asistente administrativa</b>:<br> Ylenia Murdaca (ITA)<br>
      </p>

      <h2>Sport</h2>
      <p>
      <b>Director técnico y deportivo</b>:<br> Evgeny Tsoukhlo (RUS)<br>
      <b>Manager de la tecnología y de la administración del deporte</b>:<br> Natalia Bodrova (RUS)<br>
      <b>Manager de operaciones del deporte</b>:<br>Sophie Treyvaud (SUI) <br>
      </p>
      <h2>Comunicación, Marketing, TV</h2>
      <p>
      <b>Directora del departamento CMTV</b>:<br> Elena Grishina (RUS)<br>
      <b>Coordinadora digital</b>:<br> Maria Ntanou (GRE)<br>
      <b>Jefe de producción TV de la FIE</b>:<br> Barna Heder (HUN) <br>
      <b>Asistente de producción TV de la FIE</b>:<br> Svetlana Krasnokoutskaya (RUS)<br>
      <b>Encargado de prensa</b>:<br> Serge Timacheff (USA)<br>
      <b>Fotógrafo</b>:<br> Augusto Bizzi (ITA)<br>
      </p>

      <h2>Design</h2>
      <p>
      Touchline </b><br>
      (<a href="http://www.touchline.com" target="blank">www.touchline.com</a>)
      </p>`
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Prólogo",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `<img id="6-title" class="halfScale" style="top:532px;left:283px" src="/106/es/static/_content/6-title.png">
      <img id="6-img" class="halfScale" style="top:204px;left:520px" src="/106/es/static/_content/6-img.jpg">
      <img id="6-next" class="halfScale pointer" style="top:940px;left:1390px" src="/106/es/static/_content/6-next.jpg" onclick="Publish.goToNextPage()">
    
      <img id="6-text-1" class="halfScale" style="top:310px;left:203px" src="/106/es/static/_content/6-text-1.png">
      <img id="6-text-2" class="halfScale" style="top:310px;left:203px; opacity:0;" src="/106/es/static/_content/6-text-2.png">
      <img id="6-cta-1" class="halfScale pointer" style="top:819px;left:784px;" onclick="toggleText6(false);" src="/106/es/static/_content/6-pg1a.png">
      <img id="6-cta-2" class="halfScale pointer" style="top:821px;left:1064px;opacity:0" onclick="toggleText6(true);" src="/106/es/static/_content/6-pg2a.jpg">
      
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
          <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
  
      `,
      "script": `
      function onPageEnter(){
        var fwd = new TimelineMax();
        fwd.fromTo(idOf("6-img"), 0.5,{opacity:0}, {opacity:1},0.5)
           .fromTo(idOf("6-title"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1},"-=0.2")
           .fromTo(idOf("6-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks},"+=0.3")
      }
  
      function toggleText6(bool){
        var text1 = idOf("6-text-1");
        var text2 = idOf("6-text-2");
        
        if(!bool && text1.style.opacity == "0"){
          TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:0}, {opacity:1});
        }else if(bool && text2.style.opacity == "0"){
          TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-cta-1"), 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-cta-2"), 0.5, {opacity:0}, {opacity:1});
          TweenMax.fromTo(idOf("6-img"), 0.5, {opacity:1}, {opacity:0});
          TweenMax.fromTo(idOf("6-title"), 0.5, {opacity:1}, {opacity:0});
        }
      }
      function onPageLeave(){
        if(idOf("6-text-1").style.opacity == "0"){
          toggleText6(false);
        }
        removeContentLinks()
      }
      `,
      "searchText": "PRÓLOGO  A STRONG GLOBAL COMMITMENT  de Grand Prix y Copa del Mundo con muchas competiciones interesantes y prometedores resultados competitivos. El comienzo del panorama competitivo para Tokio 2020 está tomando forma con una variedad de atletas nuevos así como familiares, todos los cuales sueñan con el oro olímpico. Con un conjunto completo de 12 medallas ahora reconocidas por el COI en los Juegos Olímpicos, los atletas y equipos mundiales de esgrima tienen una nueva y revigorizada misión para ser la mejor versión de sí mismos en espada, florete y sable. El Campeonato Mundial Junior y Cadete de Esgrima que tuvo lugar en la histórica y hermosa  Queridos amigos, 2018 se está desarrollando como un año fuerte de esgrima muy entusiasta en todo el mundo, y hemos completado con éxito toda la temporada  PÁGINA 1  PÁGINA 2  W W W.FIE .ORG"
      ,
    "mobileHtml": `
        <h2>UN FUERTE COMPROMISO GLOBAL</h2>
        <img id="fwdimg" src="/106/es/static/_mobile/pg6-fore.jpg">
        <p><b>Queridos amigos,</b></p>
        <p>
        2018 se está desarrollando como un año fuerte de esgrima muy entusiasta en todo el mundo, y hemos completado con éxito toda la temporada de Grandes Premios y Copa del Mundo con muchas competiciones interesantes y prometedores resultados competitivos. El comienzo del panorama competitivo para Tokio 2020 está tomando forma con una variedad de atletas nuevos así como familiares, todos los cuales sueñan con el oro olímpico. Con un conjunto completo de 12 medallas ahora reconocidas por el COI en los Juegos Olímpicos, los atletas y equipos mundiales de esgrima tienen una nueva y revigorizada misión para ser la mejor versión de sí mismos en espada, florete y sable.
        </p>
        <p>
        El Campeonato del Mundo Junior y Cadete de Esgrima que tuvo lugar en la histórica y Hermosa ciudad de Verona, Italia en abril, reunió a varios miles de jóvenes tiradores durante 10 días con 18 competiciones de medalla de oro. El evento contó con magníficas instalaciones, completadas con un museo histórico de equipos de esgrima, salas de atletas y un impresionante estadio para los finales. 
        </p>
        <p>
        Muchos de nuestros atletas mundiales están ahora entrenando duro para el Campeonato del Mundo de Esgrima Senior de este verano, que tendrá lugar en Wuxi, China, en julio. Este será el primer Campeonato del Mundo de Esgrima acogido por China. Con una población de seis millones de personas, Wuxi es una antigua ciudad china con una historia centenaria de prosperidad económica, arte, deporte y cultura.
          </p>
        <p>
        Como familia mundial de esgrima, debemos colaborar y apoyarnos mutuamente en nuestro empeño común de alcanzar el mundo con nuestro deporte. La esgrima tiene muchas cualidades dinámicas, desafiando el cuerpo, la mente y el espíritu, y colectivamente tenemos una oportunidad de oro -y responsabilidad- de compartir sus extraordinarios beneficios.</p>
        <p>
        <p>
        2018 también marca el 105 aniversario de la fundación de la FIE. A medida que avanzamos en este año, únase a nosotros para reconocer este importante hito en la historia, el desarrollo y la evolución de la esgrima. Juntos, tenemos mucho que celebrar.
        </p>
        <b>
        Alisher Usmanov <br>
        Presidente de la FIE</b></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
      <div class="contentLink" style="top:378px;left:480px;width:580px; height:40px;">
       <a href="http://www.absolutefencinggear.com/" target="_blank"></a>
     </div>
      `,
      "script": `
      function onPageEnter() {
        addContentLinks()
      }
  
      function onPageLeave() {
        removeContentLinks()
      }
      `,
      "searchText": ""
      ,
    "mobileHtml": `
    <a href="http://www.absolutefencinggear.com" target="_blank">
      <img id="absolute1img" src="/106/es/static/_mobile/pg7-absolute.png">
    </a>
    `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Verona",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
      <img id="8-title" class="halfScale" style="top:368px;left:83px" src="/106/es/static/_content/8-title.png">
    <img id="8-sub" class="halfScale" style="top:264px;left:124px" src="/106/es/static/_content/8-sub.png">
    <img id="8-line" class="halfScale" style="top:260px;left:86px" src="/106/es/static/_content/all-2line.png">
    <img id="8-next" class="halfScale pointer" style="top:847px;left:1403px" src="/106/es/static/_content/8-next.png" onclick="Publish.goToNextPage()">
    
    `,
    "script": `
    function onPageEnter() {
      page8Anim = new TimelineMax()
      page8Anim
        .fromTo(idOf("8-title"), 0.5,{x:-100, opacity:0}, {x:0, opacity:1},0.5)
        .fromTo(idOf("8-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
        .fromTo(idOf("8-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
        .fromTo(idOf("8-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
    }

    function onPageLeave() {
      page8Anim.stop()
    }
      `,
      "searchText": " "
      ,
    "mobileHtml": `
      <h2>NUEVE DÍAS DE COMPETICIÓN EN VERONA</h2>
      <p><b>
      VERONA, ITALIA  <br>
      9 DE ABRIL DE 2018 <br>
      </b></p>
      <img src="/106/es/static/_mobile/pg8-junior.jpg">
    `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Verona",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
      <img id="9-next" class="halfScale pointer" style="top:847px;left:1408px" src="/106/es/static/_content/9-next.png" onclick="Publish.goToNextPage()">
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="9-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/9-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="9-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/9-fb.png">
      </a>
        `,
      "script": `
      function onPageEnter() {
        page9Anim = new TimelineMax()
        page9Anim
          .fromTo(idOf("9-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
          
      }
  
      function onPageLeave() {
        page9Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA JúNIOR Y CADETE VERONA, ITALIA 2/4 Atletas juveniles de más de 100 países compitieron durante nueve días en Verona, Italia, en el Campeonato del Mundo de Esgrima Júnior y Cadete 2018 en 18 eventos individuales y por equipos. Las tres armas de competición de esgrima: espada, florete y sable, contaron con tres días de eventos para hombres y mujeres de categorías júnior, cadete y por equipos juveniles. Más de 1000 tiradores participaron en la competición, que tuvo lugar en la sede de la Sociedad Deportiva Católica de la ciudad. La FIE, junto con la Federación Italiana de Esgrima en cooperación con el Ayuntamiento de Verona y la Región de Veneto, trabajaron juntas para crear un nuevo estándar en los lugares deportivos, así como una presentación para deleite de los atletas, entrenadores, oficiales e invitados. El Centro Cattolica, una inmensa instalación de 25.000 metros cuadrados llena de comodidades modernas, se transformó en un verdadero pueblo de esgrima, donde el evento de nueve días les ofreció a los tiradores un lugar al que llamar hogar mientras competían para ser los siguientes Campeones del Mundo. « Estos campeonatos fueron perfectos », dijo Emmanuel Katsiadakis, Secretario General de la FIE. « Contamos con una hermosa sala de finales en la última presentación técnica, así como con una gran deportividad, emocionantes competiciones de esgrima y una sensación de una familia y comunidad global para nuestros tiradores. Verona fue, en una palabra, fantástica. "
      ,
    "mobileHtml": `
        <p>
        Atletas juveniles de más de  100 países compitieron durante nueve días en Verona, Italia, en el Campeonato del Mundo de Esgrima Júnior y Cadete 2018 en 18 eventos individuales y por equipos.
        </p>
        <p>
        Las tres armas de competición de esgrima: espada, florete y sable, contaron con tres días de eventos para hombres y mujeres de categorías júnior, cadete y por equipos juveniles. Más de 1000 tiradores participaron en la competición, que tuvo lugar en la sede de la Sociedad Deportiva Católica de la ciudad.
        </p>
        <p>
        La FIE, junto con la Federación Italiana de Esgrima en cooperación con el Ayuntamiento de Verona y la Región de Veneto, trabajaron juntas para crear un nuevo estándar en los lugares deportivos, así como una presentación para deleite de los atletas, entrenadores, oficiales e invitados. El Centro Cattolica, una inmensa instalación de 25.000 metros cuadrados llena de comodidades modernas, se transformó en un verdadero pueblo de esgrima, donde el evento de nueve días les ofreció a los tiradores un lugar al que llamar hogar mientras competían para ser los siguientes Campeones del Mundo.
        </p>
        <p>  
        « Estos campeonatos fueron perfectos », dijo Emmanuel Katsiadakis, Secretario General de la FIE. « Contamos con una hermosa sala de finales en la última presentación técnica, así como con una gran deportividad, emocionantes competiciones de esgrima y una sensación de una familia y comunidad global para nuestros tiradores. Verona fue, en una palabra, fantástica ».
        </p>
        <p>
        Exhibición de esgrima histórica.
        Una de las características más destacadas de la instalación fue una exhibición histórica de los equipos de esgrima, que provenía de la colección personal de Roberto Gotti del Museo de Artes Marciales, un archivo de más de 2.500 tesoros históricos.
        </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Verona",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
      <img id="10-next" class="halfScale pointer" style="top:847px;left:1408px" src="/106/es/static/_content/9-next.png" onclick="Publish.goToNextPage()">
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="10-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/9-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="10-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/9-fb.png">
      </a>
        `,
      "script": `
      function onPageEnter() {
        page10Anim = new TimelineMax()
        page10Anim
          .fromTo(idOf("10-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
          
      }
  
      function onPageLeave() {
        page10Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA Júnior Y CADETE  VERONA, ITALIA 3/4 Exhibición de esgrima histórica Una de las características más destacadas de la instalación fue una exhibición histórica de los equipos de esgrima, que provenía de la colección personal de Roberto Gotti del Museo de Artes Marciales, un archivo de más de 2.500 tesoros históricos. « La exhibición histórica muestra cómo adoptamos un deporte de casi matar y lo convertimos en algo hermoso para que todos lo disfruten, esa es la historia de la esgrima », dijo Franklin Ernir Kristjannson, tirador cadete de Islandia. « Pasó de la guerra al teatro y al deporte, y eso es lo que significa para mí ». Instalaciones de clase mundial El lugar luminoso y alegre, altamente propicio para la práctica de esgrima, incluyó un estadio de finales con asientos en el estadio, iluminación profesional y presentación de vídeo, además de medios y servicios profesionales y electrónicos de vanguardia. Otros servicios de la instalación incluían carpas dedicadas al país/atleta, un auditorio de prensa y conferencias, una sala de oración multirreligiosa, una sala de vendedores de equipos profesionales y una sala de atletas para que equipos y esgrimistas pudieran relajarse y reunirse. "
      ,
    "mobileHtml": `
        <p>
        « La exhibición histórica muestra cómo adoptamos un deporte de casi matar y lo convertimos en algo hermoso para que todos lo disfruten, esa es la historia de la esgrima », dijo Franklin Ernir Kristjannson, tirador cadete de Islandia. « Pasó de la guerra al teatro y al deporte, y eso es lo que significa para mí ».
        </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Verona",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
    <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="10-tw" class="halfScaleC pulse animatedpulse" src="/106/es/static/_content/9-tw.png" alt="" style="top:453px; left: 84px;">
    </a>
    <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="10-fb" class="halfScaleC pulse animatedpulse" src="/106/es/static/_content/9-fb.png" alt="" style="top: 453px; left: 153px;">
    </a>
    <img class="halfScaleC pointer pulse animatedpulse" onclick="showOverlay('pg11-pop')" src="/106/es/static/_content/11-tropy.png" alt="" style="top: 546px; left: 82px;">
    <a href="http://fie.org/es/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=J&calendar_models_CalendarsCompetition%5BWeaponId%5D=&calendar_models_CalendarsCompetition%5BGenderId%5D=&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=CHM&calendar_models_CalendarsCompetition%5BCPYear%5D=2018&calendar_models_CalendarsCompetition%5BFedId%5D=ITA&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=" target="_blank">
      <img class="halfScaleC pulse animatedpulse" src="/106/es/static/_content/11-tropy.png" alt="" style="top: 716px; left: 82px;">
    </a>
    <a href="http://www.fencingverona2018.com/es" target="_blank">
      <img class="halfScaleC pulse animatedpulse" src="/106/es/static/_content/11-i.png" alt="" style="top: 871px; left: 81px;">
    </a>
    
    <img id="11-next" class="pointer halfScaleBR" style="bottom:178px; right:22px;" onclick="Publish.nextPage();" src="/106/es/static/_content/11-next.png">
    <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
      <a href="http://www.fie.org/es" target="_blank"></a>
    </div>

    <div id="pg11-pop" class="standardTransition contentOverlay hidden noclick">
        <img class="" style="top:0px;left:0px" src="/106/es/static/_content/pg11-pop.jpg">
        <img class="halfScale pointer" style="top:30px;left:1370px" onclick="hideOverlay('pg11-pop')" src="/106/es/static/_content/close-white.png">

    </div>

      `,
      "script": `
    function onPageEnter() {
      page11Anim = new TimelineMax()
      page11Anim .fromTo(idOf("11-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        
    }

    function onPageLeave() {
      page11Anim.stop()
      hideOverlay('pg11-pop');
      removeContentLinks()
    }
  `,
      "searchText": "CAMPEONATOS DEL MUNDO DE ESGRIMA Júnior Y CADETE VERONA, ITALIA 4/4 La FIE llevó a cabo un campamento de entrenamiento continuo para tiradores del evento, donde atletas de países con menos recursos practicaron su deporte junto a atletas de élite, entrenadores de alto nivel y con el mejor equipamiento posible a su disposición. Los programas educativos estuvieron disponibles a lo largo de la semana, para ayudar a proporcionar a los atletas más información sobre deportividad, antidopaje, anti acoso y temas para ayudarles a tener éxito no solo en esgrima y en deportes, sino también en la vida. El Consejo Fair Play de la FIE realizó actividades que enfatizan el espíritu deportivo; un programa de la WADA ayudó a los atletas a conocer los problemas de dopaje y un stand de Safe Sport les ofreció información sobre cómo garantizar entornos sin abuso ni acoso. Donaciones de equipos Otro programa activamente implicado en los campeonatos fue el programa de la FIE 'Done su equipo de esgrima', que proporciona a los tiradores un equipo de buena calidad para la FIE, por lo que puede volver a distribuirse a federaciones de esgrima de todo el mundo que  como beneficiarios del programa incluyen a Benín, Ecuador, México, Marruecos, Paraguay, Filipinas, Samoa y Samoa Americana. Todos los países presentaron proyectos creíbles centrados en la esgrima como un poderoso deporte y una actividad que beneficia y empodera a los jóvenes desfavorecidos. Atletas VIP estuvieron presentes para donar equipo y conocer a los tiradores, incluidos el campeón mundial y presidente del Comité Olímpico Húngaro Krisztian Kulcsar; la campeona júnior y cadete Natalia Botello (MEX); el campeón del Gran Premio de Francia Yannick Borel y la campeona del mundo ucraniana Olga Kharlan. En general, se recibieron más de 350 piezas de esgrima durante los campeonatos. En la Ceremonia de Clausura, la bandera oficial de la FIE se pasó a los organizadores del Campeonato Mundial de Esgrima júnior y Cadete del próximo año, que se celebrará en abril de 2019 en Torun, Polonia."
      ,
    "mobileHtml": `
        <p>
        Instalaciones de clase mundial 
        El lugar luminoso y alegre, altamente propicio para la práctica de esgrima, incluyó un estadio de finales con asientos en el estadio, iluminación profesional y presentación de vídeo, además de medios y servicios profesionales y electrónicos de vanguardia. Otros servicios de la instalación incluían carpas dedicadas al país/atleta, un auditorio de prensa y conferencias, una sala de oración multirreligiosa, una sala de vendedores de equipos profesionales y una sala de atletas para que equipos y esgrimistas pudieran relajarse y reunirse.
        </p>
        <p>
        La FIE llevó a cabo un campamento de entrenamiento continuo para tiradores del evento, donde atletas de países con menos recursos practicaron su deporte junto a atletas de élite, entrenadores de alto nivel y con el mejor equipamiento posible a su disposición. Los programas educativos estuvieron disponibles a lo largo de la semana, para ayudar a proporcionar a los atletas más información sobre deportividad, antidopaje, anti acoso y temas para ayudarles a tener éxito no solo en esgrima y en deportes, sino también en la vida. El Consejo Fair Play de la FIE realizó actividades que enfatizan el espíritu deportivo; un programa de la WADA ayudó a los atletas a conocer los problemas de dopaje y un stand de Safe Sport les ofreció información sobre cómo garantizar entornos sin abuso ni acoso.
        </p>
        <p>         
        Donaciones de equipos
        Otro programa activamente implicado en los campeonatos fue el programa de la FIE 'Done su equipo de esgrima', que proporciona a los tiradores un equipo de buena calidad para la FIE, por lo que puede volver a distribuirse a federaciones de esgrima de todo el mundo que  como beneficiarios del programa incluyen a Benín, Ecuador, México, Marruecos, Paraguay, Filipinas, Samoa y Samoa Americana. Todos los países presentaron proyectos creíbles centrados en la esgrima como un poderoso deporte y una actividad que beneficia y empodera a los jóvenes desfavorecidos. Atletas VIP estuvieron presentes para donar equipo y conocer a los tiradores, incluidos el campeón mundial y presidente del Comité Olímpico Húngaro Krisztian Kulcsar; la campeona júnior y cadete Natalia Botello (MEX); el campeón del Gran Premio de Francia Yannick Borel y la campeona del mundo ucraniana Olga Kharlan. En general, se recibieron más de 350 piezas de esgrima durante los campeonatos.
        </p>
        <p>En la Ceremonia de Clausura, la bandera oficial de la FIE se pasó a los organizadores del Campeonato Mundial de Esgrima júnior y Cadete del próximo año, que se celebrará en abril de 2019 en Torun, Polonia.
        </p>
        <p><a href="http://fie.org/es/results-statistic" target="_blank">Pulse aquí para ver los MEDALLISTAS DE ORO</a></p>
        <p><a href="http://www.fencingverona2018.com/" target="_blank">Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA INDIVIDUAL</a></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Anaheim",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
      <img id="12-next" class="halfScale pointer" style="top:847px;left:1411px" src="/106/es/static/_content/12-next.png" onclick="Publish.goToNextPage()">
      <img id="12-title" class="halfScale" style="top:111px;left:507px" src="/106/es/static/_content/12-title.png">
      <img id="12-sub" class="halfScale" style="top:244px;left:1024px" src="/106/es/static/_content/12-sub.png">
      <img id="12-line" class="halfScale" style="top:238px;left:980px" src="/106/es/static/_content/all-4line.png">
    `,
    "script": `
    function onPageEnter() {
        page12Anim = new TimelineMax()
        page12Anim
          .fromTo(idOf("12-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("12-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("12-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("12-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
      }

      function onPageLeave() {
        page12Anim.stop()
      }
      `,
      "searchText": "GRAN PREMIO  IMBODEN DE EE.UU. Y DERIGLAZOVA DE RUSIA EE.UU. VICTORIOSOS ANAHEIM, 16 AL 18 DE MARZO DE 2018 FLORETE MASCULINO Y FEMENINO"
      ,
    "mobileHtml": `
      <h2>IMBODEN DE EE.UU. Y DERIGLAZOVA DE RUSIA VICTORIOSOS</h2>
      <p><b>
      ANAHEIM, EE.UU. <br>
      16 AL 18 DE MARZO DE 2018 <br>       
      FLORETE MASCULINO Y FEMENINO
      </b></p>
      <img src="/106/es/static/_mobile/pg12-anaheim.jpg">
    `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Anaheim",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
      <img id="13-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/13-next.png" onclick="Publish.goToNextPage()">
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="13-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:85px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="13-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>
      `,
      "script": `
        function onPageEnter() {
        page13Anim = new TimelineMax()
        page13Anim
          .fromTo(idOf("13-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }
  
      function onPageLeave() {
        page13Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "GRAN PREMIO ANAHEIM, EE.UU. 2/3  Race Imboden de EE.UU. ganó su primer Grand Prix en el Absolute Fencing Gear® Grand Prix Masculino y Femenino de florete en Anaheim 2018, California. La esgrimista más importante de Rusia, medallista de oro olímpica y dos veces campeona mundial Inna Deriglazova se llevó el oro en el evento femenino. Más de 300 esgrimistas de florete participaron en el Grand Prix, que tuvo lugar en el Centro de Convenciones de Anaheim. En la competencia femenina, Deriglazova, de 28 años, derrotó a la alemana Anne Sauer por 15-3, por la medalla de oro. Para la alemana, ha sido el mejor resultado de su carrera hasta la fecha. Sauer superó a su compañera de equipo, Leonie Ebert, en la semifinal, en un match cerrado con un marcador final de 15-14. También en la semifinal, Deriglazova venció a la estadounidense Lee Kiefer en otro final cerrado, por 15-14. Kiefer ganó esta misma prueba el año pasado, cuando derrotó a Deriglazova en la misma ronda. «Lo más difícil hoy fue luchar contra las rusas, mis compañeras de equipo», dijo Deriglazova.  «Para entrar entre las 16, tuve que pelear no solo con mi compañera de equipo, sino también con mi mejor amiga». En el evento masculino, Imboden, de 24 años, ganó en la final al italiano Campeón del Mundo, Andrea Cassara, por 15-10. El día contó con varias derrotas en la parte alta de la clasificación, incluyendo al número 31 de la clasificación Nicholas Edward Choi, de Hong Kong, superando al segundo clasificado y medallista de plata olímpico Alexander Massialas (EE.UU.) en la ronda de 32, por 15-13, así como al medallista olímpico de plata de Egipto Alaaeldin Abouelkassem en los octavos de final, por 15-14, y al seis veces ganador del Grand Prix de Francia Erwann Le Pechoux en la ronda de 8, por 15-4. Choi quedó fuera en la"
      ,
    "mobileHtml": `
      <p>  
      Race Imboden de EE.UU. ganó su primer Grand Prix en el Absolute Fencing Gear® Grand Prix Masculino y Femenino de florete en Anaheim 2018, California.
      </p>
      <p>
      La esgrimista más importante de Rusia, medallista de oro olímpica y dos veces campeona mundial Inna Deriglazova se llevó el oro en el evento femenino. Más de 300 esgrimistas de florete participaron en el Gran Premio, que tuvo lugar en el Centro de Convenciones de Anaheim.
      </p>
      <p>
      En la competencia femenina, Deriglazova, de 28 años, derrotó a la alemana Anne Sauer por 15-3, por la medalla de oro. Para la alemana, ha sido el mejor resultado de su carrera hasta la fecha. Sauer superó a su compañera de equipo, Leonie Ebert, en la semifinal, en un match cerrado con un marcador final de 15-14. También en la semifinal, Deriglazova venció a la estadounidense Lee Kiefer en otro final cerrado, por 15-14. Kiefer ganó esta misma prueba el año pasado, cuando derrotó a Deriglazova en la misma ronda.
      </p>
      <p>
      «Lo más difícil hoy fue luchar contra las rusas,  mis compañeras de equipo», dijo Deriglazova. «Para entrar entre las 16, tuve que pelear no solo con mi compañera de equipo, sino también con mi mejor amiga».
      </p>
      <p>
      En el evento masculino, Imboden, de 24 años, ganó en la final al italiano Campeón del Mundo, Andrea Cassara, por 15-10. El día contó con varias derrotas en la parte alta de la clasificación, incluyendo al número 31 de la clasificación Nicholas Edward Choi, de Hong Kong, superando al segundo clasificado y medallista de plata olímpico Alexander Massialas (EE.UU.) en la ronda de 32, por 15-13, así como al medallista olímpico de plata de Egipto Alaaeldin Abouelkassem en los octavos de final, por 15-14, y al seis veces ganador del Grand Prix de Francia Erwann Le Pechoux en la ronda de 8, por 15-4. Choi quedó fuera en la semifinal contra Cassara, 15-9. En la misma ronda, Imboden venció al italiano Damiano Rosatelli,  por 15-10; Imboden también eliminó al medallista olímpico de bronce de Rusia, Timur Safin, por 15-8, en la ronda de 8. El número 57 de la clasificación Rosatelli tuvo también un día fuerte, al derrotar al medallista de oro olímpico mejor clasificado y compañero de equipo Daniele Garozzo en la ronda de 16, por 15-11, y al Campeón del Mundo Alexey Cheremisinov (RUS) en la ronda de ocho, por 15-11.
      </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Anaheim",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `<img id="14-next" class="halfScale pointer" style="top:847px;left:1390px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">

      <a href="http://fie.org/es/competitions/2018/140/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:729px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <a href="http://fie.org/es/competitions/2018/121/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:914px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>

      <div class="addContentLink pointer" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
        function onPageEnter() {
          page14Anim = new TimelineMax()
          page14Anim
            .fromTo(idOf("14-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function onPageLeave() {
          page14Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": "GRAN PREMIO ANAHEIM, EE.UU. 3/3  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  semifinal contra Cassara, 15-9. En la misma ronda, Imboden venció al italiano Damiano Rosatelli, por 15-10; Imboden también eliminó al medallista olímpico de bronce de Rusia, Timur Safin, por 158, en la ronda de 8. El número 57 de la clasificación Rosatelli tuvo también un día fuerte, al derrotar al medallista de oro olímpico mejor clasificado y compañero de equipo Daniele Garozzo en la ronda de 16, por 15-11, y al Campeón del Mundo Alexey Cheremisinov (RUS) en la ronda de ocho, por 15-11. «Me sentí bien durante todo el día y, desafortunadamente, tuve que encontrarme temprano con mi compañero de equipo», dijo Imboden. «Hubo muchos competidores  realmente buenos aquí y estoy muy contento de haber ganado en casa». Las ocho mejores en el evento de florete femenino incluyeron a Inna Deriglazova (RUS, oro), Anne Sauer (GER, plata), Leonie Ebert (GER, bronce), Lee Kiefer (EE.UU., bronce), Camilla Mancini (ITA), Eleanor Harvey (CAN), Julia Walczyk (POL) y Diana Yakoleva (RUS). Entre los ocho mejores se incluyeron Race Imboden (EE. UU., oro), Andrea Cassara (ITA, plata), Nicholas Edward Choi (HKG, bronce), Damiano Rosatelli (ITA, bronce), Timur Safin (RUS), Erwann Le Pechoux (FRA), Ka Long Cheung (HKG) y Alexey Cheremisinov (RUS). ■ W W W.FIE .ORG"
      ,
      "mobileHtml": `
      <p>  
      «Me sentí bien durante todo el día y, desafortunadamente, tuve que encontrarme temprano con mi compañero de equipo», dijo Imboden. «Hubo muchos competidores realmente buenos aquí y estoy muy contento de haber ganado en casa».
      </p>
      <p>
      Las ocho mejores en el evento de florete femenino incluyeron a Inna Deriglazova (RUS, oro), Anne Sauer (GER, plata), Leonie Ebert (GER, bronce), Lee Kiefer (EE.UU., bronce), Camilla Mancini (ITA), Eleanor Harvey (CAN), Julia Walczyk (POL) y Diana Yakoleva (RUS).
      </p>
      <p>
      Entre los ocho mejores se incluyeron Race Imboden (EE. UU., oro), Andrea Cassara (ITA, plata), Nicholas Edward Choi (HKG, bronce), Damiano Rosatelli (ITA, bronce), Timur Safin (RUS), Erwann Le Pechoux (FRA), Ka Long Cheung (HKG) y Alexey Cheremisinov (RUS).
      </p>
      <p><a href="http://fie.org/es/competitions/2018/140/results/rank" target="_blank">Pulse aquí para ver los RESULTADOS DE LA COMPERENCIA MASCULINA</a></p>
      <p><a href="http://fie.org/es/competitions/2018/121/results/rank" target="_blank">Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA</a></p>
        `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Budapest",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
      <img id="15-next" class="halfScale pointer" style="top:847px;left:1412px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <img id="15-title" class="halfScale" style="top:132px;left:84px" src="/106/es/static/_content/15-title.png">
      <img id="15-sub" class="halfScale" style="top:130px;left:883px" src="/106/es/static/_content/15-sub.png">
      <img id="15-line" class="halfScale" style="top:128px;left:840px" src="/106/es/static/_content/all-4line.png">
      `,
      "script": `
        function onPageEnter() {
          page15Anim = new TimelineMax()
          page15Anim
            .fromTo(idOf("15-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
            .fromTo(idOf("15-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
            .fromTo(idOf("15-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
            .fromTo(idOf("15-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
            
        }

        function onPageLeave() {
          page15Anim.stop()
        }
      `,
      "searchText": "GRAN PREMIO  EL SUIZO HEINZER Y LA ITALIANA NAVARRIA SE LLEVAN EL ORO  BUDAPEST, HUNGRÍA 23 AL 25 DE MARZO DE 2018 ESPADA MASCULINO Y FEMENINO"
      ,
      "mobileHtml": `
        <h2>EL SUIZO HEINZER Y LA ITALIANA NAVARRIA SE LLEVAN EL ORO</h2>
        <p><b>
        BUDAPEST, HUNGRÍA <br>
        23 AL 25 DE MARZO DE 2018 <br>       
        ESPADA MASCULINO Y FEMENINO
        </b></p>
        <img src="/106/es/static/_mobile/pg15-buda.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Budapest",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
      <img id="16-next" class="halfScale pointer" style="top:847px;left:1390px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>
      <a href="http://fie.org/es/results-statistic/result?calendar_models_CalendarsCompetition%5BFencCatId%5D=S&calendar_models_CalendarsCompetition%5BWeaponId%5D=E&calendar_models_CalendarsCompetition%5BGenderId%5D=&calendar_models_CalendarsCompetition%5BCompTypeId%5D=&calendar_models_CalendarsCompetition%5BCompCatId%5D=&calendar_models_CalendarsCompetition%5BCPYear%5D=2018&calendar_models_CalendarsCompetition%5BFedId%5D=HUN&calendar_models_CalendarsCompetition%5BDateBegin%5D=&calendar_models_CalendarsCompetition%5BDateEnd%5D=" target="_blank">
        <img class="halfScaleC pulse animatedpulse" style="top:884px;left:85px" src="/106/es/static/_content/14-trophy.png">
      </a>
      
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>

      `,
      "script": `
      function onPageEnter() {
        page16Anim = new TimelineMax()
        page16Anim
          .fromTo(idOf("16-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page16Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "GRAN PREMIO BUDAPEST, HUNGRÍA 2/2  El tirador suizo Max Heinzer ganó su cuarto Gran Premio Internacional de Esgrima en el Gran Premio de espada Westend en Budapest, Hungría, que se suma a sus seis victorias en Copas del Mundo. La italiana Mara Navarria también obtuvo el oro en la prueba femenina, su segunda victoria en el Gran Premio después de ganar la medalla de plata en el Gran Premio de Doha de esta temporada. Más de 500 hombres y mujeres tiradores de espada internacionales participaron en la prueba, que tuvo lugar en el MOM Sports Center de Budapest.  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA  En la prueba masculina, Heinzer derrotó al francés Alex Fava, que consiguió su mejor resultado hasta la fecha, con un marcador final de 15-13. Fava derrotó al segundo clasificado, el ucraniano Bogdan Nikishin, en cuartos de final, 15-10, antes de ganar un match muy reñido con su compañero de equipo, Jonathan Bonnaire, en la semifinal, 15-14. Heinzer derrotó al dos veces campeón del mundo, el estonio Nikolai Novosjolov, en cuartos de final, 15-12, antes de pasar a las semifinales y superar al ruso Sergey Khodos, 15-10.  Varias atletas obtuvieron resultados muy por encima de sus clasificaciones en la prueba femenina. Navarria se llevó el oro en la final femenina ante la china Sheng Lin, 5-4. Lin, clasificada en el puesto 257° antes de entrar en la competición, dejó fuera a la séptima clasificada, la polaca Ewa Nelip, en la semifinal, 15-8. Navarria venció a la clasificada 103º, la francesa MarieFlorencia Candassamy, en la otra semifinal, 14-13. Los ocho mejores en la prueba masculina de espada incluyen a Max Heinzer (SUI, oro), Alex Fava (FRA, plata), Jonathan Bonnaire (FRA, bronce), Sergey Khodos (RUS, bronce), Bogdan Nikishin (UKR), Nikolai Novosjolov (EST), Marco Brinkmann (GER) y Koki Kano (JPN). Las ocho mejores en espada femenina incluyen a Mara Navarria (ITA, oro), Sheng Lin (CHN, plata), Marie-Florence Candassamy (FRA, bronce), Ewa Nelip (POL, bronce), Injeong Choi (KOR), Giulia Rizzi (ITA), Erika Kirpu (EST) y Ana Maria Popescu (ROU). ■  W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <p>
        El tirador suizo Max Heinzer ganó su cuarto Gran Premio Internacional de Esgrima en el Gran Premio de espada Westend en Budapest, Hungría, que se suma a sus seis victorias en Copas del Mundo.
        </p>
        <p>
        La italiana Mara Navarria también obtuvo el oro en la prueba femenina, su segunda victoria en el Gran Premio después de ganar la medalla de plata en el Gran Premio de Doha de esta temporada. Más de 500 hombres y mujeres tiradores de espada internacionales participaron en la prueba, que tuvo lugar en el MOM Sports Center de Budapest.
        </p>
        <p>
        En la prueba masculina, Heinzer derrotó al francés Alex Fava, que consiguió su mejor resultado hasta la fecha, con un marcador final de 15-13. Fava derrotó al segundo clasificado, el ucraniano Bogdan Nikishin, en cuartos de final, 15-10, antes de ganar un match muy reñido con su compañero de equipo, Jonathan Bonnaire, en la semifinal, 15-14. Heinzer derrotó al dos veces campeón del mundo, el estonio Nikolai Novosjolov, en cuartos de final, 15-12, antes de pasar a las semifinales y superar al ruso Sergey Khodos, 15-10.
        </p>
        <p>
        Varias atletas obtuvieron resultados muy por encima de sus clasificaciones en la prueba femenina. Navarria se llevó el oro en la final femenina ante la china Sheng Lin, 5-4. Lin, clasificada en el puesto 257° antes de entrar en la competición, dejó fuera a la séptima clasificada, la polaca Ewa Nelip, en la semifinal, 15-8. Navarria venció a la clasificada 103º, la francesa Marie-Florencia Candassamy, en la otra semifinal, 14-13.
        </p>
        <p>
        Los ocho mejores en la prueba masculina de espada incluyen a Max Heinzer (SUI, oro), Alex Fava (FRA, plata), Jonathan Bonnaire (FRA, bronce), Sergey Khodos (RUS, bronce), Bogdan Nikishin (UKR), Nikolai Novosjolov (EST), Marco Brinkmann (GER) y Koki Kano (JPN).
        </p>
        <p>
        Las ocho mejores en espada femenina incluyen a Mara Navarria (ITA, oro), Sheng Lin (CHN, plata), Marie-Florence Candassamy (FRA, bronce), Ewa Nelip (POL, bronce), Injeong Choi (KOR), Giulia Rizzi (ITA), Erika Kirpu (EST) y Ana Maria Popescu (ROU).
        </p>
        <p><a href="http://fie.org/es/competitions/2018/112/results/rank" target="_blank">Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA</a></p>
        
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Seúl",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
      <img id="17-next" class="halfScale pointer" style="top:847px;left:1412px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <img id="17-title" class="halfScale" style="top:92px;left:104px" src="/106/es/static/_content/17-title.png">
      <img id="17-sub" class="halfScale" style="top:308px;left:152px" src="/106/es/static/_content/17-sub.png">
      <img id="17-line" class="halfScale" style="top:308px;left:110px" src="/106/es/static/_content/all-3line.png">
      `,
      "script": `
      function onPageEnter() {
        page17Anim = new TimelineMax()
        page17Anim
          .fromTo(idOf("17-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("17-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("17-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("17-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page17Anim.stop()
      }
      `,
      "searchText": "GRAN PREMIO  SZILAGYI DE HUNGRÍA Y KHARLAN DE UCRANIA GANAN EL GRAN PREMIO DE SABLE SK TELECOM DE SEÚL SEÚL, COREA 30 DE MARZO AL 1 DE ABRIL DE 2018 SABLE MASCULINO Y FEMENINO"
      ,
      "mobileHtml": `
        <h2>SZILAGYI DE HUNGRÍA Y KHARLAN DE UCRANIA GANAN EL GRAN PREMIO DE SABLE SK TELECOM DE SEÚL
        </h2>
        <p><b>
        SEÚL, COREA <br>
        30 DE MARZO AL 1 DE ABRIL DE 2018 <br>       
        SABLE MASCULINO Y FEMENINO
        </b></p>
        <img src="/106/es/static/_mobile/pg17-seoul.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Seúl",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
      <img id="18-next" class="halfScale pointer" style="top:847px;left:1379px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="18-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="18-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>

      <a href="http://fie.org/es/competitions/2018/165/results/rank" target="_blank">
        <img class="halfScaleC pulse animatedpulse" style="top:728px;left:91px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <a href="http://fie.org/es/competitions/2018/468/results/rank" target="_blank">
        <img class="halfScaleC pulse animatedpulse" style="top:915px;left:91px" src="/106/es/static/_content/14-trophy.png">
      </a>

      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>

      `,
      "script": `
      function onPageEnter() {
        page18Anim = new TimelineMax()
        page18Anim
          .fromTo(idOf("18-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page18Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "GRAN PREMIO SEÚL, COREA 2/2  El dos veces medallista de oro olímpico Aron Szilagyi de Hungría y la tres veces campeona del mundo Olga Kharlan de Ucrania se llevaron sus nuevas medallas de oro en Seúl, Corea, en el Gran Premio de Sable SK Telecom. Cerca de 300 esgrimistas participaron en la competición internacional, que se llevó a cabo en el mismo lugar que los Juegos Olímpicos de Verano de Seúl de 1988, el sexto Gran Premio de una serie de nueve eventos en la Federación Internacional de Esgrima (FIE), temporada 2017-2018.  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  Szilagyi se enfrentó al favorito local Junghwan Kim (KOR) en la final, derrotándolo por 15-7. El mejor clasificado, Bongil Gu, también de Corea, tuvo un revés en la ronda 32, derrotado por 1513, por el italiano Stefano Scepi, número 63 de la clasificación. En las semifinales, Kim venció al estadounidense Eli Dershwitz, tercero de la clasificación, por 15-13, mientras que Szilagyi superó al ruso Kamil Ibragimov, por 15-8. En la prueba femenina, Kharlan, clasificada número uno, ganó frente a la húngara Anna Marton, por 15-7, en la final. En las semifinales,  Marton venció a la alemana Anna Limbach, por 15-8, mientras que Kharlan derrotó por poco a la cuarta clasificada de Rumanía Bianca Pascu, por 15-14. En la ronda ocho, Marton también venció a la dos veces medallista de oro de EE.UU. Mariel Zagunis, por 15-6, quien regresó a la competición después de un descanso prolongado para tener su primer hijo. Los ocho mejores en la prueba de sable masculino incluyeron a Aron Szilagyi (HUN, oro), Junghwan Kim (KOR, plata), Eli Dershwitz (EE. UU., Bronce), Kamil Ibragimov (RUS, bronce), Luca Curatoli (ITA), Bolade Apithy (FRA), Luigi Samele (ITA) y Aldo Montano (ITA). Las ocho mejores en el evento de sable femenino incluyeron a Olga Kharlan (UKR, oro), Anna Marton (HUN, plata), Anna Limbach (GER, bronce), Bianca Pascu (ROU, bronce), Rossella Gregorio (ITA), Sooyeon Choi (KOR), Yaqi Shao (CHN) y Mariel Zagunis (EE. UU.). ■ W W W.FIE .ORG"
      ,
      "mobileHtml": `
        <p>
        El dos veces medallista de oro olímpico Aron Szilagyi de Hungría y la tres veces campeona del mundo Olga Kharlan de Ucrania se llevaron sus nuevas medallas de oro en Seúl, Corea, en el Gran Premio de Sable SK Telecom.
        </p>
        <p>
        Cerca de 300 esgrimistas participaron en la competición internacional, que se llevó a cabo en el mismo lugar que los Juegos Olímpicos de Verano de Seúl de 1988, el sexto Gran Premio de una serie de nueve eventos en la Federación Internacional de Esgrima (FIE), temporada 2017-2018.
        </p>
        <p>
        Szilagyi se enfrentó al favorito local Junghwan Kim (KOR) en la final, derrotándolo por 15-7. El mejor clasificado, Bongil Gu, también de Corea, tuvo un revés en la ronda 32, derrotado por 15-13, por el italiano Stefano Scepi, número 63 de la clasificación. En las semifinales, Kim venció al estadounidense Eli Dershwitz, tercero de la clasificación, por 15-13, mientras que Szilagyi superó al ruso Kamil Ibragimov, por 15-8.
        </p>
        <p>
        En la prueba femenina, Kharlan, clasificada número uno, ganó frente a la húngara Anna Marton, por 15-7, en la final. En las semifinales, Marton venció a la alemana Anna Limbach, por 15-8, mientras que Kharlan derrotó por poco a la cuarta clasificada de Rumanía Bianca Pascu, por 15-14. En la ronda ocho, Marton también venció a la dos veces medallista de oro de EE.UU. Mariel Zagunis, por 15-6, quien regresó a la competición después de un descanso prolongado para tener su primer hijo.
        </p>
        <p>
        Los ocho mejores en la prueba de sable masculino incluyeron a Aron Szilagyi (HUN, oro), Junghwan Kim (KOR, plata), Eli Dershwitz (EE. UU., Bronce), Kamil Ibragimov (RUS, bronce), Luca Curatoli (ITA), Bolade Apithy (FRA), Luigi Samele (ITA) y Aldo Montano (ITA).
        </p>
        <p>
        Las ocho mejores en el evento de sable femenino incluyeron a Olga Kharlan (UKR, oro), Anna Marton (HUN, plata), Anna Limbach (GER, bronce), Bianca Pascu (ROU, bronce), Rossella Gregorio (ITA), Sooyeon Choi (KOR), Yaqi Shao (CHN) y Mariel Zagunis (EE. UU.).
        </p>
        <p><a href="http://fie.org/es/competitions/2018/165/results/rank" target="_blank">Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA</a></p>
        <p><a href="http://fie.org/es/competitions/2018/468/results/rank" target="_blank">Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA</a></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.png",
      "zoom": null,
      "content": `
      <div class="addContentLink" style="bottom:52px;left:90px;width:244px; height:20px;">
      <a href="mailto:info@fencewithfun.com" ></a>
    </div>
    <div class="addContentLink" style="bottom:52px;left:422px;width:237px; height:20px;">
      <a href="http://www.fencewithfun.com" target="_blank"></a>
    </div>
    <div class="addContentLink" style="bottom:296px;left:24px;width:687px; height:70px;">
      <a href="http://www.fencewithfun.com" target="_blank"></a>
    </div>
    `,
    "script": `
    function onPageEnter() {
      addContentLinks()
    }

    function onPageLeave() {
      removeContentLinks()
    }
      `,
      "searchText": ""
      ,
      "mobileHtml": `
      <a href="https://www.fencewithfun.com" target="_blank">
        <img id="fence1img" src="/106/es/static/_mobile/pg19-fencewithfun.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `<div class="addContentLink" style="bottom:101px;right:1186px;width:185px; height:20px;">
      <a href="http://www.uhlmann-fechtsport.com" target="_blank"></a>
    </div>
    <div class="addContentLink" style="bottom:101px;right:826px;width:295px; height:20px;">
      <a href="https://en-gb.facebook.com/UhlmannFechtsport/" target="_blank"></a>
    </div>
    <div class="addContentLink" style="bottom:101px;right:483px;width:285px; height:20px;">
      <a href="https://www.instagram.com/uhlmann.fencing/?hl=en" target="_blank"></a>
    </div>
    `,
    "script": `
    function onPageEnter() {
      addContentLinks()
    }

    function onPageLeave() {
      removeContentLinks()
    }
      `,
      "searchText": ""
      ,
      "mobileHtml": `
      <a href="https://uhlmann-fechtsport.com" target="_blank">
        <img id="uhlmann1img" src="/106/es/static/_mobile/pg20-uhlmann.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Moscú",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
      <img id="21-next" class="halfScale pointer" style="top:847px;left:1411px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <img id="21-title" class="halfScale" style="top:115px;left:85px" src="/106/es/static/_content/21-title.png">
      <img id="21-sub" class="halfScale" style="top:314px;left:131px" src="/106/es/static/_content/21-sub.png">
      <img id="21-line" class="halfScale" style="top:316px;left:87px" src="/106/es/static/_content/all-3line.png">
    `,
    "script": `
    function onPageEnter() {
      page21Anim = new TimelineMax()
      page21Anim
        .fromTo(idOf("21-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
        .fromTo(idOf("21-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
        .fromTo(idOf("21-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
        .fromTo(idOf("21-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
        
    }

    function onPageLeave() {
      page21Anim.stop()
    }
      `,
      "searchText": "GRAN PREMIO  LA COREANA OH Y LA RUSA VELIKAYA SE LLEVAN EL ORO MOSCÚ, RUSIA 11 AL 13 DE MAYO DE 2018 SABLE MASCULINO Y FEMENINO"
      ,
      "mobileHtml": `
        <h2>LA COREANA OH Y LA RUSA VELIKAYA SE LLEVAN EL ORO</h2>
        <p><b>
        MOSCÚ, RUSIA <br>
        11 AL 13 DE MAYO DE 2018 <br>       
        SABLE MASCULINO Y FEMENINO
        </b></p>
        <img src="/106/es/static/_mobile/pg21-moscow.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Moscú",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
      <img id="22-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="22-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="22-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>

      <a href="http://fie.org/es/competitions/2018/162/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:729px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <a href="http://fie.org/es/competitions/2018/676/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:914px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page22Anim = new TimelineMax()
        page22Anim
          .fromTo(idOf("22-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page22Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "GRAN PREMIO MOSCÚ, RUSIA 2/2  El coreano Sanguk Oh y la dos veces campeona mundial rusa, Sofya Velikaya, se llevaron el oro en Rusia en el Gran premio de sable de Moscú. La prueba tuvo lugar en el «Palacio de Hielo» de Moscú, y contó con la participación de más de 300 de los mejores tiradores de sable del mundo, de categorías masculina y femenina, en este séptimo Gran premio, de un total de nueve pruebas de la temporada de competición 20172018 de la FIE.  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  Oh, quien ganó el Gran premio de sable de Cancún en diciembre 2017, derrotó al italiano Luca Curatoli en el último partido masculino, 15-8. El coreano Bongil Gu perdió en la semifinal contra Curatoli, 15-11; Curatoli venció a Gu en esta misma prueba el año pasado en la ronda final, llevándose la medalla de oro. En la otra semifinal, Oh superó a Mojtaba Abedini de Irán, 15-9. En particular, el iraní derrotó al dos veces medallista de oro olímpico húngaro, Aron Szilagyi, en la ronda de 16, 15-13. En la prueba femenina, la bicampeona mundial rusa Sofya Velikaya se llevó el oro contra la húngara Anna Marton, 15-12, en la ronda final. La victoria de Velikaya marca un regreso  impresionante después de un descanso de dos años de la competición. Marton derrotó a la dos veces medallista olímpica de oro y dos veces campeona mundial Mariel Zagunis en la ronda de semifinales, 15-12, mientras que en la otra semifinal, Velikaya venció al medallista de oro olímpico coreano Jiyeon Kim, 15-5. Los ocho mejores en la prueba de sable masculino incluyeron Sanguk Oh (KOR, oro), Luca Curatoli (ITA, plata), Mojtaba Abedini (IRI, bronce), Bongil Gu (KOR, bronce), Eli Dershwitz (EE. UU.), Vincent Anstett (FRA), Daryl Homer (EE. UU.) y Hansol Ha (KOR). El top 8 en la prueba de sable femenino incluye a Sofya Velikaya (RUS, oro), Anna Marton (HUN, plata), Jiyeon Kim (KOR, bronce), Mariel Zagunis (EE. UU., Bronce), Cecilia Berder (FRA), Liza Pusztai (HUN), Risa Takashima (JPN) y Lucia Martin-Portugues (ESP). ■ W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <p>
        El coreano Sanguk Oh y la dos veces campeona mundial rusa, Sofya Velikaya, se llevaron el oro en Rusia en el Gran premio de sable de Moscú.
        </p>
        <p>       
        La prueba tuvo lugar en el «Palacio de Hielo» de Moscú, y contó con la participación de más de 300 de los mejores tiradores de sable del mundo, de categorías masculina y femenina, en este séptimo Gran premio, de un total de nueve pruebas de la temporada de competición 2017-2018 de la FIE.
        </p>
        <p>        
        Oh, quien ganó el Gran premio de sable de Cancún en diciembre 2017, derrotó al italiano Luca Curatoli en el último partido masculino, 15-8. El coreano Bongil Gu perdió en la semifinal contra Curatoli, 15-11; Curatoli venció a Gu en esta misma prueba el año pasado en la ronda final, llevándose la medalla de oro. En la otra semifinal, Oh superó a Mojtaba Abedini de Irán, 15-9. En particular, el iraní derrotó al dos veces medallista de oro olímpico húngaro, Aron Szilagyi, en la ronda de 16, 15-13.
        </p>
        <p>         
        En la prueba femenina, la bicampeona mundial rusa Sofya Velikaya se llevó el oro contra la húngara Anna Marton, 15-12, en la ronda final. La victoria de Velikaya marca un regreso impresionante después de un descanso de dos años de la competición. Marton derrotó a la dos veces medallista olímpica de oro y dos veces campeona mundial Mariel Zagunis en la ronda de semifinales, 15-12, mientras que en la otra semifinal, Velikaya venció al medallista de oro olímpico coreano Jiyeon Kim, 15-5.
        </p>
        <p>         
        Los ocho mejores en la prueba de sable masculino incluyeron Sanguk Oh (KOR, oro), Luca Curatoli (ITA, plata), Mojtaba Abedini (IRI, bronce), Bongil Gu (KOR, bronce), Eli Dershwitz (EE. UU.), Vincent Anstett (FRA), Daryl Homer (EE. UU.) y Hansol Ha (KOR).
        </p>
        <p>          
        El top 8 en la prueba de sable femenino incluye a Sofya Velikaya (RUS, oro), Anna Marton (HUN, plata), Jiyeon Kim (KOR, bronce), Mariel Zagunis (EE. UU., Bronce), Cecilia Berder (FRA), Liza Pusztai (HUN), Risa Takashima (JPN) y Lucia Martin-Portugues (ESP).
        </p>
        <p><a href="http://fie.org/es/competitions/2018/162/results/rank" target="_blank">Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA</a></p>
        <p><a href="http://fie.org/es/competitions/2018/676/results/rank" target="_blank">Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA</a></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Shanghái",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `<img id="23-next" class="halfScale pointer" style="top:847px;left:1411px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <img id="23-title" class="halfScale" style="top:156px;left:745px" src="/106/es/static/_content/23-title.png">
      <img id="23-sub" class="halfScale" style="top:428px;left:1072px" src="/106/es/static/_content/23-sub.png">
      <img id="23-line" class="halfScale" style="top:428px;left:1029px" src="/106/es/static/_content/all-4line.png">
      `,
      "script": `
      function onPageEnter() {
        page23Anim = new TimelineMax()
        page23Anim
          .fromTo(idOf("23-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("23-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("23-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("23-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page23Anim.stop()
      }
      `,
      "searchText": "COPA DEL MUNDO  KRUSE DE GRAN BRETAÑA Y DERIGLAZOVA DE RUSIA GANAN EL ORO SHANGHÁI, CHINA 18-20 DE MAYO DE 2018 ESGRIMA MASCULINO Y FEMENINO"
      ,
      "mobileHtml": `
        <h2>KRUSE DE GRAN BRETAÑA Y DERIGLAZOVA DE RUSIA GANAN EL ORO</h2>
        <p><b>
        SHANGHÁI, CHINA <br>
        18 AL 20 DE MAYO DE 2018 <br>       
        ESGRIMA MASCULINO Y FEMENINO
        </b></p>
        <img src="/106/es/static/_mobile/pg23-shanghai.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Shanghái",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
      <img id="24-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="24-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="24-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>

      <a href="http://fie.org/es/competitions/2018/145/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:728px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <a href="http://fie.org/es/competitions/2018/457/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:915px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page24Anim = new TimelineMax()
        page24Anim
          .fromTo(idOf("24-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page24Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "COPA DEL MUNDO SHANGHAI, CHINA 2/2  Richard Kruse de Gran Bretaña e Inna Deriglazova de Rusia obtuvieron medallas de oro este fin de semana en el Gran Premio de Esgrima de Shanghái de 2018. El evento tuvo lugar en el Centro Deportivo Jing'an de la ciudad y atrajo a más de 325 esgrimistas internacionales, hombres y mujeres. Es el octavo de nueve eventos del Gran Premio en la temporada de competición de la Federación Internacional de Esgrima 2017-2018.  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  En el evento femenino, la medallista de oro olímpica rusa y dos veces campeona mundial Inna Deriglazova venció a la japonesa Karin Miyawaki en el partido final, 15-6. Para Miyawaki, fue el mejor resultado de su carrera, y para alcanzar la ronda de medalla de oro superó a la canadiense Eleanor Harvey en la semifinal, 15-11, y la segunda clasificada, la italiana Alice Volpi, en cuartos de final, 15-13. El mejor clasificado, Deriglazova, se hizo cargo de la coreana Song Oh Chae en la semifinal, ganando con un marcador de 15-11. En la competición de florete masculina, el esgrimista británico Richard Kruse repitió su  victoria en Shanghái, habiendo ganado este mismo evento el año pasado. Kruse derrotó al tercer clasificado ruso, Timur Safin, en la final, 15-13, tras vencer al Campeón del Mundo italiano Andrea Cassara en el partido de semifinales por un solo punto, 15-14. En la otra semifinal, Safin eliminó al mejor esgrimista estadounidense, Race Imboden, 15-10. Las ocho mejores en el evento femenino de Shanghái incluyen a Inna Deriglazova (RUS, oro), Karin Miyawaki (JPN, plata), Song Oh Chae (KOR, bronce), Eleanor Harvey (CAN, bronce), Alice Volpi (ITA), Inés Boubakri (TUN), Leonie Ebert (GER) y Jacqueline Dubrovich (Estados Unidos). Los ocho mejores finalistas masculinos de Shanghái incluyen a Richard Kruse (GBR, oro), Timur Safin (RUS, plata), Andrea Cassara (ITA, bronce), Race Imboden (EE. UU., Bronce), Gerek Meinhardt (EE. UU.), Edoardo Luperi (ITA), Francesco Trani (ITA) y Carlos Llavador (ESP). Los resultados finales del Gran Premio de Shanghái para hombres y mujeres de 2018 se pueden ver aquí para las mujeres, y aquí para los hombres. ■ W W W.FIE .ORG"
      ,
      "mobileHtml": `
        <p>
        Richard Kruse de Gran Bretaña e Inna Deriglazova de Rusia obtuvieron medallas de oro este fin de semana en el Gran Premio de Esgrima de Shanghái de 2018.
        </p>
        <p>
        El evento tuvo lugar en el Centro Deportivo Jing'an de la ciudad y atrajo a más de 325 esgrimistas internacionales, hombres y mujeres. Es el octavo de nueve eventos del Gran Premio en la temporada de competición de la Federación Internacional de Esgrima 2017-2018. 
        </p>
        <p>
        En el evento femenino, la medallista de oro olímpica rusa y dos veces campeona mundial Inna Deriglazova venció a la japonesa Karin Miyawaki en el partido final, 15-6. Para Miyawaki, fue el mejor resultado de su carrera, y para alcanzar la ronda de medalla de oro superó a la canadiense Eleanor Harvey en la semifinal, 15-11, y la segunda clasificada, la italiana Alice Volpi, en cuartos de final, 15-13. El mejor clasificado, Deriglazova, se hizo cargo de la coreana Song Oh Chae en la semifinal, ganando con un marcador de 15-11.
        </p>
        <p>        
        En la competición de florete masculina, el esgrimista británico Richard Kruse repitió su victoria en Shanghái, habiendo ganado este mismo evento el año pasado. Kruse derrotó al tercer clasificado ruso, Timur Safin, en la final, 15-13, tras vencer al Campeón del Mundo italiano Andrea Cassara en el partido de semifinales por un solo punto, 15-14. En la otra semifinal, Safin eliminó al mejor esgrimista estadounidense, Race Imboden, 15-10.
        </p>
        <p>
        Las ocho mejores en el evento femenino de Shanghái incluyen a Inna Deriglazova (RUS, oro), Karin Miyawaki (JPN, plata), Song Oh Chae (KOR, bronce), Eleanor Harvey (CAN, bronce), Alice Volpi (ITA), Inés Boubakri (TUN), Leonie Ebert (GER) y Jacqueline Dubrovich (Estados Unidos).
        </p>
        <p>          
        Los ocho mejores finalistas masculinos de Shanghái incluyen a Richard Kruse (GBR, oro), Timur Safin (RUS, plata), Andrea Cassara (ITA, bronce), Race Imboden (EE. UU., Bronce), Gerek Meinhardt (EE. UU.), Edoardo Luperi (ITA), Francesco Trani (ITA) y Carlos Llavador (ESP). Los resultados finales del Gran Premio de Shanghái para hombres y mujeres de 2018 se pueden ver aquí para las mujeres, y aquí para los hombres.
        </p>
        <p><a href="http://fie.org/es/competitions/2018/145/results/rank" target="_blank">Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA</a></p>
        <p><a href="http://fie.org/es/competitions/2018/457/results/rank" target="_blank">Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA</a></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
      ,
      "mobileHtml": `
      <img id="jiang1img" src="/106/es/static/_mobile/pg25-wuxi.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" style="bottom:155px;right:500px;width:338px; height:30px;">
      <a href="mailto:contact@blaise-freres.fr"></a>
    </div>
    <div class="addContentLink" style="bottom:155px;right:50px;width:285px; height:30px;">
      <a href="http://www.blaise-freres.fr" target="_blank"></a>
    </div>
    
  `,
  "script": `
  function onPageEnter() {
    addContentLinks()
  }

  function onPageLeave() {
    removeContentLinks()
  }
      `,
      "searchText": ""
      ,
      "mobileHtml": `
      <a href="http://www.blaise-freres.fr/fr" target="_blank">
        <img id="blaise1img" src="/106/es/static/_mobile/pg26-blaise.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Cali",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `
      <img id="27-next" class="halfScale pointer" style="top:847px;left:1412px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <img id="27-title" class="halfScale" style="top:124px;left:80px" src="/106/es/static/_content/27-title.png">
      <img id="27-sub" class="halfScale" style="top:488px;left:127px" src="/106/es/static/_content/27-sub.png">
      <img id="27-line" class="halfScale" style="top:485px;left:84px" src="/106/es/static/_content/all-1line.png">
      `,
      "script": `
      function onPageEnter() {
        page27Anim = new TimelineMax()
        page27Anim
          .fromTo(idOf("27-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("27-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("27-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("27-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page27Anim.stop()
      }
      `,
      "searchText": "COPA DEL MUNDO  EL FRANCÉS BOREL Y EL HÚNGARO SZASZ-KOVACS GANAN EL GRAN PREMIO DE ESPADA DE CALI CALI, COLOMBIA 25 AL 27 DE MAYO DE 2018 ESPADA MASCULINA Y FEMENINA"
      ,
      "mobileHtml": `
        <h2>EL FRANCÉS BOREL Y EL HÚNGARO SZASZ-KOVACS GANAN EL GRAN PREMIO DE ESPADA DE CALI</h2>
        <p><b>
          CALI, COLUMBIA <br>
          25 AL 27 DE MAYO DE 2018 <br>       
          ESPADA MASCULINA Y FEMENINA
        </b></p>
        <img src="/106/es/static/_mobile/pg27-cali.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Cali",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `
      <img id="28-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="28-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="28-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>

      <a href="http://fie.org/es/competitions/2018/113/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:728px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <a href="http://fie.org/es/competitions/2018/95/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:915px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>

      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page28Anim = new TimelineMax()
        page28Anim
          .fromTo(idOf("28-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page28Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "COPA DEL MUNDO CALI, COLOMBIA 2/2  El esgrimista francés Yannick Borel obtuvo el oro en el Gran Premio de Espada de Cali, Colombia, en el evento masculino, su segundo título del Gran Premio. La medallista de oro olímpica Emese Szasz-Kovacs de Hungría ganó la competición femenina, su quinta victoria en el Gran Premio, incluyendo este mismo evento el año pasado en Bogotá. Teniendo lugar en el Centro de Eventos Valle del Pacífico de Cali, más de 230 esgrimistas participaron en este Gran Premio final de una serie de nueve eventos en la temporada competitiva de la Federación Internacional de Esgrima (FIE) 2017-2018.  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA MASCULINA  Pulse aquí para ver los RESULTADOS DE LA COMPETENCIA FEMENINA  En el último partido masculino, Borel, 13° clasificado, derrotó al coreano Byeungchan Jung, 109°, con marca de 15-10, para quien fue el mejor resultado de su carrera. Jung enfrentó al francés Daniel Jerent en la semifinal, ganando 15-11, mientras que Borel superó al medallista de oro coreano Sangyoung Park por un punto, 15-14. Jerent también venció por poco al segundo clasificado, el ucraniano Bogdan Nikishin, en los cuartos de final, 15-14, y Borel eliminó al cuarto clasificado suizo Max Heinzer en la misma ronda, 15-9.  El mejor clasificado, Szasz-Kovacs, se enfrentó al n.º 26 de Estados Unidos Courtney Hurley en la final, terminando con un marcador de 1511. Hurley derrotó a la francesa Auriane Mallo en la semifinal, 15-9, y Szasz-Kovacs venció a la italiana Federica Isola, 15-10, para quien este fue el mejor resultado de la historia, dada su posición 189 de la clasificación. Los ocho mejores en el evento de espada masculino incluyen Yannick Borel (FRA, oro), Byeungchan Jung (KOR, plata), Daniel Jerent (FRA, bronce), Sangyoung Park (KOR, bronce), Bogdan Nikishin (UKR), Max Heinzer (SUI), Jinsun Jung (KOR) y Yulen Pereira (ESP). Las ocho mejores mujeres fueron Emese SzaszKovacs (HUN, oro), Courtney Hurley (EE. UU., Plata), Federica Isola (ITA, bronce), Auriane Mallo (FRA, bronce), Olena Kryvytska (UKR), Young Mi Kang ( KOR), Marta Ferrari (ITA) y Hyojung Jung (KOR). Los resultados finales del Gran Premio de Espada de Cali 2018 se pueden encontrar aquí para los eventos masculinos y aquí femeninos. ■ W W W.FIE .ORG"
      ,
      "mobileHtml": `
        <p>
        El esgrimista francés Yannick Borel obtuvo el oro en el Gran Premio de Espada de Cali, Colombia, en el evento masculino, su segundo título del Gran Premio.
        </p>
        <p>
        La medallista de oro olímpica Emese Szasz-Kovacs de Hungría ganó la competición femenina, su quinta victoria en el Gran Premio, incluyendo este mismo evento el año pasado en Bogotá. Teniendo lugar en el Centro de Eventos Valle del Pacífico de Cali, más de 230 esgrimistas participaron en este Gran Premio final de una serie de nueve eventos en la temporada competitiva de la Federación Internacional de Esgrima (FIE) 2017-2018.
        </p>
        <p>        
        En el último partido masculino, Borel, 13° clasificado, derrotó al coreano Byeungchan Jung, 109°, con marca de 15-10, para quien fue el mejor resultado de su carrera. Jung enfrentó al francés Daniel Jerent en la semifinal, ganando 15-11, mientras que Borel superó al medallista de oro coreano Sangyoung Park por un punto, 15-14. Jerent también venció por poco al segundo clasificado, el ucraniano Bogdan Nikishin, en los cuartos de final, 15-14, y Borel eliminó al cuarto clasificado suizo Max Heinzer en la misma ronda, 15-9. 
        </p>
        <p>          
        El mejor clasificado, Szasz-Kovacs, se enfrentó al n.º 26 de Estados Unidos Courtney Hurley en la final, terminando con un marcador de 15-11. Hurley derrotó a la francesa Auriane Mallo en la semifinal, 15-9, y Szasz-Kovacs venció a la italiana Federica Isola, 15-10, para quien este fue el mejor resultado de la historia, dada su posición 189 de la clasificación.
        </p>
        <p>
        Los ocho mejores en el evento de espada masculino incluyen Yannick Borel (FRA, oro), Byeungchan Jung (KOR, plata), Daniel Jerent (FRA, bronce), Sangyoung Park (KOR, bronce), Bogdan Nikishin (UKR), Max Heinzer (SUI), Jinsun Jung (KOR) y Yulen Pereira (ESP).
        </p>
        <p>          
        Las ocho mejores mujeres fueron Emese Szasz-Kovacs (HUN, oro), Courtney Hurley (EE.UU., Plata), Federica Isola (ITA, bronce), Auriane Mallo (FRA, bronce), Olena Kryvytska (UKR), Young Mi Kang ( KOR), Marta Ferrari (ITA) y Hyojung Jung (KOR).
        </p>
        <p>
        Los resultados finales del Gran Premio de Espada de Cali 2018 se pueden encontrar aquí para los eventos masculinos y aquí femeninos.
        </p>
        <p><a href="http://fie.org/es/competitions/2018/113/results/rank" target="_blank">Pulse aquí para ver los RESULTADOS DE LA COMPERENCIA MASCULINA</a></p>
        <p><a href="http://fie.org/es/competitions/2018/95/results/rank" target="_blank">Pulse aquí para ver los RESULTADOS DE LA COMPERENCIA FEMENINA</a></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Atenas",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
      <img id="29-next" class="halfScale pointer" style="top:847px;left:1411px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <img id="29-title" class="halfScale" style="top:116px;left:84px" src="/106/es/static/_content/29-title.png">
      <img id="29-sub" class="halfScale" style="top:392px;left:88px" src="/106/es/static/_content/29-sub.png">
      <img id="29-line" class="halfScale" style="top:387px;left:88px" src="/106/es/static/_content/all-3line.png">
      `,
      "script": `
      function onPageEnter() {
        page29Anim = new TimelineMax()
        page29Anim
          .fromTo(idOf("29-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("29-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("29-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("29-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page29Anim.stop()
      }
      `,
      "searchText": "COPA DEL MUNDO  LA RUMANA BIANCA PASCU Y EL EQUIPO DE ITALIA GANAN EL ORO ATENAS, GRECIA 16 AL 18 DE MARZO DE 2018 SABLE FEMENINO"
      ,
      "mobileHtml": `
        <h2>LA RUMANA BIANCA PASCU Y EL EQUIPO DE ITALIA GANAN EL ORO</h2>
        <p><b>
        ATENAS, GRECIA <br>
        16 AL 18 DE MARZO DE 2018 <br>       
        SABLE FEMENINO
        </b></p>
        <img src="/106/es/static/_mobile/pg29-athens.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Atenas",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
      <img id="30-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="30-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="30-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>

      <a href="http://fie.org/es/competitions/2018/151/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:733px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <a href="http://fie.org/es/competitions/2018/756/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:940px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>

      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page30Anim = new TimelineMax()
        page30Anim
          .fromTo(idOf("30-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page30Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "COPA DEL MUNDO ATENAS, GRECIA 2/2  La esgrimista rumana Bianca Pascu, en la mejor victoria de su carrera, se llevó el oro en la Copa del Mundo de sable femenino de la «Coupe Acropolis» de Atenas. Las esgrimistas italianas también ocuparon el primer lugar en el evento por equipos, y ambas pruebas tuvieron lugar en el Complejo Olímpico de Atenas. En total, participaron 23 equipos en un campo de más de 180 esgrimistas internacionales.  Se pueden encontrar los RESULTADOS COMPLETOS DE LA COMPETICIÓN INDIVIDUAL AQUÍ  Y los RESULTADOS DE LA PRUEBA POR EQUIPOS AQUÍ  Pascu, de 29 años, que ocupa el quinto lugar del mundo, derrotó en la final a la húngara de 16 años Liza Pusztai, por 15-11. Pascu también venció en la semifinal a la compañera de equipo de Pusztai, la segunda clasificada Anna Marton, por 15-12; Marton es medallista de bronce en el Campeonato Mundial y la campeona vigente de la «Coupe Acropolis» del año pasado. La mejor clasificada Olga Kharlan (UKR) también fue eliminada por Pascu en los cuartos de final, por 15-13. Pusztai dejó fuera a la francesa Manon Brunet, que ganó la plata en este mismo evento el año pasado, en la semifinal, por 15-9. En la final de la prueba de sable femenino por equipos, Italia venció a Corea por 45-31. Italia también ganó frente a EE. UU. en la semifinal, por  45-39, mientras que Corea derrotó a Francia en un partido cerrado, por 45-43. Francia se llevó a casa la medalla de bronce después de ganar frente a Estados Unidos, por 45-41. Las ocho mejores clasificadas individuales de sable femenino de la Coupe Acropolis incluyen a Bianca Pascu (ROU, oro), Liza Pusztai (HUN, plata), Manon Brunet (FRA, bronce), Anna Marton (HUN, bronce), Olga Kharlan (UKR), Charlotte Lembach (FRA), Sofia Pozdniakova (RUS) y Malgorzata Kozaczuk (POL). El ranking de los ocho mejores equipos de sable femenino ubica a Italia (oro) en primer lugar, seguida de Corea (plata), Francia (bronce), EE. UU., Rusia, España, Hungría y China. ■ W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <p>
        La esgrimista rumana Bianca Pascu, en la mejor victoria de su carrera, se llevó el oro en la Copa del Mundo de sable femenino de la «Coupe Acropolis» de Atenas.
        </p>
        <p>
        Las esgrimistas italianas también ocuparon el primer lugar en el evento por equipos, y ambas pruebas tuvieron lugar en el Complejo Olímpico de Atenas. En total, participaron 23 equipos en un campo de más de 180 esgrimistas internacionales.
        </p>
        <p>         
        Pascu, de 29 años, que ocupa el quinto lugar del mundo, derrotó en la final a la húngara de 16 años Liza Pusztai, por 15-11. Pascu también venció en la semifinal a la compañera de equipo de Pusztai, la segunda clasificada Anna Marton, por 15-12; Marton es medallista de bronce en el Campeonato Mundial y la campeona vigente de la «Coupe Acropolis» del año pasado. La mejor clasificada Olga Kharlan (UKR) también fue eliminada por Pascu en los cuartos de final, por 15-13. Pusztai dejó fuera a la francesa Manon Brunet, que ganó la plata en este mismo evento el año pasado, en la semifinal, por 15-9.
        </p>
        <p>
        En la final de la prueba de sable femenino por equipos, Italia venció a Corea por 45-31. Italia también ganó frente a EE. UU. en la semifinal, por 45-39, mientras que Corea derrotó a Francia en un partido cerrado, por 45-43. Francia se llevó a casa la medalla de bronce después de ganar frente a Estados Unidos, por 45-41.
        </p>
        <p>      
        Las ocho mejores clasificadas individuales de sable femenino de la Coupe Acropolis incluyen a Bianca Pascu (ROU, oro), Liza Pusztai (HUN, plata), Manon Brunet (FRA, bronce), Anna Marton (HUN, bronce), Olga Kharlan (UKR), Charlotte Lembach (FRA), Sofia Pozdniakova (RUS) y Malgorzata Kozaczuk (POL).
        </p>
        <p>         
        El ranking de los ocho mejores equipos de sable femenino ubica a Italia (oro) en primer lugar, seguida de Corea (plata), Francia (bronce), EE. UU., Rusia, España, Hungría y China.
        </p>
        <p><a href="http://fie.org/es/competitions/2018/151/results/rank" target="_blank">Se peuden encontrar los resultados completos de la competición individual aquí</a></p>
        <p><a href="http://fie.org/es/competitions/2018/756/results/rank" target="_blank">Y los resultados de la prueba por equipos aquí</a></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" style="bottom:79px;right:330px;width:815px; height:42px;">
      <a href="mailto:service@blue-gauntletservice.com"></a>
    </div>
    <a class="addContentLink" style="top:940px;left:244px;height:81px;width:1095px;" href="http://www.blue-gauntlet.com" target="_blank">
  
    `,
    "script": `
    function onPageEnter() {
      addContentLinks()
    }

    function onPageLeave() {
      removeContentLinks()
    }
      `,
      "searchText": ""
      ,
      "mobileHtml": `
      <a href="http://www.blue-gauntlet.com" target="_blank">
        <img id="bluegauntlet1img" src="/106/es/static/_mobile/pg31-bluegauntlet.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.png",
      "zoom": null,
      "content": `
      <div class="addContentLink" style="bottom:584px;right:48px;width:655px; height:50px;">
        <a href="http://www.AbsoluteFencingGear.com" target="_blank"></a>
      </div>

`,
"script": `
function onPageEnter() {
  addContentLinks()
}

function onPageLeave() {
  removeContentLinks()
}
      `,
      "searchText": ""
      ,
      "mobileHtml": `
      <a href="http://www.absolutefencinggear.com/shopping/" target="_blank">
        <img id="absolute2img" src="/106/es/static/_mobile/pg32-absolute.png">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Tauberbischofsheim",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `
      <img id="33-next" class="halfScale pointer" style="top:847px;left:1411px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <img id="33-title" class="halfScale" style="top:90px;left:84px" src="/106/es/static/_content/33-title.png">
      <img id="33-sub" class="halfScale" style="top:346px;left:127px" src="/106/es/static/_content/33-sub.png">
      <img id="33-line" class="halfScale" style="top:342px;left:85px" src="/106/es/static/_content/all-3line.png">
      `,
      "script": `
      function onPageEnter() {
        page33Anim = new TimelineMax()
        page33Anim
          .fromTo(idOf("33-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("33-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("33-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("33-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page33Anim.stop()
      }
      `,
      "searchText": "COPA DEL MUNDO  RUSIA OBTIENE DOBLE ORO EN LA COPA DEL MUNDO DE ESGRIMA FEMENINA EN ALEMANIA TAUBERBISCHOFSHEIM, ALEMANIA 27 AL 29 DE ABRIL DE 2018 FLORETE FEMENINO"
      ,
      "mobileHtml": `
        <h2>RUSIA OBTIENE DOBLE ORO EN LA COPA DEL MUNDO DE ESGRIMA FEMENINA EN ALEMANIA</h2>
        <p><b>
        TAUBERBISCHOFSHEIM, ALEMANIA <br>
        27 AL 29 DE ABRIL DE 2018 <br>       
        FLORETE FEMENINO
        </b></p>
        <img src="/106/es/static/_mobile/pg33-tauber.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Tauberbischofsheim",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `<img id="34-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="34-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="34-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>

      <a href="http://fie.org/es/competitions/2018/122/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:734px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <a href="http://fie.org/es/competitions/2018/201/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:940px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>

      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page34Anim = new TimelineMax()
        page34Anim
          .fromTo(idOf("34-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page34Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "COPA DEL MUNDO TAUBERBISCHOFSHEIM, ALEMANIA 2/2  Las esgrimistas rusas se llevaron dos medallas de oro en Tauberbischofsheim, Alemania, en la Copa Mundial de florete femenina. La medallista de oro olímpica rusa y la dos veces campeona mundial Inna Deriglazova se llevó los honores en la modalidad individual, y el equipo de florete femenino ruso logró el oro en la modalidad por equipos. Casi 200 floristas internacionales y 21 equipos participaron en la competición, la cual tuvo lugar en el club de esgrima de Tauberbischofsheim. Se pueden encontrar los RESULTADOS COMPLETOS DE LA COMPETICIÓN INDIVIDUAL AQUÍ  Y los RESULTADOS DE LA PRUEBA POR EQUIPOS AQUÍ  Deriglazova ganó la copa Reinhold-Wurth del evento de florete individual por un punto, derrotando a la Coreana Hee Sook Jeon en la final,13-12. Jeon derrotó a la alemana Leonie Ebert en la semifinal para ganar la medalla de oro, 15-12, mientras que Deriglazova superó a la tercera clasificada Lee Kiefer (EE.UU),15-10.  de 45-36. Italia venció a Francia en la ronda semifinal, 45-34, mientras que Rusia obtuvo la victoria sobre EE.UU, 45-37. Para la medalla de bronce, Francia venció a EE.UU, 45-36. Las ocho mejores clasificadas de la Copa del Mundo de Tauberbischofsheim de florete femenino individual incluyen a Inna Deriglazova (RUS, oro), Hee Sook Jeon (COR, plata), Leonie Ebert (ALE, bronce), Lee Kiefer (EE.UU, bronce), Ysaora Thibus (FRA), Svetlana Tripapina (RUS), Chiara Cini (ITA), y Elisa Vardaro (ITA). Las ocho mejores clasificadas de florete femenino por equipos sitúan a Rusia (oro) primera, seguido por Italia (plata), Francia (bronce), EE.UU, Polonia, Japón, Alemania y Hungría. ■  En la modalidad por equipos, Rusia se enfrentó con Italia en la final, ganando con una puntuación W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <p>
        Las esgrimistas rusas se llevaron dos medallas de oro en Tauberbischofsheim, Alemania, en la Copa Mundial de florete femenina.
        </p>
        <p>       
        La medallista de oro olímpica rusa y la dos veces campeona mundial Inna Deriglazova se llevó los honores en la modalidad individual, y el equipo de florete femenino ruso logró el oro en la modalidad por equipos. Casi 200 floristas internacionales y 21 equipos participaron en la competición, la cual tuvo lugar en el club de esgrima de Tauberbischofsheim.
        </p>
        <p>          
        Deriglazova ganó la copa Reinhold-Wurth del evento de florete individual por un punto, derrotando a la Coreana Hee Sook Jeon en la final, 13-12. Jeon derrotó a la alemana Leonie Ebert en la semifinal para ganar la medalla de oro, 15-12, mientras que Deriglazova superó a la tercera clasificada Lee Kiefer (EE.UU), 15-10.
        </p>
        <p>          
        En la modalidad por equipos, Rusia se enfrentó con Italia en la final, ganando con una puntuación de 45-36. Italia venció a Francia en la ronda semifinal, 45-34, mientras que Rusia obtuvo la victoria sobre EE.UU, 45-37. Para la medalla de bronce, Francia venció a EE.UU, 45-36.
        </p>
        <p>         
        Las ocho mejores clasificadas de la Copa del Mundo de Tauberbischofsheim de florete femenino individual incluyen a Inna Deriglazova (RUS, oro), Hee Sook Jeon (COR, plata), Leonie Ebert (ALE, bronce), Lee Kiefer (EE.UU, bronce), Ysaora Thibus (FRA), Svetlana Tripapina (RUS), Chiara Cini (ITA), y Elisa Vardaro (ITA).
        </p>
        <p>         
        Las ocho mejores clasificadas de florete femenino por equipos sitúan a Rusia (oro) primera, seguido por Italia (plata), Francia (bronce), EE.UU, Polonia, Japón, Alemania y Hungría.
        </p>
        <p><a href="http://fie.org/es/competitions/2018/129/results/rank" target="_blank">Se peuden encontrar los resultados completos de la competición individual aquí</a></p>
        <p><a href="http://fie.org/es/competitions/2018/563/results/rank" target="_blank">Y los resultados de la prueba por equipos aquí</a></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Dubai, Emiratos Árabes Unidos",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": `
      <img id="35-next" class="halfScale pointer" style="top:847px;left:1411px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <img id="35-title" class="halfScale" style="top:106px;left:836px" src="/106/es/static/_content/35-title.png">
      <img id="35-sub" class="halfScale" style="top:443px;left:1079px" src="/106/es/static/_content/35-sub.png">
      <img id="35-line" class="halfScale" style="top:435px;left:1037px" src="/106/es/static/_content/all-4line.png">
      `,
      "script": `
      function onPageEnter() {
        page35Anim = new TimelineMax()
        page35Anim
          .fromTo(idOf("35-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("35-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("35-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("35-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page35Anim.stop()
      }
      `,
      "searchText": "COPA DEL MUNDO  SUN DE CHINA, Y EL EQUIPO DE EE.UU. GANAN LA COPA DEL MUNDO DE ESPADA FEMENINA DE DUBAI DUBAI, EMIRATOS ÁRABES UNIDOS 4 AL 6 DE MAYO DE 2018 ESPADA FEMENINA"
      ,
      "mobileHtml": `
        <h2>SUN DE CHINA, Y EL EQUIPO DE EE.UU. GANAN LA COPA DEL MUNDO DE ESPADA FEMENINA DE DUBAI</h2>
        <p><b>
        DUBAI, EMIRATOS ÁRABES UNIDOS <br>
        4 AL 6 DE MAYO DE 2018 <br>       
        ESPADA FEMENINA
        </b></p>
        <img src="/106/es/static/_mobile/pg35-dubai.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Dubai, Emiratos Árabes Unidos",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": `
      <img id="36-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="36-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="36-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>

      <a href="http://fie.org/es/competitions/2018/451/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:733px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <a href="http://fie.org/es/competitions/2018/762/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:940px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page36Anim = new TimelineMax()
        page36Anim
          .fromTo(idOf("36-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page36Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "COPA DEL MUNDO DUBAI, EMIRATOS ÁRABES UNIDOS 2/2  Se pueden encontrar los RESULTADOS COMPLETOS DE LA COMPETICIÓN INDIVIDUAL AQUÍ  Y los RESULTADOS DE LA PRUEBA POR EQUIPOS AQUÍ  La tiradora china Yiwen Sun se llevó los honores en los Emiratos Árabes Unidos en la Copa del Mundo de espada femenina, compitiendo en un campo de casi 200 de las atletas femeninas internacionales mejor clasificadas.  En la prueba por equipos femeninos, los EE.UU. vencieron por poco a Rusia en la ronda por la medalla de oro, 29-28. Rusia venció a Italia en la semifinal, 29-22, mientras que Estados Unidos venció a Francia, 42-36. Italia se llevó a casa la medalla de bronce, venciendo a Francia en la ronda por el tercer puesto, 45-35.  Las esgrimistas de EE.UU. también ganaron el oro en la prueba por equipos, con 24 equipos compitiendo. La prueba tuvo lugar en el Shabab Al Ahli Club en Dubai.  Las ocho finalistas individuales para la Copa del Mundo de Dubai con espada incluyeron a Yiwen Sun (CHN, oro), Laurence Epee (FRA, plata), Injeong Choi (KOR, bronce), Violetta Kolobova (RUS, bronce), Emese Szasz-Kovacs (HUN), Mingye Zhu (CHN), Giulia Rizzi (ITA) y Coraline Vitalis (FRA).  Sun disputó el último match en la prueba individual contra la francesa Laurence Epee, ganando con una puntuación de 15-9. Epee venció a la rusa Violetta Kolobova en la semifinal, 15-11, mientras que Sun dejó fuera a la coreana Injeong Choi, también con una puntuación de 15-11. De manera destacada, Sun derrotó a la primera clasificada y medallista de oro olímpico Emese Szasz-Kovacs de Hungría en los cuartos de final, 15-12.  Los ocho equipos ganadores fueron EE.UU. (Oro), Rusia (plata), Italia (bronce), Francia, Corea, Hong Kong, Polonia y China. ■  W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <p>
        La tiradora china Yiwen Sun se llevó los honores en los Emiratos Árabes Unidos en la Copa del Mundo de espada femenina, compitiendo en un campo de casi 200 de las atletas femeninas internacionales mejor clasificadas.
        </p>
        <p>
        Las esgrimistas de EE.UU. también ganaron el oro en la prueba por equipos, con 24 equipos compitiendo. La prueba tuvo lugar en el Shabab Al Ahli Club en Dubai.
        </p>
        <p>         
        Sun disputó el último match en la prueba individual contra la francesa Laurence Epee, ganando con una puntuación de 15-9. Epee venció a la rusa Violetta Kolobova en la semifinal, 15-11, mientras que Sun dejó fuera a la coreana Injeong Choi, también con una puntuación de 15-11. De manera destacada, Sun derrotó a la primera clasificada y medallista de oro olímpico Emese Szasz-Kovacs de Hungría en los cuartos de final, 15-12.
        </p>
        <p>
        En la prueba por equipos femeninos, los EE.UU. vencieron por poco a Rusia en la ronda por la medalla de oro, 29-28. Rusia venció a Italia en la semifinal, 29-22, mientras que Estados Unidos venció a Francia, 42-36. Italia se llevó a casa la medalla de bronce, venciendo a Francia en la ronda por el tercer puesto, 45-35.
        </p>
        <p>         
        Las ocho finalistas individuales para la Copa del Mundo de Dubai con espada incluyeron a Yiwen Sun (CHN, oro), Laurence Epee (FRA, plata), Injeong Choi (KOR, bronce), Violetta Kolobova (RUS, bronce), Emese Szasz-Kovacs (HUN), Mingye Zhu (CHN), Giulia Rizzi (ITA) y Coraline Vitalis (FRA).
        </p>
        <p>
        Los ocho equipos ganadores fueron EE.UU. (oro), Rusia (plata), Italia (bronce), Francia, Corea, Hong Kong, Polonia y China.
        </p>
        <p><a href="http://fie.org/es/competitions/2018/451/results/rank" target="_blank">Se peuden encontrar los resultados completos de la competición individual aquí</a></p>
        <p><a href="http://fie.org/es/competitions/2018/762/results/rank" target="_blank">Y los resultados de la prueba por equipos aquí</a></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `
      <div class="addContentLink" style="bottom:55px;right:58px;width:105px; height:30px;">
      <a href="http://www.allstar.de" target="_blank"></a>
    </div>
    <svg class="abs pulse animatedpulse pointer" onclick="Publish.openVideo('static/_content/pg37-vid.mp4')" style="bottom:460px;left:86px;" width="69.4px" height="67.4px" viewBox="0 0 69.4 67.4">
      <path fill="#ffffff" d="M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7"/>
    </svg>

    `,
    "script": `
    function onPageEnter() {
    addContentLinks()
    }

    function onPageLeave() {
    removeContentLinks()
    }
    `,
    "searchText": "",
    "mobileHtml": `
    <a href="http://www.allstar.de" target="_blank">
      <img id="allstarimg" src="/106/es/static/_mobile/pg37-mobile.jpg">
    </a>
    `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.png",
      "zoom": null,
      "content": `
    <div class="addContentLink" style="bottom:39px;right:1046px;width:289px; height:44px;">
      <a href="http://www.pbtfencing.com" target="_blank"></a>
    </div>
    <div class="addContentLink" style="bottom:38px;right:617px;width:311px; height:45px;">
      <a href="mailto:sales@pbtfencing.com"></a>
    </div>
    <div class="addContentLink" style="bottom:37px;right:188px;width:332px; height:46px;">
      <a href="http://www.fb.com/pbtfencing" target="_blank"></a>
    </div>

`,
"script": `
function onPageEnter() {
addContentLinks()
}

function onPageLeave() {
removeContentLinks()
}
      `,
      "searchText": "",
      "mobileHtml": `
      <a href="http://pbtfencing.com" target="_blank">
        <img id="pbtimg" src="/106/es/static/_mobile/pg38-pbt.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "San Petersburgo, Rusio",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.jpg",
      "zoom": null,
      "content": `
      <img id="39-next" class="halfScale pointer" style="top:847px;left:1412px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <img id="39-title" class="halfScale" style="top:95px;left:85px" src="/106/es/static/_content/39-title.png">
      <img id="39-sub" class="halfScale" style="top:100px;left:588px" src="/106/es/static/_content/39-sub.png">
      <img id="39-line" class="halfScale" style="top:97px;left:545px" src="/106/es/static/_content/all-3line.png">
      `,
      "script": `
      function onPageEnter() {
        page39Anim = new TimelineMax()
        page39Anim
          .fromTo(idOf("39-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("39-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("39-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("39-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page39Anim.stop()
      }
      `,
      "searchText": "COPA DEL MUNDO PAUTY DE FRANCIA Y EL EQUIPO DE EE.UU. SE HACE CON EL ORO  SAN PETERSBURGO, RUSIA 4 AL 6 DE MAYO DE 2018 FLORETE MASCULINO"
      ,
      "mobileHtml": `
        <h2>PAUTY DE FRANCIA Y EL EQUIPO DE EE.UU. SE HACE CON EL ORO</h2>
        <p><b>
        SAN PETERSBURGO, RUSIA <br>
        4 AL 6 DE MAYO DE 2018 <br>       
        FLORETE MASCULINO
        </b></p>
        <img src="/106/es/static/_mobile/pg39-stp.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "San Petersburgo, Rusio",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.jpg",
      "zoom": null,
      "content": `<img id="40-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
        <img id="40-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
        <img id="40-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>

      <a href="http://fie.org/es/competitions/2018/147/results/rank" target="_blank">
        <img class="halfScaleC pulse animatedpulse" style="top:732px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <a href="http://fie.org/es/competitions/2018/571/results/rank" target="_blank">
        <img class="halfScaleC pulse animatedpulse" style="top:940px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page40Anim = new TimelineMax()
        page40Anim
          .fromTo(idOf("40-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page40Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "COPA DEL MUNDO SAN PETERSBURGO, RUSIA 2/2  El francés Maxime Pauty ganó la prueba individual de la Copa del Mundo de florete masculino de San Petersburgo, compitiendo contra casi 200 de los mejores tiradores de espada del mundo. Estados Unidos también terminó en primer lugar en la prueba por equipos masculinos de entre 23 equipos internacionales, que se llevó a cabo en el Estadio Zimniy de San Petersburgo.  Se pueden encontrar los RESULTADOS COMPLETOS DE LA COMPETICIÓN INDIVIDUAL AQUÍ  Y los RESULTADOS DE LA PRUEBA POR EQUIPOS AQUÍ  Pauty, en el mejor resultado individual en su carrera hasta la fecha, derrotó al segundo clasificado de Italia, Alessio Foconi, en el match por la medalla de oro, 15-7. Foconi venció al campeón del mundo, el tirador ruso Alexey Cheremisinov en la semifinal, 15-9, y Pauty venció al coreano Kwanghyun Lee, 15-9. Pauty también venció al Campeón del Mundo, el italiano Andrea Cassara en los cuartos de final, 15-13. En la prueba por equipos masculinos, EE.UU. completó una temporada invicta en la Copa del Mundo al ganar este fin de semana en la ronda final contra Italia, 45-25. Italia venció a Francia en la ronda de semifinales, 45-31, y Estados Unidos venció a Rusia, 45-38. La medalla de bronce fue  para Francia en el match por el tercer puesto, derrotando a Rusia, 45-34. Los ocho mejores clasificados de la Copa del Mundo de florete masculino de San Petersburgo incluyen a Maxime Pauty (FRA, oro), Alessio Foconi (ITA, plata), Alexey Cheremisinov (RUS, bronce), Kwanghyun Lee (KOR, bronce), Alexander Massialas (EE.UU.), Andrea Cassara (ITA), Jeremy Cadot (FRA) y Young Ki Son (KOR). Los ocho mejores equipos masculinos de florete masculino incluyen EE. UU. (Oro), Italia (plata), Francia (bronce), Rusia, Corea, Gran Bretaña, Japón y China. ■  W W W.FIE .ORG"
,
      "mobileHtml":`
        <p>         
        El francés Maxime Pauty ganó la prueba individual de la Copa del Mundo de florete masculino de San Petersburgo, compitiendo contra casi 200 de los mejores tiradores de espada del mundo.
        </p>
        <p>       
        Estados Unidos también terminó en primer lugar en la prueba por equipos masculinos de entre 23 equipos internacionales, que se llevó a cabo en el Estadio Zimniy de San Petersburgo.
        </p>
        <p>
        Pauty, en el mejor resultado individual en su carrera hasta la fecha, derrotó al segundo clasificado de Italia, Alessio Foconi, en el match por la medalla de oro, 15-7. Foconi venció al campeón del mundo, el tirador ruso Alexey Cheremisinov en la semifinal, 15-9, y Pauty venció al coreano Kwanghyun Lee, 15-9. Pauty también venció al Campeón del Mundo, el italiano Andrea Cassara en los cuartos de final, 15-13.
        </p>
        <p>          
        En la prueba por equipos masculinos, EE.UU. completó una temporada invicta en la Copa del Mundo al ganar este fin de semana en la ronda final contra Italia, 45-25. Italia venció a Francia en la ronda de semifinales, 45-31, y Estados Unidos venció a Rusia, 45-38. La medalla de bronce fue para Francia en el match por el tercer puesto, derrotando a Rusia, 45-34.
        </p>
        <p>
        Los ocho mejores clasificados de la Copa del Mundo de florete masculino de San Petersburgo incluyen a Maxime Pauty (FRA, oro), Alessio Foconi (ITA, plata), Alexey Cheremisinov (RUS, bronce), Kwanghyun Lee (KOR, bronce), Alexander Massialas (EE.UU.), Andrea Cassara (ITA), Jeremy Cadot (FRA) y Young Ki Son (KOR).
        </p>
        <p>
        Los ocho mejores equipos masculinos de florete masculino incluyen EE. UU. (Oro), Italia (plata), Francia (bronce), Rusia, Corea, Gran Bretaña, Japón y China.
        </p>
        <p><a href="http://fie.org/es/competitions/2018/147/results/rank" target="_blank">Se peuden encontrar los resultados completos de la competición individual aquí</a></p>
        <p><a href="http://fie.org/es/competitions/2018/571/results/rank" target="_blank">Y los resultados de la prueba por equipos aquí</a></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Paris, Francia",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.jpg",
      "zoom": null,
      "content": `
      <img id="41-next" class="halfScale pointer" style="top:847px;left:1411px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <img id="41-title" class="halfScale" style="top:82px;left:620px" src="/106/es/static/_content/41-title.png">
      <img id="41-sub" class="halfScale" style="top:402px;left:1023px" src="/106/es/static/_content/41-sub.png">
      <img id="41-line" class="halfScale" style="top:394px;left:980px" src="/106/es/static/_content/all-3line.png">
      `,
      "script": `
      function onPageEnter() {
        page41Anim = new TimelineMax()
        page41Anim
          .fromTo(idOf("41-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("41-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("41-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("41-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page41Anim.stop()
      }
      `,
      "searchText": "COPA DEL MUNDO  EL ESTONIO NOVOSJOLOV Y EL EQUIPO DE HUNGRÍA GANA EN EL DESAFÍO SNCF RESEAU DE LA COPA DEL MUNDO DE ESGRIMA PARIS, FRANCIA 11 AL 13 DE MAYO DE 2018 ESPADA MASCULINA"
      ,
      "mobileHtml": `
        <h2>EL ESTONIO NOVOSJOLOV Y EL EQUIPO DE HUNGRÍA GANA EN EL DESAFÍO SNCF RESEAU DE LA COPA DEL MUNDO DE ESGRIMA</h2>
        <p><b>
        PARIS, FRANCIA <br>
        11 AL 13 DE MAYO DE 2018  <br>       
        ESPADA MASCULINA
        </b></p>
        <img src="/106/es/static/_mobile/pg41-paris.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Paris, Francia",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.jpg",
      "zoom": null,
      "content": `
      <img id="42-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="42-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="42-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>

      <a href="http://fie.org/es/competitions/2018/111/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:733px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <a href="http://fie.org/es/competitions/2018/753/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:940px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page42Anim = new TimelineMax()
        page42Anim
          .fromTo(idOf("42-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page42Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "COPA DEL MUNDO PARIS, FRANCIA 2/2  El esgrimista estonio dos veces campeón del mundo Nikolai Novosjolov se llevó el oro en el desafío SNFC Reseau de espada de la Copa del Mundo en la modalidad masculina en París, junto con el equipo de Hungría que ganó el evento en la modalidad por equipos. La competición, que tuvo lugar en el Stade Pierre de Coubertin, atrajo a más de 325 esgrimistas de espada en la modalidad masculina y a 35 equipos de al rededor del mundo.  Se pueden encontrar los RESULTADOS COMPLETOS DE LA COMPETICIÓN INDIVIDUAL AQUÍ  Y los RESULTADOS DE LA PRUEBA POR EQUIPOS AQUÍ  Novosjolov venció al segundo clasificado, el ucraniano Bogdan Nikishin en la ronda final, 1513. Nikishin superó a Kyoungdoo Park de Corea en la semifinal, 15-9, mientras que Novosjolov derrotó a Bas Verwijlen de Holanda, 15-13. En la modalidad masculina por equipos, Hungría ganó el oro en la competición final, venciendo al equipo masculino de corea por un punto, 30-29. Corea superó a Israel en las semifinales, 45-36, mientras que Hungría derrotó a Ucrania, 23-21. Ucrania se  llevó la medalla de bronce tras ganar contra Israel, 38-36. Los ocho mejores clasificados de espada en la modalidad masculina individual del Desafío SNCF Reseau de la Copa de Mundo masculina de espada incluye a Nikolai Novosjolov (EST, oro), Bogdan Nikishin (UCR, plata), Kyoungdoo Park (COR, bronce), Bas Verwijlen (HOL, bronce), Andrea Santarelli (ITA), Curtis McDowald (EE.UU), Daniel Berta (HUN), y Byeungchan Jung (COR). Los ocho mejores clasificados de la modalidad masculina por equipos sitúan a Hungría primero (oro), seguido de Corea (plata), Ucrania (bronce), Israel, Francia, República Checa, China y Suiza. ■ W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <p>
        El esgrimista estonio dos veces campeón del mundo Nikolai Novosjolov se llevó el oro en el desafío SNFC Reseau de espada de la Copa del Mundo en la modalidad masculina en París, junto con el equipo de Hungría que ganó el evento en la modalidad por equipos.
        </p>
        <p>
        La competición, que tuvo lugar en el Stade Pierre de Coubertin, atrajo a más de 325 esgrimistas de espada en la modalidad masculina y a 35 equipos de al rededor del mundo.
        </p>
        <p>
        Novosjolov venció al segundo clasificado, el ucraniano Bogdan Nikishin en la ronda final, 15-13. Nikishin superó a Kyoungdoo Park de Corea en la semifinal, 15-9, mientras que Novosjolov derrotó a Bas Verwijlen de Holanda, 15-13.
        </p>
        <p>
        En la modalidad masculina por equipos, Hungría ganó el oro en la competición final, venciendo al equipo masculino de corea por un punto, 30-29. Corea superó a Israel en las semifinales, 45-36, mientras que Hungría derrotó a Ucrania, 23-21. Ucrania se llevó la medalla de bronce tras ganar contra Israel, 38-36.
        </p>
        <p>      
        Los ocho mejores clasificados de espada en la modalidad masculina individual del Desafío SNCF Reseau de la Copa de Mundo masculina de espada incluye a Nikolai Novosjolov (EST, oro), Bogdan Nikishin (UCR, plata), Kyoungdoo Park (COR, bronce), Bas Verwijlen (HOL, bronce), Andrea Santarelli (ITA), Curtis McDowald (EE.UU), Daniel Berta (HUN), y Byeungchan Jung (COR).
        </p>
        <p>          
        Los ocho mejores clasificados de la modalidad masculina por equipos sitúan a Hungría primero (oro), seguido de Corea (plata), Ucrania (bronce), Israel, Francia, República Checa, China y Suiza.
        </p>
        <p><a href="http://fie.org/es/competitions/2018/111/results/rank" target="_blank">Se peuden encontrar los resultados completos de la competición individual aquí</a></p>
        <p><a href="http://fie.org/es/competitions/2018/753/results/rank" target="_blank">Y los resultados de la prueba por equipos aquí</a></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Madrid, España",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg44.jpg",
      "zoom": null,
      "content": `
      <img id="44-next" class="halfScale pointer" style="top:847px;left:1411px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <img id="44-title" class="halfScale" style="top:88px;left:83px" src="/106/es/static/_content/44-title.png">
      <img id="44-sub" class="halfScale" style="top:654px;left:126px" src="/106/es/static/_content/44-sub.png">
      <img id="44-line" class="halfScale" style="top:650px;left:85px" src="/106/es/static/_content/all-4line.png">
      `,
      "script": `
      function onPageEnter() {
        page44Anim = new TimelineMax()
        page44Anim
          .fromTo(idOf("44-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("44-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("44-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("44-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page44Anim.stop()
      }
      `,
      "searchText": "COPA DEL MUNDO EL ITALIANO BERRE Y EL EQUIPO DE COREA SE HACEN CON EL ORO EN LA COPA DEL MUNDO MASCULINA DE ESGRIMA DE SABLE MADRID, ESPAÑA 18 AL 20 DE MAYO DE 2018 SABLE MASCULINO"
      ,
      "mobileHtml": `
        <h2>EL ITALIANO BERRE Y EL EQUIPO DE COREA SE HACEN CON EL ORO EN LA COPA DEL MUNDO MASCULINA DE ESGRIMA DE SABLE</h2>
        <p><b>
        MADRID, ESPAÑA <br>
        18 AL 20 DE MAYO DE 2018 <br>       
        SABLE MASCULINO
        </b></p>
        <img src="/106/es/static/_mobile/pg44-madrid.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Madrid, España",
      "index": 43,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg45.jpg",
      "zoom": null,
      "content": `
      <img id="45-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="45-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="45-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>

      <a href="http://fie.org/es/competitions/2018/474/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:732px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <a href="http://fie.org/es/competitions/2018/853/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:940px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page45Anim = new TimelineMax()
        page45Anim
          .fromTo(idOf("45-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page45Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "COPA DEL MUNDO MADRID, ESPAÑA 2/2  El esgrimista de sable italiano Enrico Berre ganó la medalla de oro de sable en la modalidad masculina individual en la Copa del Mundo celebrada en Madrid, junto con el equipo coreano de sable masculino que ganó la competición por equipos. Más de 200 esgrimistas y 26 equipos compitieron en el evento, el cual tuvo lugar en el Centro Deportivo Vallehermoso GO FIT de la Ciudad.  Se pueden encontrar los RESULTADOS COMPLETOS DE LA COMPETICIÓN INDIVIDUAL AQUÍ  Y los RESULTADOS DE LA PRUEBA POR EQUIPOS AQUÍ  Berre derrotó al Campeón del Mundo, el ruso Veniamin Reshetnikov en la competición final de la modalidad individual, 15-11. Reshetnikov casi superó al segundo clasificado, el coreano Sanguk Oh en la semifinal, 15-14, mientras que Berre obtuvo la misma puntuación contra el americano Daryl Homer en la misma ronda. Particularmente, Berre también venció al mejor clasificado, el coreano Bongil Oh en la ronda de 32, 15-11. En la modalidad masculina de sable, Corea se llevó el oro, ganando a Italia, 45-41, en la competición final. En las semifinales, Italia venció a Hungría, 45-35 mientras que Corea eliminó a Rusia, 45-32 Rusia se llevó a casa el bronce, superando a Hungría, 45-35.  Los ocho mejores clasificados de sable en la modalidad masculina individual de la Copa del Mundo en Madrid incluyen a Enrico Berre (ITA, oro), Veniamin Reshetnikov (RUS, plata), Daryl Homer (EE.UU, bronce), Sanguk Oh (COR, bronce), Eli Dershwitz (EE.UU) Vincent Anstett (FRA), Kamil Ibragimov (RUS), y Konstantin Lokhanov (RUS). Los ocho mejores clasificados de sable en la modalidad masculina por equipos sitúa primera a Corea (oro), seguida de Italia (plata), Rusia (bronce), Hungría, Alemania, EE.UU, Francia e Irán. ■ W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <p>          
        El esgrimista de sable italiano Enrico Berre ganó la medalla de oro de sable en la modalidad masculina individual en la Copa del Mundo celebrada en Madrid, junto con el equipo coreano de sable masculino que ganó la competición por equipos.
        </p>
        <p>        
        Más de 200 esgrimistas y 26 equipos compitieron en el evento, el cual tuvo lugar en el Centro Deportivo Vallehermoso GO FIT de la Ciudad.
        </p>
        <p>          
        Berre derrotó al Campeón del Mundo, el ruso Veniamin Reshetnikov en la competición final de la modalidad individual, 15-11.  Reshetnikov casi superó al segundo clasificado, el coreano Sanguk Oh en la semifinal, 15-14, mientras que Berre obtuvo la misma puntuación contra el americano Daryl Homer en la misma ronda.
        Particularmente, Berre también venció al mejor clasificado, el coreano Bongil Oh en la ronda de 32, 15-11.
        </p>
        <p>        
        En la modalidad masculina de sable, Corea se llevó el oro, ganando a Italia, 45-41, en la competición final. En las semifinales, Italia venció a Hungría, 45-35 mientras que Corea eliminó a Rusia, 45-32 Rusia se llevó a casa el bronce, superando a Hungría, 45-35.
        </p>
        <p>          
        Los ocho mejores clasificados de sable en la modalidad masculina individual de la Copa del Mundo en Madrid incluyen a Enrico Berre (ITA, oro), Veniamin Reshetnikov (RUS, plata), Daryl Homer (EE.UU, bronce), Sanguk Oh (COR, bronce), Eli Dershwitz (EE.UU) Vincent Anstett (FRA), Kamil Ibragimov (RUS), y Konstantin Lokhanov (RUS).
        </p>
        <p>
        Los ocho mejores clasificados de sable en la modalidad masculina por equipos sitúa primera a Corea (oro), seguida de Italia (plata), Rusia (bronce), Hungría, Alemania, EE.UU, Francia e Irán.
        </p>
        <p><a href="http://fie.org/es/competitions/2018/474/results/rank" target="_blank">Se peuden encontrar los resultados completos de la competición individual aquí</a></p>
        <p><a href="http://fie.org/es/competitions/2018/853/results/rank" target="_blank">Y los resultados de la prueba por equipos aquí</a></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Tunéz, Tunéz",
      "index": 44,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg46.jpg",
      "zoom": null,
      "content": `
      <img id="46-next" class="halfScale pointer" style="top:847px;left:1411px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      <img id="46-title" class="halfScale" style="top:109px;left:87px" src="/106/es/static/_content/46-title.png">
      <img id="46-sub" class="halfScale" style="top:178px;left:988px" src="/106/es/static/_content/46-sub.png">
      <img id="46-line" class="halfScale" style="top:178px;left:946px" src="/106/es/static/_content/all-3line.png">
      `,
      "script": `
      function onPageEnter() {
        page46Anim = new TimelineMax()
        page46Anim
          .fromTo(idOf("46-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("46-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("46-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("46-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page46Anim.stop()
      }
      `,
      "searchText": "COPA DEL MUNDO  LA FRANCESA BRUNET Y EL EQUIPO RUSO TÚNEZ, TÚNEZ GANAN EL ORO EN TÚNEZ  1 AL 3 DE JUNIO DE 2018 SABLE FEMENINO"
      ,
      "mobileHtml": `
        <h2>LA FRANCESA BRUNET Y EL EQUIPO RUSO GANAN EL ORO EN TÚNEZ</h2>
        <p><b>
        TÚNEZ, TÚNEZ <br>
        1 AL 3 DE JUNIO DE 2018 <br>       
        SABLE FEMENINO
        </b></p>
        <img src="/106/es/static/_mobile/pg46-tunis.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Tunéz, Tunéz",
      "index": 45,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg47.jpg",
      "zoom": null,
      "content": `
      <img id="47-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/14-next.png" onclick="Publish.goToNextPage()">
      
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="47-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/13-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="47-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/13-fb.png">
      </a>

      <a href="http://fie.org/es/competitions/2018/471/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:732px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <a href="http://fie.org/es/competitions/2018/760/results/rank" target="_blank">
      <img class="halfScaleC pulse animatedpulse" style="top:940px;left:84px" src="/106/es/static/_content/14-trophy.png">
      </a>
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page47Anim = new TimelineMax()
        page47Anim
          .fromTo(idOf("47-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page47Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "COPA DEL MUNDO TÚNEZ, TÚNEZ 2/2  La esgrimista de sable francesa Manon Brunet se llevó la medalla de oro individual en la Copa del Mundo femenina de sable de Túnez en Túnez, donde el equipo ruso ganó el oro en la competición por equipos. Más de 150 de las mejores esgrimistas de sable participaron en la competición, que también atrajo a 21 equipos internacionales. La competición individual tuvo lugar en el famoso Teatro Romano de Cartago. Brunet se enfrentó en la final a la número uno Olga Kharlan, tres veces campeona del mundo, y la derrotó por un solo toque, 15-14. Kharlan había superado a la rumana Bianca Pascu en la semifinal en otro combate ajustado, por 15-14, mientras que Brunet venció a su compañera de equipo, Margaux Rifkiss, por 15-5. En los cuartos de final, Kharlan derrotó a la medallista de oro  olímpica rusa Yana Egorian con una puntuación de 15-13, mientras que la medallista de oro olímpica coreana Jiyeon Kim perdió contra Pascu también con un resultado de 15-13 y Brunet derrotó a la dos veces campeona del mundo Sofya Velikaya, por 15-7. En la competición por equipos, las rusas se llevaron el oro contra las francesas, con una puntuación final de 45-35. Italia perdió ante Rusia en semifinales, por 45-42, mientras que Francia venció a China, por 45-37. La medalla de bronce fue para Italia, que derrotó a China por 45-42.  Se pueden encontrar los RESULTADOS COMPLETOS DE LA COMPETICIÓN INDIVIDUAL AQUÍ  Las ocho mejores clasificadas de la Copa del Mundo femenina de sable de Túnez incluyen a Manon Brunet (FRA, oro), Olga Kharlan (UKR, plata), Bianca Pascu (ROU, bronce), Margaux Rifkiss (FRA, bronce), Cecilia Berder (FRA), Jiyeon Kim (KOR), Yana Egorian (RUS) y Sofya Velikaya (RUS).  Y los RESULTADOS DE LA PRUEBA POR EQUIPOS AQUÍ  Los ocho mejores equipos incluyen a Rusia (oro), Francia (plata), Italia (bronce), China, EE. UU., Hungría, Corea y Ucrania. ■ W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <p>        
        La esgrimista de sable francesa Manon Brunet se llevó la medalla de oro individual en la Copa del Mundo femenina de sable de Túnez en Túnez, donde el equipo ruso ganó el oro en la competición por equipos.
        </p>
        <p>          
        Más de 150 de las mejores esgrimistas de sable participaron en la competición, que también atrajo a 21 equipos internacionales. La competición individual tuvo lugar en el famoso Teatro Romano de Cartago.
        </p>
        <p>          
        Brunet se enfrentó en la final a la número uno Olga Kharlan, tres veces campeona del mundo, y la derrotó por un solo toque, 15-14. Kharlan había superado a la rumana Bianca Pascu en la semifinal en otro combate ajustado, por 15-14, mientras que Brunet venció a su compañera de equipo, Margaux Rifkiss, por 15-5. En los cuartos de final, Kharlan derrotó a la medallista de oro olímpica rusa Yana Egorian con una puntuación de 15-13, mientras que la medallista de oro olímpica coreana Jiyeon Kim perdió contra Pascu también con un resultado de 15-13 y Brunet derrotó a la dos veces campeona del mundo Sofya Velikaya, por 15-7.
        </p>
        <p>         
        En la competición por equipos, las rusas se llevaron el oro contra las francesas, con una puntuación final de 45-35. Italia perdió ante Rusia en semifinales, por 45-42, mientras que Francia venció a China, por 45-37. La medalla de bronce fue para Italia, que derrotó a China por 45-42.
        </p>
        <p>          
        Las ocho mejores clasificadas de la Copa del Mundo femenina de sable de Túnez incluyen a Manon Brunet (FRA, oro), Olga Kharlan (UKR, plata), Bianca Pascu (ROU, bronce), Margaux Rifkiss (FRA, bronce), Cecilia Berder (FRA), Jiyeon Kim (KOR), Yana Egorian (RUS) y Sofya Velikaya (RUS).
        </p>
        <p>        
        Los ocho mejores equipos incluyen a Rusia (oro), Francia (plata), Italia (bronce), China, EE.UU., Hungría, Corea y Ucrania.
        </p>
        <p><a href="http://fie.org/es/competitions/2018/471/results/rank" target="_blank">Se peuden encontrar los resultados completos de la competición individual aquí</a></p>
        <p><a href="http://fie.org/es/competitions/2018/760/results/rank" target="_blank">Y los resultados de la prueba por equipos aquí</a></p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 46,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg48.jpg",
      "zoom": null,
      "content": `
    <div class="addContentLink" style="bottom:249px;right:610px;width:283px; height:42px;">
      <a href="http://www.blue-gauntlet.com" target="_blank"></a>
    </div>
  
    `,
    "script": `
    function onPageEnter() {
      addContentLinks()
    }

    function onPageLeave() {
      removeContentLinks()
    }
      `,
      "searchText": ""
      ,
      "mobileHtml": `
      <a href="http://www.blue-gauntlet.com" target="_blank">
        <img id="bluegauntlet2img" src="/106/es/static/_mobile/pg48-bluegauntlet.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Conozca A Los Atletas",
      "index": 47,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg49.jpg",
      "zoom": null,
      "content": `
      <img id="49-next" class="halfScale pointer" style="top:951px;left:1411px" src="/106/es/static/_content/50-next.png" onclick="Publish.goToNextPage()">
      <img id="49-t1" class="halfScale" style="top:22px;left:48px" src="/106/es/static/_content/49-t1.png">
      <img id="49-t2" class="halfScale" style="top:656px;left:-299px" src="/106/es/static/_content/49-t2.png">
      <img id="49-t3" class="" style="top:821px;left:119px" src="/106/es/static/_content/49-t3-2.png">
    `,
    "script": `
    function onPageEnter() {
      page49Anim = new TimelineMax()
      page49Anim
        .fromTo(idOf("49-t1"), 0.5,{y:-100, opacity:0, }, {y:0, opacity:1},0.5)
        .fromTo(idOf("49-t2"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"-=0.2")
        .fromTo(idOf("49-t3"), 0.3,{x:200,opacity:0}, {x:0,opacity:1},"+=0.1")
        .fromTo(idOf("49-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, "-=0.2")
    }

    function onPageLeave() {
      page49Anim.stop()
      removeContentLinks()
    }
      `,
      "searchText": "CONOZCA A LOS ATLETAS KAZUYASU MINOBE"
      ,
      "mobileHtml":`
      <img src="/106/es/static/_mobile/pg49-interview.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Conozca A Los Atletas",
      "index": 48,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg50.jpg",
      "zoom": null,
      "content": `
      <img id="50-next" class="halfScale pointer" style="top:950px;left:606px" src="/106/es/static/_content/50-next.png" onclick="Publish.goToNextPage()">
      <img id="50-no1" class="halfScale" style="top:419px;left:732px" src="/106/es/static/_content/50-1.png">
      <img id="50-no2" class="halfScale" style="top:419px;left:732px; display: none;" src="/106/es/static/_content/50-2.png">
      <img id="50-no3" class="halfScale" style="top:419px;left:732px; display: none;" src="/106/es/static/_content/50-3.png">
      <img id="50-no4" class="halfScale" style="top:419px;left:732px; display: none;" src="/106/es/static/_content/50-4.png">
      <img id="50-no5" class="halfScale" style="top:419px;left:732px; display: none;" src="/106/es/static/_content/50-5.png">

      <div class="addContentLink" style="top: 443px; left: 1382px; width: 134px; height: 97px;" onclick="p50Sect1()"></div>
      <div class="addContentLink" style="top: 538px; left: 1382px; width: 134px; height: 97px;" onclick="p50Sect2()"></div>
      <div class="addContentLink" style="top: 629px; left: 1382px; width: 134px; height: 97px;" onclick="p50Sect3()"></div>
      <div class="addContentLink" style="top: 722px; left: 1382px; width: 134px; height: 97px;" onclick="p50Sect4()"></div>
      <div class="addContentLink" style="top: 813px; left: 1382px; width: 134px; height: 97px;" onclick="p50Sect5()"></div>

      `,
      "script": `
        function onPageEnter() {
          page50Anim = new TimelineMax()
        page50Anim
          .fromTo(idOf("50-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
        }

        function p50Sect1() {
          idOf("50-no1").style.display = "block"
          idOf("50-no2").style.display = "none"
          idOf("50-no3").style.display = "none"
          idOf("50-no4").style.display = "none"
          idOf("50-no5").style.display = "none"
      }

      function p50Sect2() {
        idOf("50-no1").style.display = "none"
        idOf("50-no2").style.display = "block"
        idOf("50-no3").style.display = "none"
        idOf("50-no4").style.display = "none"
        idOf("50-no5").style.display = "none"
    }

      function p50Sect3() {
        idOf("50-no1").style.display = "none"
        idOf("50-no2").style.display = "none"
        idOf("50-no3").style.display = "block"
        idOf("50-no4").style.display = "none"
        idOf("50-no5").style.display = "none"
    }

        function p50Sect4() {
          idOf("50-no1").style.display = "none"
          idOf("50-no2").style.display = "none"
          idOf("50-no3").style.display = "none"
          idOf("50-no4").style.display = "block"
          idOf("50-no5").style.display = "none"
      }

      function p50Sect5() {
        idOf("50-no1").style.display = "none"
        idOf("50-no2").style.display = "none"
        idOf("50-no3").style.display = "none"
        idOf("50-no4").style.display = "none"
        idOf("50-no5").style.display = "block"
      }

        function onPageLeave() {
          page50Anim.stop()
          removeContentLinks()
        }
      `,
      "searchText": "Con los próximos Juegos Olímpicos en Tokio en el 2020, ¿cómo se ha estado desarrollando la esgrima en Japón? Organizar los Juegos Olímpicos de 2020 en mi país de origen está generando un gran entusiasmo entre toda la comunidad deportiva. En la esgrima, estamos unidos en el esfuerzo por hacer que nuestra competición sea más reconocida y comprensible, con el fin de atraer a una gran audiencia a nuestras competiciones de esgrima. Como resultado, logramos atraer a un público amplio que fue 10 veces mayor con respecto al de la Copa del Mundo de florete masculino en Tokio y 5 veces mayor al de los Campeonatos de Japón, y hemos disfrutado compitiendo con gran vitoreo. Un ejemplo fue que nuestros tiradores que no compitieron se acercaron a la tribuna de los espectadores y explicaron los juegos a aquellos que vinieron a verlos por primera vez.  1 2 3 4 5"
      ,
      "mobileHtml": `
        <p><b>Con los próximos Juegos Olímpicos en Tokio en el 2020, ¿cómo se ha estado desarrollando la esgrima en Japón?</b></p>
        
        <p>
        Organizar los Juegos Olímpicos de 2020 en mi país de origen está generando un gran entusiasmo entre toda la comunidad deportiva. En la esgrima, estamos unidos en el esfuerzo por hacer que nuestra competición sea más reconocida y comprensible, con el fin de atraer a una gran audiencia a nuestras competiciones de esgrima. Como resultado, logramos atraer a un público amplio que fue 10 veces mayor con respecto al de la Copa del Mundo de florete masculino en Tokio y 5 veces mayor al de los Campeonatos de Japón, y hemos disfrutado compitiendo con gran vitoreo. Un ejemplo fue que nuestros tiradores que no compitieron se acercaron a la tribuna de los espectadores y explicaron los juegos a aquellos que vinieron a verlos por primera vez.</p>

        <p><b>¿Cómo te sientes acerca de que Japón sea anfitrión de los Juegos Olímpicos? ¿Cómo te afecta como atleta japonés de esgrima?</b></p>

        <p>
        Creo que es una oportunidad de oro para la comunidad de esgrima asiática en muchos aspectos. La población de esgrima en Japón y en Asia es todavía pequeña, pero los medios de comunicación están recogiendo la esgrima y mostrando más interés en nuestro deporte. El ambiente para que los esgrimistas puedan concentrarse en una competición está mejorando. En las competiciones nos motivan los ánimos que, en ocasiones, superan nuestras expectativas. Creo que es importante para nosotros difundir información sobre la esgrima y proporcionar información sobre nosotros mismos con el fin de obtener un apoyo más positivo.
        </p>

        <p><b>Has ganado tu segunda medalla de oro en la Copa del Mundo en Heidenheim, Alemania, a principios de este año en espada. ¿Cómo te sientes acerca de tus posibilidades de tener éxito en el futuro en la competición?</b></p>
        
        <p>
        Ganar mi segunda medalla de oro en la Copa del Mundo en Heidenheim me dio la sensación más clara de éxito en el mundo. Tengo 31 años, y creo que a partir de ahora será difícil para mí mejorar mi fuerza física y habilidades. Sin embargo, como sigo creyendo que puedo elevar y enriquecer aún más mi mente y experiencia, estoy apuntando a un nivel inesperado de logros para el futuro. También quiero servir como un líder para el resto de esgrimistas, que se animarán con mi ejemplo y pensarán que también pueden ganar una medalla algún día. 
        </p>

        <p><b>El Campeonato del Mundo 2018 será en Wuxi, China en julio. ¿Qué estáshaciendo para prepararte y cuáles son tus posibilidades de obtener una medalla?</b></p>
        
        <p>
        Nuestro objetivo es ganar una medalla por equipo en el Campeonato del Mundo de Wuxi.En lugar de tener un equipo en el que uno de los miembros del equipo toma la iniciativa, ponemos de nuestra parte para formar un equipo en el que todos los integrantes del equipo apoyen al equipo. Durante varios años, todos han mejorado en fuerza, y creemos que tenemos muchas posibilidades de ganar una medalla en la prueba de Wuxi.
        </p>

        <p><b>El éxito en la competencia del mundo de espada es relativamente nuevo para los tiradores japoneses. ¿A qué atribuyes su reciente aumento de éxito?</b></p>

        <p>
        Creo que un factor fue nuestro equipo de florete ganando la medalla de plata por equipo en los Juegos Olímpicos de Londres. Eso nos dio valor y confianza en nosotros mismos y demostró que incluso los japoneses podían ganar. Además, el entrenador Oleksandr Gorbachuk de Ucrania vino a Japón. Antes, en Japón teníamos una técnica y estrategia limitadas en espada. Por lo tanto, creo que los logros del entrenador Gorbachuk con los equipos japoneses han sido notables.
        </p>
        `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Verona",
      "index": 49,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg51.jpg",
      "zoom": null,
      "content": `
      <img id="51-next" class="halfScale pointer" style="top:847px;left:1412px" src="/106/es/static/_content/52-next.png" onclick="Publish.goToNextPage()">
      <img id="51-title" class="halfScale" style="top:112px;left:85px" src="/106/es/static/_content/51-t1.png">
      <img id="51-sub" class="halfScale" style="top:266px;left:126px" src="/106/es/static/_content/51-sub.png">
      <img id="51-line" class="halfScale" style="top:260px;left:89px" src="/106/es/static/_content/all-2line.png">
      `,
      "script": `
      function onPageEnter() {
        page51Anim = new TimelineMax()
        page51Anim
          .fromTo(idOf("51-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("51-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("51-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("51-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page51Anim.stop()
      }
      `,
      "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIONES NACIONALES  DÍA INTERNACIONAL DEL DEPORTE PARA EL DESARROLLO Y LA PAZ VERONA, ITALIA 6 DE ABRIL DE 2018"
      ,
      "mobileHtml": `
        <h2>Día Internacional del Deporte para el Desarrollo y la Paz</h2>
        <p><b>
        VERONA, ITALIA <br>
        6 DE ABRIL DE 2018       
        </b></p>
        <img src="/106/es/static/_mobile/pg51-fed.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Verona",
      "index": 50,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg52.jpg",
      "zoom": null,
      "content": `
      <img id="52-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/52-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="52-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/green-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="52-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/green-face.png">
      </a>

      <a href="http://www.april6.org/es" target="_blank">
      <img class="halfScaleC" style="top:786px;left:56px" src="/106/es/static/_content/green-globe.png">
      </a>

      <div class="addContentLink" style="bottom:110px;left:80px;width:105px; height:30px;">
        <a href="https://www.april6.org/es/carton-blanc.html" target="_blank"></a>
      </div>

      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page52Anim = new TimelineMax()
        page52Anim
          .fromTo(idOf("52-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page52Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  Hoy, 6 de abril, es el Día Internacional del Deporte para el Desarrollo y la Paz, cuando la organización mundial 'Paz y Deporte' anima a todos los deportes y a sus participantes a comprometerse con los conceptos de inclusión, equidad y paz.  Tap here to visite el sitio web Busque más información en las redes sociales en #WhiteCard  Sostener una tarjeta blanca, a la manera de un árbitro con una tarjeta de penalización, simboliza universalmente el poder positivo del deporte. La Federación Internacional de Esgrima, con motivo del Campeonato Mundial de Esgrima Júnior y Cadete 2018 en Verona, Italia, apoya esta iniciativa y celebra su misión.  compromiso con la Paz y el Deporte y lo que representa. En los campeonatos, los atletas, árbitros, entrenadores, oficiales y seguidores mostraron sus tarjetas blancas en una celebración unificada de esta noble empresa. Varios atletas olímpicos y campeonatos mundiales que visitaron aquí en Verona se unieron a la tradición de la WhiteCard. ■  En contraste con una tarjeta roja o negra, la #WhiteCard, por el contrario, es un gesto de W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <p>       
        Hoy, 6 de abril, es el Día Internacional del Deporte para el Desarrollo y la Paz, cuando la organización mundial "Paz y Deporte" anima a todos los deportes y a sus participantes a comprometerse con los conceptos de inclusión, equidad y paz.
        </p>
        <p>
        Sostener una tarjeta blanca, a la manera de un árbitro con una tarjeta de penalización, simboliza universalmente el poder positivo del deporte. La Federación Internacional de Esgrima, con motivo del Campeonato Mundial de Esgrima Júnior y Cadete 2018 en Verona, Italia, apoya esta iniciativa y celebra su misión.
        </p>
        <p>        
        En contraste con una tarjeta roja o negra, la #WhiteCard, por el contrario, es un gesto de compromiso con la Paz y el Deporte y lo que representa. En los campeonatos, los atletas, árbitros, entrenadores, oficiales y seguidores mostraron sus tarjetas blancas en una celebración unificada de esta noble empresa. Varios atletas olímpicos y campeonatos mundiales que visitaron aquí en Verona se unieron a la tradición de la WhiteCard.
        </p>
        <p><a href="http://www.april6.org" target="_blank">Pulse aquí para ir a la web</a></p>
      `  
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "San Salvador, El Salvador",
      "index": 51,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg53.jpg",
      "zoom": null,
      "content": `
      <img id="53-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/green-next-arrow.png" onclick="Publish.goToNextPage()">
      <img id="53-title" class="halfScale" style="top:406px;left:87px" src="/106/es/static/_content/53-t1.png">
      <img id="53-sub" class="halfScale" style="top:235px;left:86px" src="/106/es/static/_content/53-s1.png">
      <img id="53-sub2" class="halfScale" style="top:729px;left:120px" src="/106/es/static/_content/53-s2.png">
      <img id="53-line" class="halfScale" style="top:725px;left:84px" src="/106/es/static/_content/all-2line.png">
      `,
      "script": `
      function onPageEnter() {
        page53Anim = new TimelineMax()
        page53Anim
          .fromTo(idOf("53-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("53-sub2"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("53-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("53-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("53-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page53Anim.stop()
      }
      `,
      "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIONES NACIONALES  CONFEDERACIÓN PANAMERICANA DE ESGRIMA:  UN FUERTE COMIENZO DE 2018 SAN SALVADOR, EL SALVADOR 23 DE MARZO DE 2018"
      ,
      "mobileHtml": `
        <h2>CONFEDERACIÓN PANAMERICANA DE ESGRIMA:
        UN FUERTE COMIENZO DE 2018</h2>
        <p><b>
        SAN SALVADOR, EL SALVADOR <br>
        23 DE MARZO DE 2018      
        </b></p>
        <img src="/106/es/static/_mobile/pg53-pan.jpg">
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "San Salvador, El Salvador",
      "index": 52,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg54.jpg",
      "zoom": null,
      "content": `
      <img id="54-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/green-next-arrow.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="54-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/green-tw.png">
      </a>
      
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="54-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/green-face.png">
      </a>
      <div class="addContentLink" style="bottom:231px;left:568px;width:55px; height:30px;" onclick="Publish.goToPage(54); setTimeout(function(){Publish.openVideo('https://www.youtube.com/embed/NgHh85k-2Ow');}, 200)"></div>
      <div class="addContentLink" style="bottom:231px;left:760px;width:53px; height:30px;" onclick="Publish.goToPage(54); setTimeout(function(){Publish.openVideo('https://www.youtube.com/embed/lfysx__fbts');}, 200)"></div>

      `,
      "script": `
      function onPageEnter() {
        page54Anim = new TimelineMax()
        page54Anim
          .fromTo(idOf("54-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page54Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/3  La Confederación Panamericana (CPE) informa de un primer trimestre de 2018 muy ocupado y, al mismo tiempo, proyecta un año igualmente lleno de actividades. El presidente de CPE Vitaly Logvin viajó por la región en los últimos meses, realizando visitas oficiales a Guatemala, Nicaragua y El Salvador, para pasar tiempo con los presidentes de las federaciones nacionales, así como para reunirse con las autoridades de los funcionarios del Comité Olímpico de cada país, junto con los líderes de los institutos nacionales de deportes. Cabe destacar que, a principios de febrero, la CPE organizó una competición experimental de espada y florete con nuevas y diferentes reglas de enfrentamiento, así como un enfoque innovador de tiempos y combates. La idea es explorar formas de mejorar el interés de la esgrima y atraer al público en todo el mundo. Se realizaron dos vídeos de YouTube de estos experimentos, a los que se puede acceder aquí para espada y aquí para florete. La CPE tiene planes sólidos para el año, en cooperación con las federaciones nacionales en todo el continente americano. Algunos de estos  eventos ya han tenido lugar, mientras que otros ya se han completado: Campeonatos Panamericanos Júnior y Cadetes (Costa Rica); el Tercer seminario sobre arbitraje y un curso para entrenadores titulado 'De la escuela a los Juegos Olímpicos' en Ecuador; un nuevo curso para entrenadores de sable que se celebrará en El Salvador entre abril y mayo; los Juegos Sudamericanos entre mayo y julio, que se celebrarán en Cochabamba, Bolivia; y los Juegos Centroamericanos en julio, que se realizan en Barranquilla, Colombia.  Ecuador Leads with Teaching Events Supervisado por la FIE, Quito, Ecuador, organizó un programa de desarrollo que beneficia a toda la región continental, titulado 'Cuarto seminario sobre arbitraje'. El estimado árbitro de la FIE Juan Carlos Ríos Rivera (MEX) enseñó el seminario, al"
      ,
      "mobileHtml":`
        <p>        
        La Confederación Panamericana (CPE) informa de un primer trimestre de 2018 muy ocupado y, al mismo tiempo, proyecta un año igualmente lleno de actividades.
        </p>
        <p>     
        El presidente de CPE Vitaly Logvin viajó por la región en los últimos meses, realizando visitas oficiales a Guatemala, Nicaragua y El Salvador, para pasar tiempo con los presidentes de las federaciones nacionales, así como para reunirse con las autoridades de los funcionarios del Comité Olímpico de cada país, junto con los líderes de los institutos nacionales de deportes.
        </p>
        <p>         
        Cabe destacar que, a principios de febrero, la CPE organizó una competición experimental de espada y florete con nuevas y diferentes reglas de enfrentamiento, así como un enfoque innovador de tiempos y combates. La idea es explorar formas de mejorar el interés de la esgrima y atraer al público en todo el mundo. Se realizaron dos vídeos de YouTube de estos experimentos, a los que se puede acceder aquí para espada y aquí para florete.
        </p>
        <p>          
        La CPE tiene planes sólidos para el año, en cooperación con las federaciones nacionales en todo el continente americano. Algunos de estos eventos ya han tenido lugar, mientras que otros ya se han completado: Campeonatos Panamericanos Júnior y Cadetes (Costa Rica); el Tercer seminario sobre arbitraje y un curso para entrenadores titulado "De la escuela a los Juegos Olímpicos" en Ecuador; un nuevo curso para entrenadores de sable que se celebrará en El Salvador entre abril y mayo; los Juegos Sudamericanos entre mayo y julio, que se celebrarán en Cochabamba, Bolivia; y los Juegos Centroamericanos en julio, que se realizan en Barranquilla, Colombia.
        </p>
        <p>         
        Ecuador es el líder en eventos de enseñanza.
        Supervisado por la FIE, Quito, Ecuador, organizó un programa de desarrollo que beneficia a toda la región continental, titulado "Cuarto seminario sobre arbitraje". El estimado árbitro de la FIE Juan Carlos Ríos Rivera (MEX) enseñó el seminario, al que asistieron 21 árbitros (incluyendo algunos entrenadores). Al participar en el evento, los asistentes y sus regiones se benefician de poder convertirse esencialmente en educadores, capaces de demostrar técnicas mejoradas y un conocimiento más profundo del arbitraje. Esta mejor comprensión ayuda no solo a educar a los oficiales de esgrima de su país, a los esgrimistas y a los entrenadores, sino que también les ayuda a desarrollar mejores resultados competitivos y un conocimiento más amplio del deporte en general.
        </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "San Salvador, El Salvador",
      "index": 53,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg55.jpg",
      "zoom": null,
      "content": `<img id="55-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/52-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="55-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/green-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="55-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/green-face.png">
      </a>
       
      <img id="55-you" class="halfScaleC pointer" onclick="Publish.openVideo('https://www.youtube.com/embed/NgHh85k-2Ow')" style="top:683px;left:44px" src="/106/es/static/_content/green-you.png">

      <img id="55-you" class="halfScaleC pointer" onclick="Publish.openVideo('https://www.youtube.com/embed/lfysx__fbts')" style="top:870px;left:44px" src="/106/es/static/_content/green-you.png">
      
      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page55Anim = new TimelineMax()
        page55Anim
          .fromTo(idOf("55-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page55Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 3/3  Tap to play Epee video  Tap to play Foil video  que asistieron 21 árbitros (incluyendo algunos entrenadores). Al participar en el evento, los asistentes y sus regiones se benefician de poder convertirse esencialmente en educadores, capaces de demostrar técnicas mejoradas y un conocimiento más profundo del arbitraje. Esta mejor comprensión ayuda no solo a educar a los oficiales de esgrima de su país, a los esgrimistas y a los entrenadores, sino que también les ayuda a desarrollar mejores resultados competitivos y un conocimiento más amplio del deporte en general. Los participantes en el curso tomaron exámenes específicos de armas con un enfoque en el arbitraje de la FIE y sus exámenes. La CPE y la FIE están trabajando juntos para desarrollar su supervisión y difusión de 'actividades de conocimiento' en varios países confederados, y ambas organizaciones expresaron su gratitud a la Federación de Esgrima de Ecuador por ayudar a que el programa despegue. El objetivo es alcanzar 20 programas para finales de 2018 y beneficiar a tantos esgrimistas en la región panamericana como sea posible. El evento de Ecuador tuvo lugar del 15 al 23 de febrero, específicamente enfocado en desarrollar conocimiento de procesos psicológicos, planificación, métodos de enseñanza, táctica/  ejecución, y un objetivo fundamental de mejorar las habilidades de los entrenadores para planear y diseñar estrategias, metas y objetivos de esgrima viables. El 22 de febrero se celebró en Quito el evento del ayuntamiento 'De la escuela a los Juegos Olímpicos', en el que se presentó la esgrima a los niños de la zona. Se llevaron a cabo dos eventos de esgrima en dos escuelas, una primaria y otra secundaria, que llegaron a una variedad de espectadores, 350 estudiantes en total, y hasta 200 niños de entre 4 y 16 años. Los miembros del equipo nacional de esgrima ecuatoriano y otros atletas de alto rendimiento ayudaron con el programa, utilizando equipos de enseñanza innovadores diseñados y distribuidos por Absolute Fencing Gear. El evento fue tan exitoso que capturó la atención de muchas otras escuelas y clubes en Quito, y la Federación Ecuatoriana de Esgrima ha solicitado más eventos para llevarse a cabo. Además, el programa educa a los maestros regionales de educación física con información básica sobre esgrima y brinda asesoramiento técnico a las escuelas sobre programas de esgrima. ■  W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <p>
        Los participantes en el curso tomaron exámenes específicos de armas con un enfoque en el arbitraje de la FIE y sus exámenes. La CPE y la FIE están trabajando juntos para desarrollar su supervisión y difusión de "actividades de conocimiento" en varios países confederados, y ambas organizaciones expresaron su gratitud a la Federación de Esgrima de Ecuador por ayudar a que el programa despegue. El objetivo es alcanzar 20 programas para finales de 2018 y beneficiar a tantos esgrimistas en la región panamericana como sea posible.
        </p>
        <p>         
        El evento de Ecuador tuvo lugar del 15 al 23 de febrero, específicamente enfocado en desarrollar conocimiento de procesos psicológicos, planificación, métodos de enseñanza, táctica/ejecución, y un objetivo fundamental de mejorar las habilidades de los entrenadores para planear y diseñar estrategias, metas y objetivos de esgrima viables.
        </p>
        <p>          
        El 22 de febrero se celebró en Quito el evento del ayuntamiento "De la escuela a los Juegos Olímpicos", en el que se presentó la esgrima a los niños de la zona. Se llevaron a cabo dos eventos de esgrima en dos escuelas, una primaria y otra secundaria, que llegaron a una variedad de espectadores, 350 estudiantes en total, y hasta 200 niños de entre 4 y 16 años. Los miembros del equipo nacional de esgrima ecuatoriano y otros atletas de alto rendimiento ayudaron con el programa, utilizando equipos de enseñanza innovadores diseñados y distribuidos por Absolute Fencing Gear.
        </p>
        <p>
        El evento fue tan exitoso que capturó la atención de muchas otras escuelas y clubes en Quito, y la Federación Ecuatoriana de Esgrima ha solicitado más eventos para llevarse a cabo. Además, el programa educa a los maestros regionales de educación física con información básica sobre esgrima y brinda asesoramiento técnico a las escuelas sobre programas de esgrima.
        </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Verona",
      "index": 54,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg56.jpg",
      "zoom": null,
      "content": `
      <img id="56-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/green-next-arrow.png" onclick="Publish.goToNextPage()">
      <img id="56-title" class="halfScale" style="top:138px;left:88px" src="/106/es/static/_content/56-t1.png">
      <img id="56-sub" class="halfScale" style="top:350px;left:358px" src="/106/es/static/_content/56-s1.png">
      <img id="56-line" class="halfScale" style="top:344px;left:323px" src="/106/es/static/_content/all-2line.png">
      `,
      "script": `
      function onPageEnter() {
        page56Anim = new TimelineMax()
        page56Anim
          .fromTo(idOf("56-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("56-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("56-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("56-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page56Anim.stop()
      }
      `,
      "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIONES NACIONALES  DONA TU EQUIPAMIENTO DE ESGRIMA VERONA, ITALIA 4 DE ABRIL DE 2018"
      ,
      "mobileHtml": `
        <h2>DONA TU EQUIPAMIENTO DE ESGRIMA</h2>
        <p><b>
        VERONA, ITALIA <br>
        4 DE ABRIL DE 2018    
        </b><p>
        <img src="/106/es/static/_mobile/pg56-donate.jpg">
        `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Verona",
      "index": 55,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg57.jpg",
      "zoom": null,
      "content": `
      <img id="57-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/green-next-arrow.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="57-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/green-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="57-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/green-face.png">
      </a>
       

      `,
      "script": `
      function onPageEnter() {
        page57Anim = new TimelineMax()
        page57Anim
          .fromTo(idOf("57-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page57Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/4  Centrándose en el lema ‘Desarrollando nuestras nuevas federaciones’, la primera edición de Dona tu Equipamiento de Esgrima 2018 llegó a su fin en Verona. Tal como en las ediciones anteriores, los tiradores tuvieron la opción de elegir el programa que querían apoyar con su donación, que se asignó de acuerdo con su elección. En seis meses recibirán el primer informe sobre el progreso del proyecto que adoptaron. 124 materiales fueron donados por tiradores y otros donantes individuales, mientras que la contribución de los dos proveedores que se unieron al programa - PBT Fencing y Uhlmann Fencing - ascendió a 241, distribuidos por igual entre los siete beneficiarios de los proyectos: Benín Ecuador México Marruecos  Paraguay Filipinas Samoa Americana Samoa  La FIE le debe un especial agradecimiento especial a Gamil Elzewftawi, miembro de la Comisión SEMI de la FIE, que verificó todas las donaciones una por una, para asegurarse  de que todavía fueran funcionales y seguras de usar. Bartosz Piasecki, cabeza de delegación del equipo de Noruega, abrió las donaciones en Verona. Muchos VIP del mundo de la esgrima contribuyeron al proyecto, entre ellos Krisztian Kulcsar, presidente de la NOC húngara y ex directora deportiva de la FIE y la joven superestrella de México, Natalia Botello, con un total de cinco medallas en los Campeonatos del Mundo Junior y Cadete en los últimos dos años. Representantes de las Comisiones y Consejos de la FIE respaldaron activamente la acción que incluyó lo siguiente:"
      ,
      "mobileHtml":`
        <p>          
        Centrándose en el lema “Desarrollando nuestras nuevas federaciones”, la primera edición de Dona tu Equipamiento de Esgrima 2018 llegó a su fin en Verona.
        </p>
        <p>         
        Tal como en las ediciones anteriores, los tiradores tuvieron la opción de elegir el programa que querían apoyar con su donación, que se asignó de acuerdo con su elección. En seis meses recibirán el primer informe sobre el progreso del proyecto que adoptaron.
        </p>
        <p>         
        124 materiales fueron donados por tiradores y otros donantes individuales, mientras que la contribución de los dos proveedores que se unieron al programa - PBT Fencing y Uhlmann Fencing - ascendió a 241, distribuidos por igual entre los siete beneficiarios de los proyectos:
        </p>
        <ul>
          <li>Benín</li>
          <li>Ecuador</li>
          <li>México</li>
          <li>Marruecos</li>
          <li>Paraguay</li>
          <li>Filipinas</li>
          <li>Samoa Americana</li>
          <li>Samoa</li>
        </ul>
        <p>         
        La FIE le debe un especial agradecimiento especial a Gamil Elzewftawi, miembro de la Comisión SEMI de la FIE, que verificó todas las donaciones una por una, para asegurarse de que todavía fueran funcionales y seguras de usar.
        </p>
        <p>
        Bartosz Piasecki, cabeza de delegación del equipo de Noruega, abrió las donaciones en Verona.
        </p>
        <p>        
        Muchos VIP del mundo de la esgrima contribuyeron al proyecto, entre ellos Krisztian Kulcsar, presidente de la NOC húngara y ex directora deportiva de la FIE y la joven superestrella de México, Natalia Botello, con un total de cinco medallas en los Campeonatos del Mundo Junior y Cadete en los últimos dos años.
        </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Verona",
      "index": 56,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg58.jpg",
      "zoom": null,
      "content": `
      <img id="58-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/green-next-arrow.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="58-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/green-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="58-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/green-face.png">
      </a>
       
      `,
      "script": `
      function onPageEnter() {
        page58Anim = new TimelineMax()
        page58Anim
          .fromTo(idOf("58-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page58Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 3/4  Yannick Borrel, Olga Kharlan y Gwladys Sakoa, miembros de la Comisión de Atletas de la FIE, que se reunieron en Verona el 7 de abril El Dr. Gennady Tyshler, presidente del Consejo de Entrenadores de la FIE y Yusuke Aoki, miembro del Consejo de Entrenadores de la FIE. La Federación China de Esgrima brindó una generosa donación de nuevos equipos. Samoa Americana, la última federación afiliada (la membresía provisional se otorgó en febrero  pasado) recibió una cálida bienvenida a la FIE, siendo el país que ha atraído a más donantes. El aislamiento geográfico de Samoa y Samoa Americana hace que sea particularmente difícil para estos archipiélagos adquirir equipos, por lo tanto, las donaciones de material usado desempeñan un papel crucial en el desarrollo de la esgrima en las islas. Una mención especial es merecida para dos federaciones nacionales cuyas acciones proporcionaron un impacto significativo al programa: La Federación de Esgrima de Argelia proporcionó el apoyo logístico necesario para garantizar que el equipo recogido para Benín llegue a África, dado que ningún representante pudo llegar a Verona. USA Fencing realizó un trabajo increíble al informar e involucrar a sus atletas, antes de la partida a Verona. Muchos esgrimistas y padres de esgrimistas contactaron a la FIE con mucha anticipación para averiguar cómo podían donar. El resultado fue que el número de tiradores estadounidenses que hicieron donaciones fue significativamente mayor que el de cualquier otra nación. Jenny y Claire Beddingfield, madre e"
      ,
      "mobileHtml":`
        <p>         
        Representantes de las Comisiones y Consejos de la FIE respaldaron activamente la acción que incluyó lo siguiente:
        </p>
        <ul>
          <li>Yannick Borrel, Olga Kharlan y Gwladys Sakoa, miembros de la Comisión de Atletas de la FIE, que se reunieron en Verona el 7 de abril</li><br>
          <li>El Dr. Gennady Tyshler, presidente del Consejo de Entrenadores de la FIE y Yusuke Aoki, miembro del Consejo de Entrenadores de la FIE.</li>
        </ul>
        <p>       
        La Federación China de Esgrima brindó una generosa donación de nuevos equipos.
        </p>
        <p>    
        Samoa Americana, la última federación afiliada (la membresía provisional se otorgó en febrero pasado) recibió una cálida bienvenida a la FIE, siendo el país que ha atraído a más donantes. El aislamiento geográfico de Samoa y Samoa Americana hace que sea particularmente difícil para estos archipiélagos adquirir equipos, por lo tanto, las donaciones de material usado desempeñan un papel crucial en el desarrollo de la esgrima en las islas.
        </p>
        <p>           
        Una mención especial es merecida para dos federaciones nacionales cuyas acciones proporcionaron un impacto significativo al programa:
        </p>
        <ul>
          <li>        
          La Federación de Esgrima de Argelia proporcionó el apoyo logístico necesario para garantizar que el equipo recogido para Benín llegue a África, dado que ningún representante pudo llegar a Verona.
          </li><br>
          <li>          
          USA Fencing realizó un trabajo increíble al informar e involucrar a sus atletas, antes de la partida a Verona. Muchos esgrimistas y padres de esgrimistas contactaron a la FIE con mucha anticipación para averiguar cómo podían donar. El resultado fue que el número de tiradores estadounidenses que hicieron donaciones fue significativamente mayor que el de cualquier otra nación. Jenny y Claire Beddingfield, madre e hija, expresaron su entusiasmo por el programa y autorizaron a la FIE a compartir públicamente el siguiente correo electrónico:
          </li>
        </ul>
        <p>          
        Acabamos de regresar a casa y queremos agradecerle por un programa tan genial.
        </p>
        <p>
        Claire recopiló artículos de sus compañeros de club en LAIFC (Los Angeles International Fencing Club) en Los Ángeles y estaba muy agradecida de poder ayudar a otros esgrimistas de todo el mundo.
        </p>
        <p>         
        A ella le gustaría darles un poco a todos estos países, y quizás dividir ítems si es posible.
        </p>
        <p>De no ser posible, [dad] a cualquier país que usted y la FIE consideren que más necesita estos artículos.</p>
        <p>      
        Todo lo mejor,
        </p>
        <p>
          <b>Jenny Beddingfield y Claire Beddingfield - EE.UU.</b>
        </p>
        <p>        
        El próximo evento de recolección tendrá lugar en Wuxi (CHN) en el Campeonato del Mundo de Esgrima Senior en julio ¡Sigamos desarrollando nuestras federaciones!
        </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Verona",
      "index": 57,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg59.jpg",
      "zoom": null,
      "content": `<img id="59-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/52-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="59-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/green-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="59-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/green-face.png">
      </a>

      <div class="addContentLink" style="bottom:13px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
       
      `,
      "script": `
      function onPageEnter() {
        page59Anim = new TimelineMax()
        page59Anim
          .fromTo(idOf("59-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page59Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 4/4  hija, expresaron su entusiasmo por el programa y autorizaron a la FIE a compartir públicamente el siguiente correo electrónico:  De no ser posible, [dad] a cualquier país que usted y la FIE consideren que más necesita estos artículos.  Acabamos de regresar a casa y queremos agradecerle por un programa tan genial.  Todo lo mejor,  Claire recopiló artículos de sus compañeros de club en LAIFC (Los Angeles International Fencing Club) en Los Ángeles y estaba muy agradecida de poder ayudar a otros esgrimistas de todo el mundo.  Jenny Beddingfield y Claire Beddingfield - EE.UU. El próximo evento de recolección tendrá lugar en Wuxi (CHN) en el Campeonato del Mundo de Esgrima Senior en julio ¡Sigamos desarrollando nuestras federaciones! ■  A ella le gustaría darles un poco a todos estos países, y quizás dividir ítems si es posible. W W W.FIE .ORG"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Lausanne",
      "index": 58,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg60.jpg",
      "zoom": null,
      "content": `<img id="60-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/green-next-arrow.png" onclick="Publish.goToNextPage()">
      <img id="60-title" class="halfScale" style="top:897px;left:69px" src="/106/es/static/_content/60-t1.png">
      <img id="60-sub" class="halfScale" style="top:986px;left:946px" src="/106/es/static/_content/60-s1.png">
      <img id="60-line" class="halfScale" style="top:981px;left:910px" src="/106/es/static/_content/all-2line.png">
      `,
      "script": `
      function onPageEnter() {
        page60Anim = new TimelineMax()
        page60Anim
          .fromTo(idOf("60-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("60-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("60-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("60-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page60Anim.stop()
      }
      `,
      "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIONES NACIONALES  DÍA MUNDIAL DE LA ESGRIMA: 8 DE SEPTIEMBRE DE 2018  LAUSANNE, SUIZA 17 DE ABRIL DE 2018"
      ,
      "mobileHtml": `
        <h2>DÍA MUNDIAL DE LA ESGRIMA: 8 DE SEPTIEMBRE DE 2018</h2>
        <p><b>
        LAUSANNE, SUIZA <br>     
        17 DE ABRIL DE 2018     
        </b><p>
        <img src="/106/es/static/_mobile/pg60-fencingday.jpg">
        `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Lausanne",
      "index": 59,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg61.jpg",
      "zoom": null,
      "content": `
      <img id="61-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/52-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="61-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/green-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="61-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/green-face.png">
      </a>

      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
       
      `,
      "script": `
      function onPageEnter() {
        page61Anim = new TimelineMax()
        page61Anim
          .fromTo(idOf("61-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page61Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/2  El Día mundial de la esgrima tendrá lugar el sábado, 8 de septiembre con países de todo el mundo que participan en la promoción del deporte olímpico de la esgrima en sus respectivas naciones. Es un día en que la atención prestada al manejo competitivo de la espada llega a niños, comunidades, escuelas y los nuevos espectadores, que descubren un deporte lleno de historia y de compromiso con el futuro. El 9 de septiembre de 2017, el primer Día mundial de esgrima, contó con esgrimistas olímpicos y campeones del mundo que demostraron su talento a escolares emocionados, hicieron demostraciones de esgrima en plazas públicas y centros comerciales desde Nepal hasta Río, varios clubes de esgrima abrieron sus puertas al público para probar un duelo de forma gratuita, hubo rutas por las playas de California y los muelles de Gran Bretaña, cientos de niños chinos practicando esgrima en campos de fútbol, e incluso un partido de esgrima en lo alto de una torre de 192 metros en Auckland, Nueva Zelanda.  Este año, la FIE está celebrando su 105.º aniversario. En cooperación con sus 153 países miembros, está impulsando aún más la participación para llegar a las masas a través de la emoción y la energía que da la esgrima. Las federaciones de esgrima, clubes, individuos, equipos, escuelas, fabricantes y campeones de élite se unirán para presentar y compartir su entusiasmo y dedicación con todo el mundo. Estén atentos para más información sobre eventos y actividades que se realizarán el 8 de septiembre y únanse a nosotros en la celebración de este deporte verdaderamente global. ■  W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <p>       
        El Día mundial de la esgrima tendrá lugar el sábado, 8 de septiembre con países de todo el mundo que participan en la promoción del deporte olímpico de la esgrima en sus respectivas naciones.
        </p>
        <p>
        Es un día en que la atención prestada al manejo competitivo de la espada llega a niños, comunidades, escuelas y los nuevos espectadores, que descubren un deporte lleno de historia y de compromiso con el futuro.
        </p>
        <p>       
        El 9 de septiembre de 2017, el primer Día mundial de esgrima, contó con esgrimistas olímpicos y campeones del mundo que demostraron su talento a escolares emocionados, hicieron demostraciones de esgrima en plazas públicas y centros comerciales desde Nepal hasta Río, varios clubes de esgrima abrieron sus puertas al público para probar un duelo de forma gratuita, hubo rutas por las playas de California y los muelles de Gran Bretaña, cientos de niños chinos practicando esgrima en campos de fútbol, e incluso un partido de esgrima en lo alto de una torre de 192 metros en Auckland, Nueva Zelanda.
        </p>
        <p>
        Este año, la FIE está celebrando su 105.º aniversario. En cooperación con sus 153 países miembros, está impulsando aún más la participación para llegar a las masas a través de la emoción y la energía que da la esgrima. Las federaciones de esgrima, clubes, individuos, equipos, escuelas, fabricantes y campeones de élite se unirán para presentar y compartir su entusiasmo y dedicación con todo el mundo.
        </p>
        <p>
        Estén atentos para más información sobre eventos y actividades que se realizarán el 8 de septiembre y únanse a nosotros en la celebración de este deporte verdaderamente global.
        </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Sáo Paulo",
      "index": 60,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg62.jpg",
      "zoom": null,
      "content": `
      <img id="62-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/green-next-arrow.png" onclick="Publish.goToNextPage()">
      <img id="62-title" class="halfScale" style="top:122px;left:85px" src="/106/es/static/_content/62-t1.png">
      <img id="62-sub" class="halfScale" style="top:528px;left:120px" src="/106/es/static/_content/62-sub.png">
      <img id="62-line" class="halfScale" style="top:530px;left:84px" src="/106/es/static/_content/all-2line.png">
      `,
      "script": `
      function onPageEnter() {
        page62Anim = new TimelineMax()
        page62Anim
          .fromTo(idOf("62-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("62-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("62-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("62-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page62Anim.stop()
      }
      `,
      "searchText": "NOTICIAS DE L A FIE Y DE L AS FEDER ACIONES NACIONALES  DONE SU EQUIPO DE ESGRIMA:  BRASIL, UN AÑO DESPUÉS  SÃO PAULO, BRASIL 10 DE MAYO DE 2018"
      ,
      "mobileHtml": `
        <h2>DONE SU EQUIPAMIENTO DE ESGRIMA: <br>
        BRASIL, UN AÑO DESPUÉS</h2>
        <p><b>
        SÃO PAULO, BRASIL <br>            
        10 DE MAYO DE 2018      
        </b><p>
        <img src="/106/es/static/_mobile/pg62-oneyear.jpg">
        `  
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Sáo Paulo",
      "index": 61,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg63.jpg",
      "zoom": null,
      "content": `
      <img id="63-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/green-next-arrow.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="63-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/green-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="63-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/green-face.png">
      </a>
       
        <img class="halfScaleC pointer" onclick="Publish.openVideo('https://www.youtube.com/embed/VKoAlMvFvm0')" style="top:623px;left:465px" src="/106/es/static/_content/green-play-button.png">

      `,
      "script": `
      function onPageEnter() {
        page63Anim = new TimelineMax()
        page63Anim
          .fromTo(idOf("63-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page63Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/4  En 2017, la Confederación Brasileña de Esgrima respondió a una invitación de la FIE para presentar proyectos de solidaridad como beneficiarios del programa Done su equipo de esgrima, presentando un proyecto llamado Paraisópolis Musketeers, o Mosqueteiros de Paraisópolis. Este proyecto ya era conocido por la FIE; unos meses antes de los Juegos Olímpicos de Río 2016, la FIE, como parte de la promoción de la esgrima en Brasil, dio visibilidad a la actividad a través del siguiente vídeo:  Tap to link to video  Ahora, aproximadamente un año después, ¿cuál fue el impacto de la donación en la comunidad?  Paraisópolis es la segunda «favela» más grande de São Paulo y la quinta más grande de Brasil. Más de 100.000 personas viven en esta comunidad, que carece de una infraestructura decente que supla necesidades tales como una red eléctrica oficial y un sistema de alcantarillado. En este entorno, es esencial proporcionar actividades complementarias a los niños, ya que es una de las pocas o, incluso, únicas oportunidades que pueden tener de experimentar la cultura y los deportes. En consecuencia, y como continuación de la introducción a la esgrima patrocinada por la FIE el año pasado, un grupo de esgrimistas tuvo la idea de ofrecer clases a los niños de Paraisópolis como una actividad gratuita. Además de sacar a los niños y adolescentes de las calles, los principales objetivos del proyecto son desarrollar sus cualidades físicas, cognitivas y sociales a través de la esgrima. La Asociación Brasileña de Esgrimistas (ABE) dirige la actividad en cooperación con otras dos"
      ,
      "mobileHtml": `
        <p>
        En 2017, la Confederación Brasileña de Esgrima respondió a una invitación de la FIE para presentar proyectos de solidaridad como beneficiarios del programa Done su equipo de esgrima, presentando un proyecto llamado Paraisópolis Musketeers, o Mosqueteiros de Paraisópolis.
        </p>
        <p>         
        Este proyecto ya era conocido por la FIE; unos meses antes de los Juegos Olímpicos de Río 2016, la FIE, como parte de la promoción de la esgrima en Brasil, dio visibilidad a la actividad a través del siguiente vídeo:
        </p>
        <p>
        Ahora, aproximadamente un año después, ¿cuál fue el impacto de la donación en la comunidad?
        </p>
        <p>
        Paraisópolis es la segunda «favela» más grande de São Paulo y la quinta más grande de Brasil. Más de 100.000 personas viven en esta comunidad, que carece de una infraestructura decente que supla necesidades tales como una red eléctrica oficial y un sistema de alcantarillado. En este entorno, es esencial proporcionar actividades complementarias a los niños, ya que es una de las pocas o, incluso, únicas oportunidades que pueden tener de experimentar la cultura y los deportes. En consecuencia, y como continuación de la introducción a la esgrima patrocinada por la FIE el año pasado, un grupo de esgrimistas tuvo la idea de ofrecer clases a los niños de Paraisópolis como una actividad gratuita.
        </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Sáo Paulo",
      "index": 62,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg64.jpg",
      "zoom": null,
      "content": `
      <img id="64-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/green-next-arrow.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="64-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/green-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="64-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/green-face.png">
      </a>
       
      `,
      "script": `
      function onPageEnter() {
        page64Anim = new TimelineMax()
        page64Anim
          .fromTo(idOf("64-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page64Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 3/4  asociaciones locales, CEU Paraisópolis (escuela pública en la comunidad) y UMPC (Asociación de habitantes y comercio de Paraisópolis). Además de la participación social de los estudiantes, el proyecto tiene la intención de [indirectamente] incluir a otros miembros de la comunidad en actividades relacionadas con el proyecto (como lavandería/costura de uniformes y preparación de aperitivos). Se estima que más de 2000 personas de la comunidad han tenido un primer contacto con la esgrima desde el comienzo del proyecto en 2014.  En el Campeonato del Mundo de Leipzig en 2017, quedó claro que muchos donantes eran deportistas olímpicos que querían agradecer a Brasil por la intensa y entusiasta experiencia vivida en Río de Janeiro un año antes. Aron Szilágyi, quien en Río ganó su segunda medalla de oro en sable masculino, donó, entre otras cosas, la chaqueta que llevaba cuando ganó su primera medalla de oro en Londres. El equipo recolectado en Leipzig destinado a Brasil fue entregado al vicepresidente de la Confederación Brasileña de Esgrima, Arno Perillier, quien tuvo"
      ,
      "mobileHtml":`
        <p>
        Además de sacar a los niños y adolescentes de las calles, los principales objetivos del proyecto son desarrollar sus cualidades físicas, cognitivas y sociales a través de la esgrima. La Asociación Brasileña de Esgrimistas (ABE) dirige la actividad en cooperación con otras dos asociaciones locales, CEU Paraisópolis (escuela pública en la comunidad) y UMPC (Asociación de habitantes y comercio de Paraisópolis). Además de la participación social de los estudiantes, el proyecto tiene la intención de [indirectamente] incluir a otros miembros de la comunidad en actividades relacionadas con el proyecto (como lavandería/costura de uniformes y preparación de aperitivos). Se estima que más de 2000 personas de la comunidad han tenido un primer contacto con la esgrima desde el comienzo del proyecto en 2014.
        </p>
        <p>       
        En el Campeonato del Mundo de Leipzig en 2017, quedó claro que muchos donantes eran deportistas olímpicos que querían agradecer a Brasil por la intensa y entusiasta experiencia vivida en Río de Janeiro un año antes. Aron Szilágyi, quien en Río ganó su segunda medalla de oro en sable masculino, donó, entre otras cosas, la chaqueta que llevaba cuando ganó su primera medalla de oro en Londres. El equipo recolectado en Leipzig destinado a Brasil fue entregado al vicepresidente de la Confederación Brasileña de Esgrima, Arno Perillier, quien tuvo que resolver el problema de traer de vuelta a Brasil varias bolsas repletas de material.
        </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Sáo Paulo",
      "index": 63,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg65.jpg",
      "zoom": null,
      "content": `
      <img id="65-next" class="halfScale pointer" style="top:847px;left:1390px" src="/106/es/static/_content/52-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="65-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/green-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="65-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/green-face.png">
      </a>

      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
       
      `,
      "script": `
      function onPageEnter() {
        page65Anim = new TimelineMax()
        page65Anim
          .fromTo(idOf("65-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page65Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 4/4  que resolver el problema de traer de vuelta a Brasil varias bolsas repletas de material. «La mayoría de los niños del proyecto nunca habían visto ningún equipo de esgrima oficial y se sorprendieron con esta oportunidad durante una presentación de esgrima en enero», dijo Ana Carolina Pontes, directora del proyecto Mosqueteiros de Paraisópolis. «El equipo donado es principalmente para entrenamiento eléctrico. Como el proyecto no tiene máquinas de entrenamiento ni rollos, todavía estamos buscando una manera de pagarlos, el equipo se utiliza principalmente en competiciones y presentaciones de esgrima. Ya son aproximadamente 50 alumnos, entre regulares y ocasionales, los que han sido alcanzados por la donación».  nacionales en Porto Alegre, gracias a un esfuerzo de financiamiento organizado por ABE. Logramos pagar los billetes de avión, materiales, alojamiento, etc. para los niños y los profesores. Estamos convencidos de que el apoyo de la FIE nos ayudó a ganar la credibilidad de las personas que nos han ayudado hasta día de hoy». Ponte concluyó con la promesa de mantener a todos informados sobre nuevos desarrollos y avances del proyecto: «Nos gustaría felicitar a esta destacable iniciativa de la FIE y agradecer a todas las personas involucradas por un gesto tan maravilloso». ■  Además, Ponte declaró que el apoyo brindado por la FIE ayudó más allá de la donación de equipos: «¡La inclusión de Mosqueteiros de Paraisópolis en los beneficiarios de Done su equipo de esgrima! aumentó la credibilidad del proyecto y de la institución que lo respalda - ABE: un mes después de la donación, nueve niños de Paraisópolis viajaron a los campeonatos  W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <p>
        «La mayoría de los niños del proyecto nunca habían visto ningún equipo de esgrima oficial y se sorprendieron con esta oportunidad durante una presentación de esgrima en enero», dijo Ana Carolina Pontes, directora del proyecto Mosqueteiros de Paraisópolis. «El equipo donado es principalmente para entrenamiento eléctrico. Como el proyecto no tiene máquinas de entrenamiento ni rollos, todavía estamos buscando una manera de pagarlos, el equipo se utiliza principalmente en competiciones y presentaciones de esgrima. Ya son aproximadamente 50 alumnos, entre regulares y ocasionales, los que han sido alcanzados por la donación».
        </p>
        <p>
        Además, Ponte declaró que el apoyo brindado por la FIE ayudó más allá de la donación de equipos: «¡La inclusión de Mosqueteiros de Paraisópolis en los beneficiarios de Done su equipo de esgrima! aumentó la credibilidad del proyecto y de la institución que lo respalda - ABE: un mes después de la donación, nueve niños de Paraisópolis viajaron a los campeonatos nacionales en Porto Alegre, gracias a un esfuerzo de financiamiento organizado por ABE. Logramos pagar los billetes de avión, materiales, alojamiento, etc. para los niños y los profesores. Estamos convencidos de que el apoyo de la FIE nos ayudó a ganar la credibilidad de las personas que nos han ayudado hasta día de hoy».
        </p>
        <p>        
        Ponte concluyó con la promesa de mantener a todos informados sobre nuevos desarrollos y avances del proyecto: «Nos gustaría felicitar a esta destacable iniciativa de la FIE y agradecer a todas las personas involucradas por un gesto tan maravilloso».
        </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 64,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg66.jpg",
      "zoom": null,
      "content": `<div class="addContentLink" style="bottom:784px;right:540px; width:373px; height:40px;">
      <a href="http://www.swordhellas.com" target="_blank"></a>
    </div>

      `,
      "script": `
      function onPageEnter() {
      addContentLinks()
      }

      function onPageLeave() {
      removeContentLinks()
      }
      `,
      "searchText": ""
      ,
      "mobileHtml": `
      <a href="http://www.swordhellas.com" target="_blank">
        <img id="swordhellasimg" src="/106/es/static/_mobile/pg66-swordhellas.jpg">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Katmandú, Nepal",
      "index": 65,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg67.jpg",
      "zoom": null,
      "content": `
      <img id="67-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/green-next-arrow.png" onclick="Publish.goToNextPage()">
      <img id="67-title" class="halfScale" style="top:108px;left:82px" src="/106/es/static/_content/67-title.png">
      <img id="67-sub" class="halfScale" style="top:177px;left:1168px" src="/106/es/static/_content/67-sub.png">
      <img id="67-line" class="halfScale" style="top:175px;left:1142px" src="/106/es/static/_content/all-3line.png">
      `,
      "script": `
      function onPageEnter() {
        page67Anim = new TimelineMax()
        page67Anim
          .fromTo(idOf("67-title"), 0.5,{x:-100, opacity:0, }, {x:0, opacity:1},0.5)
          .fromTo(idOf("67-line"), 0.3,{opacity:0, y:50}, {y:0,opacity:1},"-=0.2")
          .fromTo(idOf("67-sub"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1},"+=0.1")
          .fromTo(idOf("67-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1})
          
      }

      function onPageLeave() {
        page67Anim.stop()
      }
      `,
      "searchText": ""
      ,
      "mobileHtml": `
        <h2>LA ASOCIACIÓN DE ESGRIMA DE NEPAL ORGANIZA UN CURSO DE ENTRENAMIENTO TÉCNICO</h2>
        <p><b>
        KATMANDÚ, NEPAL <br>            
        17 AL 22 DE MAYO DE 2018     
        </b><p>
        <img src="/106/es/static/_mobile/pg67-nepal.jpg">
        ` 
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Katmandú, Nepal",
      "index": 66,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg68.jpg",
      "zoom": null,
      "content": `
      <img id="68-next" class="halfScale pointer" style="top:847px;left:1391px" src="/106/es/static/_content/green-next-arrow.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="68-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/green-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="68-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/green-face.png">
      </a>
       
      `,
      "script": `
      function onPageEnter() {
        page68Anim = new TimelineMax()
        page68Anim
          .fromTo(idOf("68-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page68Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 2/3 La Asociación de Esgrima de Nepal ha completado la organización de un Curso técnico de Solidaridad Olímpica (SO) para entrenadores de sable, celebrado en Katmandú del 17 al 22 de mayo. Los objetivos principales del curso eran generar la mano de obra técnica necesaria para promover y desarrollar de forma efectiva la esgrima en Nepal. El Sr. Lama Tendi Sherpa, Secretario General del Comité Olímpico de Nepal, inauguró la ceremonia de apertura del curso, transmitiendo sus mejores deseos de éxito. Durante la ceremonia, el Sr. Sujan Lal Shrestha, Secretario General de la Asociación de Esgrima de Nepal, dio la bienvenida a los participantes y especialistas de la FIE y destacó que, aunque la esgrima es uno de los deportes olímpicos más antiguos, aún queda un largo camino por recorrer para ser promovida en Nepal. Añadió que, sin personal técnico, el desarrollo de cualquier deporte  es casi imposible y, por tanto, el Curso técnico de SO es un hito en el desarrollo de la esgrima en Nepal. El Sr. Sunil Kumar Shrestha, Presidente de  la Asociación de Esgrima de Nepal, agradeció a la FIE, a Solidaridad Olímpica y al Comité Olímpico de Nepal haber aprobado la organización del curso.El curso fue dirigido por Cyril Tahon de la FIE. Dieciocho atletas y entrenadores de sable participaron, entusiasmados por aprender nuevas habilidades y técnicas. Al concluir el curso, el Sr. Jeevan Ram Shrestha, Presidente del Comité Olímpico de Nepal, entregó certificados a los participantes del mismo durante una ceremonia de clausura. En el mismo evento, el Sr. Janga Giri, miembro del club de esgrima APF de Nepal, recibió un premio en efectivo por su  "
      ,
      "mobileHtml":`
        <p>
        La Asociación de Esgrima de Nepal ha completado la organización de un Curso técnico de Solidaridad Olímpica (SO) para entrenadores de sable, celebrado en Katmandú del 17 al 22 de mayo.
        </p>
        <p>          
        Los objetivos principales del curso eran generar la mano de obra técnica necesaria para promover y desarrollar de forma efectiva la esgrima en Nepal. El Sr. Lama Tendi Sherpa, Secretario General del Comité Olímpico de Nepal, inauguró la ceremonia de apertura del curso, transmitiendo sus mejores deseos de éxito. Durante la ceremonia, el Sr. Sujan Lal Shrestha, Secretario General de la Asociación de Esgrima de Nepal, dio la bienvenida a los participantes y especialistas de la FIE y destacó que, aunque la esgrima es uno de los deportes olímpicos más antiguos, aún queda un largo camino por recorrer para ser promovida 
        </p>
        <p>
        El Sr. Sunil Kumar Shrestha, Presidente de la Asociación de Esgrima de Nepal, agradeció a la FIE, a Solidaridad Olímpica y al Comité Olímpico de Nepal haber aprobado la organización del curso.
        </p>
        <p>
        El curso fue dirigido por Cyril Tahon de la FIE. Dieciocho atletas y entrenadores de sable participaron, entusiasmados por aprender nuevas habilidades y técnicas. Al concluir el curso, el Sr. Jeevan Ram Shrestha, Presidente del Comité Olímpico de Nepal, entregó certificados a los participantes del mismo durante una ceremonia de clausura. En el mismo evento, el Sr. Janga Giri, miembro del club de esgrima APF de Nepal, recibió un premio en efectivo por su destacada actuación como medallista de oro en el primer, segundo y tercer Campeonato Nacional de Esgrima de Nepal.
        </p>
        
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Katmandú, Nepal",
      "index": 67,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg69.jpg",
      "zoom": null,
      "content": `
      <img id="69-next" class="halfScale pointer" style="top:847px;left:1390px" src="/106/es/static/_content/52-next.png" onclick="Publish.goToNextPage()">
      
      <a href="https://twitter.com/FIE_fencing" target="_blank">
      <img id="69-tw" class="halfScaleC pulse animatedpulse" style="top:453px;left:84px" src="/106/es/static/_content/green-tw.png">
      </a>
      <a href="https://www.facebook.com/fie.org" target="_blank">
      <img id="69-fb" class="halfScaleC pulse animatedpulse" style="top:453px;left:153px" src="/106/es/static/_content/green-face.png">
      </a>
       
      <div class="addContentLink" style="bottom:13px;right:79px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page69Anim = new TimelineMax()
        page69Anim
          .fromTo(idOf("69-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)
      }

      function onPageLeave() {
        page69Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "NOTICIAS DE LA FIE Y DE LAS FEDERACIONES NACIONALES 3/3 destacada actuación como medallista de oro en el primer, segundo y tercer Campeonato Nacional de Esgrima de Nepal. La Asociación de Esgrima de Nepal cree que cursos como este son esenciales para la organización con el fin de desarrollar y producir entrenadores calificados. Expresaron su gratitud colectiva a la FIE, a Solidaridad Olímpica y al Comité Olímpico de Nepal por su cooperación y apoyo."
      ,
      "mobileHtml":`
      <p>
      La Asociación de Esgrima de Nepal cree que cursos como este son esenciales para la organización con el fin de desarrollar y producir entrenadores calificados. Expresaron su gratitud colectiva a la FIE, a Solidaridad Olímpica y al Comité Olímpico de Nepal por su cooperación y apoyo.
      </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 68,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg70.jpg",
      "zoom": null,
      "content": `
    <div class="contentLink" style="bottom:62px;left:65px;width:330px; height:60px;">
      <a href="http://corp.megafon.com" target="_blank"></a>
    </div>
    `,
    "script": `
      function onPageEnter() {
        addContentLinks()
      }

      function onPageLeave() {
        removeContentLinks()
      }
      `,
      "searchText": ""
      ,
      "mobileHtml": `
      <a href="http://corp.megafon.com" target="_blank">
        <img id="megafonimg" src="/106/es/static/_mobile/pg70-megafon.png">
      </a>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Noticias",
      "index": 69,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg71.jpg",
      "zoom": null,
      "content": `
      <img id="71-title" class="halfScale" style="top:131px;left:86px" src="/106/es/static/_content/71-title.png">
      <img id="71-next" class="halfScale pointer" style="top:941px;left:1176px" src="/106/es/static/_content/71-next.png" onclick="Publish.goToNextPage()">
      <div class=" addContentLink" style="top: 110px;left: 1276px;width: 183px;height: 133px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>

      <div class="addContentLink" style="top: 608px; left: 102px; width: 240px; height: 34px;" onclick="showOverlay('news-pop-1')"></div>

      <div id="news-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img id="" class="" style="top:0px;left:0px" src="/106/es/static/_content/pg71-pop.jpg">
          
          <img id="71-popup-text" class="halfScale" style="top:156px;left:81px" src="/106/es/static/_content/71-news1.png">
          <img id="71-popup1-pg1" class="halfScale" style="top:928px;left:785px" src="/106/es/static/_content/71-pg1.png">
          <div class="addContentLink" style="top: 928px; left: 785px; width: 329px; height: 112px; z-index:100;opacity:0" onclick="showPop1()"> </div>

          <img id="71-popup-text1" class="halfScale" style="top:162px;left:81px; opacity:0" src="/106/es/static/_content/71-news1.1.png">
          <img id="71-popup1-pg2" class="halfScale" style="top:928px;left:1125px ;opacity:0" src="/106/es/static/_content/71-pg2.png">
          <div class="addContentLink" style="top: 928px; left: 1125px; width: 329px; height: 112px;opacity:0" onclick="showPop2()"> </div>
          <img id="71-news-french" class="halfScale" style="top:163px;left:782px; opacity:0" src="/106/es/static/_content/71-news1.1-fre.png">
          <img id="71-news-russia" class="halfScale" style="top:165px;left:782px; opacity:0" src="/106/es/static/_content/71-news1.1-rus.png">

          <div id="french" class="addContentLink pointer" style="top: 321px; left: 782px; width: 138px; height: 138px;opacity:0;display:none" onclick="showFr()"> </div>

          <div id="russia" class="addContentLink pointer" style="top: 162px; left: 782px; width: 138px; height: 138px;opacity:0;display:none" onclick="showRu()"> </div>


          <div class="addContentLink" style="top: 54px; left: 1327px; width: 164px; height: 42px;opacity:0" onclick="hideOverlay('news-pop-1');">
          
          </div>

      </div>

      <div class="addContentLink" style="top: 972px; left: 282px; width: 190px; height: 34px;" onclick="showOverlay('news-pop-2')"></div>

        <div id="news-pop-2" class="standardTransition contentOverlay hidden noclick">

        <img id="" class="" style="top:0px;left:0px" src="/106/es/static/_content/pg71-pop.jpg">

        <img id="71-popup-text2" class="halfScale" style="top:249px;left:81px" src="/106/es/static/_content/71-news2.png">
        <img id="71-popup2-pg1" class="halfScale" style="top:928px;left:785px" src="/106/es/static/_content/71-pg1.png">
        <div class="addContentLink" style="top: 928px; left: 785px; width: 329px; height: 112px; z-index:100;opacity:0" onclick="twoShowPop1()"> </div>

        <img id="71-popup-text2-1" class="halfScale" style="top:476px;left:81px; opacity: 0" src="/106/es/static/_content/71-news2.1.png">
        <img id="71-popup2-pg2" class="halfScale" style="top:928px;left:1125px; opacity: 0" src="/106/es/static/_content/71-pg2.png">
        <div class="addContentLink" id="71-pop-2-link" style="top:817px;left:882px;width:56px; height:33px;">
          <a href="https://www.buenosaires2018.com/es/noticias/mascota-de-buenos-aires-2018" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top: 928px; left: 1125px; width: 329px; height: 112px; z-index:100;opacity:0" onclick="twoShowPop2()"> </div>

        <div class="addContentLink" style="top: 54px; left: 1327px; width: 164px; height: 42px;opacity:0" onclick="hideOverlay('news-pop-2'); ">

        </div>

      </div>

      <div class="addContentLink" style="top: 436px; left: 1072px; width: 190px; height: 34px;" onclick="showOverlay('news-pop-3')"></div>

      <div id="news-pop-3" class="standardTransition contentOverlay hidden noclick">

        <img id="" class="" style="top:0px;left:0px" src="/106/es/static/_content/pg71-pop2.jpg">

        <img id="71-popup-text3" class="halfScale" style="top:187px;left:81px" src="/106/es/static/_content/71-news3.png">
        <div class="addContentLink" style="top:559px;left:793px;width:311px; height:33px;">
          <a href="mailto:limassolfencingclub@cytanet.com.cy"></a>
        </div>
        <div class="addContentLink" style="top:622px;left:794px;width:214px; height:33px;">
          <a href="https://www.facebook.com/limassolfencingclub" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top: 54px; left: 1327px; width: 164px; height: 42px;opacity:0" onclick="hideOverlay('news-pop-3'); "></div>

      </div>

      <div class="addContentLink" style="top: 630px; left: 1072px; width: 190px; height: 34px;" onclick="showOverlay('news-pop-4')"></div>

      <div id="news-pop-4" class="standardTransition contentOverlay hidden noclick">

        <img id="" class="" style="top:0px;left:0px" src="/106/es/static/_content/pg71-pop2.jpg">

        <img id="71-popup-text4" class="halfScale" style="top:183px;left:81px" src="/106/es/static/_content/71-news4.png">

        <div class="addContentLink" style="top: 54px; left: 1327px; width: 164px; height: 42px;opacity:0" onclick="hideOverlay('news-pop-4'); "></div>

      </div>

      <div class="addContentLink" style="top: 820px; left: 1072px; width: 190px; height: 34px;" onclick="showOverlay('news-pop-5')"></div>

        <div id="news-pop-5" class="standardTransition contentOverlay hidden noclick">

        <img id="" class="" style="top:0px;left:0px" src="/106/es/static/_content/pg71-pop.jpg">

        <img id="71-popup-text5" class="halfScale" style="top:143px;left:81px" src="/106/es/static/_content/71-news5.png">
        <img id="71-popup5-pg1" class="halfScale" style="top:928px;left:785px" src="/106/es/static/_content/71-pg1.png">
        <div class="addContentLink" style="top: 928px; left: 785px; width: 329px; height: 112px; z-index:100;opacity:0" onclick="fiveShowPop1()"> </div>

        <img id="71-popup-text5-1" class="halfScale" style="top:284px;left:81px; opacity: 0" src="/106/es/static/_content/71-news5.1.png">
        <img id="71-popup5-pg2" class="halfScale" style="top:928px;left:1125px; opacity: 0" src="/106/es/static/_content/71-pg2.png">
        <div class="addContentLink" style="top: 928px; left: 1125px; width: 329px; height: 112px; z-index:100;opacity:0" onclick="fiveShowPop2()"> </div>

        <div class="addContentLink" style="top: 54px; left: 1327px; width: 164px; height: 42px;opacity:0" onclick="hideOverlay('news-pop-5'); ">

        </div>

      </div>

      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page71Anim = new TimelineMax()
        page71Anim
          .fromTo(idOf("71-title"), 0.5,{y:-100, opacity:0, }, {y:0, opacity:1},0.5)
          .fromTo(idOf("71-next"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, "-=0.2")
      }

      function showPop1() {
          idOf("71-popup-text").style.opacity = 1
          idOf("71-popup-text1").style.opacity = 0
          idOf("71-popup1-pg1").style.opacity = 1
          idOf("71-popup1-pg2").style.opacity = 0
          idOf("71-news-french").style.opacity = 0
          idOf("71-news-russia").style.opacity = 0
          idOf("russia").style.display = "none"
          idOf("french").style.display = "none"
      }

      function showPop2() {
        idOf("71-popup-text").style.opacity = 0
        idOf("71-popup-text1").style.opacity = 1
        idOf("71-popup1-pg1").style.opacity = 0
        idOf("71-popup1-pg2").style.opacity = 1
        idOf("71-news-french").style.opacity = 1
        idOf("71-news-russia").style.opacity = 0
        idOf("russia").style.display = "block"
        idOf("french").style.display = "block"
    }

      function showFr() {
        idOf("71-news-french").style.opacity = 1
        idOf("71-news-russia").style.opacity = 0
    }

      function showRu() {
        idOf("71-news-russia").style.opacity = 1
        idOf("71-news-french").style.opacity = 0
    }

      function twoShowPop1() {
        idOf("71-popup-text2").style.opacity = 1
        idOf("71-popup-text2-1").style.opacity = 0
        idOf("71-popup2-pg1").style.opacity = 1
        idOf("71-popup2-pg2").style.opacity = 0
        idOf("71-pop-2-link").style.display = "none"
    }

      function twoShowPop2() {
        idOf("71-popup-text2").style.opacity = 0
        idOf("71-popup-text2-1").style.opacity = 1
        idOf("71-popup2-pg1").style.opacity = 0
        idOf("71-popup2-pg2").style.opacity = 1
        idOf("71-pop-2-link").style.display = "block"
    }

    function fiveShowPop1() {
      idOf("71-popup-text5").style.opacity = 1
      idOf("71-popup-text5-1").style.opacity = 0
      idOf("71-popup5-pg1").style.opacity = 1
      idOf("71-popup5-pg2").style.opacity = 0;
  }

    function fiveShowPop2() {
      idOf("71-popup-text5").style.opacity = 0
      idOf("71-popup-text5-1").style.opacity = 1
      idOf("71-popup5-pg1").style.opacity = 0
      idOf("71-popup5-pg2").style.opacity = 1
  }

      function onPageLeave() {
        page71Anim.stop()
        removeContentLinks()
        hideOverlay('news-pop-1');
        hideOverlay('news-pop-2');
        hideOverlay('news-pop-3');
        hideOverlay('news-pop-4');
        hideOverlay('news-pop-5');
      }
      `,
      "searchText": "NOTICIAS  NOTICIAS DE LA FIE 1  3    Esgrimistas Rusos y Franceses se reunen en San Petersburgo  WWW.FIE.ORG  Concurso Internacional 'Cyprus Talents Copa 2018' Ver más aquí.  4  Ver más aquí.  Pozdnyakov elegido presidente del comité Olímpico Ruso Ver más aquí.  5  WOA lanza un Estudio de Referencia de Salud Olímpica Ver más aquí.  2  Buenos Aires 2018 presenta una mascota para Juegos Olímpicos Juveniles Ver más aquí.  W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <img src="/106/es/static/_mobile/pg71-news.jpg">
        <h2>          
        Esgrimistas Rusos y Franceses se reunen en San Petersburgo
        Ver más aquí.
        </h2>
        <p><b>
        Esgrimistas Rusos y Franceses se reunen en San Petersburgo
        </b></p>
        <p>
        Equipos de esgrima de mujeres rusas y francesas celebraron un amistoso partido de sable como parte del programa deportivo del Foro Económico Internacional de San Petersburgo.
        </p>
        <p>
        Equipos de esgrima de mujeres rusas y francesas celebraron un amistoso partido de sable como parte del programa deportivo del Foro Económico Internacional de San Petersburgo. Ambos equipos incluyeron las esgrimistas de sable más fuertes de sus respectivos países.
        </p>
        <p>
        Desde 1999, el equipo ruso ha ganado siete Campeonatos Mundiales y 10 Europeos. Las esgrimistas de sable rusas ganaron la medalla de oro durante los Juegos Olímpicos de Río 2016, y Francia ha ganado dos campeonatos mundiales y dos europeos.
        </p>
        <p>
        El partido se llevó a cabo en el Salón de Mármol del Museo Ruso de Etnografía, y contó con la asistencia de importantes personalidades rusas y francesas:
        </p>
        <ul>
          <li><b>Alisher Usmanov</b></li>
          <li>presidente de la Federación Internacional de Esgrima (FIE)</li>
          <li><b>Pavel Kolobkov</b></li>
          <li>Ministro de Deportes de Rusia y campeón olímpico de esgrima</li>
          <li><b>Isabelle Lamour</b></li>
          <li>presidenta de la Federación Francesa de Esgrima</li>
          <li><b>Aleksandr Mikhailov</b></li>
          <li>presidente de la Federación Rusa de Esgrima</li>
        </ul>
        <p>
        El público disfrutó de las mejores actuaciones de ambos equipos, que lograron controlar de forma impresionante tanto sus armas como sus emociones, aunque en la esgrima esta última parte es siempre una tarea más difícil. Si bien el partido fue amistoso, cada atleta, sin embargo, trató de hacer lo mejor para su equipo. El equipo ruso ganó por poco, por un punto, 45-44.
        </p>
        <p>
        Después de la competición, el presidente Usmanov compartió sus impresiones: "Disfrutamos muchísimo el partido de hoy. Los tiradores fueron geniales: demostraron una técnica perfecta y buena velocidad. Espero que estos partidos se conviertan en una tradición, que fortalecerá la amistad entre las federaciones deportivas de nuestros países".
        </p>
        <p>
        El día después del evento, ambos equipos visitaron las salas de exhibición del Foro Económico Internacional y fueron presentados al presidente francés Emmanuel Macron y al presidente ruso Vladimir Putin.
        </p>
        <p>
        Se espera que tenga lugar otra reunión de los equipos de Francia y Rusia este noviembre en París como parte del Congreso de la Federación Internacional de Esgrima.
        </p>
        <p>Pulse las banderas para ver los equipos</p>
        <p><b>El equipo ruso incluyó:</b></p>
        <ul>
          <li><b>Sofiya Velikaya, </b><br>campeona olímpica y mundial</li>
          <li><b>Yana Yegoryan, </b><br>dos veces campeona olímpica y mundial</li>
          <li><b>Julia Gavrilova, </b><br>campeona olímpica, mundial y europea</li>
          <li><b>Svetlana Sheveleva, </b><br>campeona rusa 2018</li>
        </ul>
        <p><b>El equipo francés incluyó:</b></p>
        <ul>
          <li><b>Cecilia Berder, </b><br>medallista de campeonatos mundiales y europeos</li>
          <li><b>Charlotte Lembach, </b><br>campeona del Gran Premio y medallista de Campeonatos Mundiales y Europeos</li>
          <li><b>Manon Brunet, </b><br>ganador de la copa del mundo y medallista de Campeonatos Mundiales y Europeos
          </li>
          <li><b>Sara Balzer, </b><br>medallista del Campeonato Europeo</li>
        </ul>
        <h2>
        Buenos Aires 2018 presenta una mascota para los Juegos Olímpicos de la Juventud
        </h2>
        <p><b>
        El Comité Organizador de Buenos Aires 2018 lanzó su mascota olímpica juvenil.
        </b></p>
        <p>
        Inspirada en el jaguar, una de las especies de gatos salvajes más emblemáticas del norte de Argentina, la mascota busca inspirar a los jóvenes a adoptar el deporte como una herramienta para hacer del mundo un lugar mejor, al tiempo que crea conciencia sobre el peligro de extinción de la especie.
        </p>
        <p>
        La mascota se llamará #Pandi, con un "hashtag" al principio para mostrar su fuerte perfil en línea.
        </p>
        <p>
        En el corto animado, nuestro joven jaguar no se da por vencido ante los desafíos mientras trata de alcanzar las cintas con colores que simbolizan a Buenos Aires 2018.
        </p>
        <p>
        Durante la carrera, utiliza la energía positiva de los deportes que se encuentran en el programa olímpico juvenil para superar todo tipo de obstáculos. Comienza con un movimiento de ruptura; demuestra su habilidad para saltar sobre varios obstáculos; desafía la gravedad con un salto con pértiga; y asciende rápidamente al igual que en la escalada deportiva.
        </p>
        <p>
        El agotamiento ni siquiera puede entorpecer su objetivo final: llegar al Obelisco en el centro de Buenos Aires, donde las cintas lo abrazan para convertirse en la mascota de la tercera edición de verano de los Juegos Olímpicos de la Juventud.
        </p>
        <p>
        Con perseverancia y el espíritu festivo que revela al alcanzar su objetivo, #Pandi simboliza el deseo de Buenos Aires 2018, la primera edición de una celebración olímpica con estricta igualdad de género, para servir como una importante fuente de inspiración para construir un mundo mejor a través del deporte.
        </p>
        <p>
        "Al igual que los jóvenes atletas que dan lo mejor de sí mismos para clasificarse para los Juegos, la mascota de Buenos Aires 2018 supera todos los tipos de adversidades para alcanzar sus objetivos", dijo el presidente del Comité Organizador Buenos Aires 2018, Gerardo Werthein.
        </p>
        <p>
        Las mascotas olímpicas son embajadoras de los Juegos y desempeñan un papel fundamental en la difusión del mensaje del evento y los valores olímpicos de amistad, respeto y excelencia entre diferentes públicos, especialmente niños y jóvenes.
        </p>
        <p>
        El jaguar, que se encuentra en la región norte de Argentina, está en gran peligro debido a la acción humana. Varias organizaciones no gubernamentales (ONG) han advertido sobre el riesgo de extinción como resultado de la destrucción de su hábitat natural y la caza.
        </p>
        <p>
        La mascota de Buenos Aires 2018 fue diseñada por la agencia argentina Human Full Agency. El corto de animación fue realizado por la productora local, Buda TV. 
        </p>
        <p><a href="https://www.buenosaires2018.com/es/noticias/mascota-de-buenos-aires-2018" target="_blank">Haga clic aquí para saber más.</a></p>
        <h2>
        Concurso Internacional "Cyprus Talents Copa 2018"
        </h2>
        <p><b>
        El Club de Esgrima Limassol, en cooperación con la Federación de Esgrima de Chipre, organizó la competición internacional de esgrima, "Cyprus Talents Cup", en un evento de dos días del 28 al 29 de abril en el Centro Deportivo "Spyros Kyprianou" en Limassol.
        </b></p>
        <p>
        Desde la fundación en 1987, la Federación de Esgrima de Chipre ha organizado grandes competiciones internacionales con gran éxito, como la Copa del Mundo "Afrodita" y el Torneo Internacional "Chipre", mientras que el Club de Esgrima Limassol organiza un torneo de desarrollo para niños, el "Cyprus Talents Cup" se celebra anualmente a partir de 2015. En 2017, participaron 65 atletas de 14 países, incluidos Grecia, Ucrania, Rumanía, Bulgaria y Rusia.
        </p>
        <p>
        El torneo de este año incluyó las categorías U11 y U13 en la categoría de espada de niños y niñas el sábado 28 de abril y un evento abierto para hombres y mujeres en categoría de espada el domingo 29 de abril. El evento está bajo los auspicios de la Organización Deportiva de Chipre y fue apoyado por la Organización de Turismo de Chipre.
        </p>
        <p>
        El objetivo del evento fue desarrollar y promover la esgrima, buscar la cooperación con clubes y federaciones de esgrima de todo el mundo, con el objetivo de mejorar aún más las habilidades de sus jóvenes atletas y apoyar el turismo deportivo en Chipre.
        </p>
        <p>
        En la competición de este año, se inscribieron más de 85 atletas de 11 países y el espectáculo fue único para los espectadores chipriotas.
        </p>
        <p>Club de Esgrima Limassol</p>
        <p>Correo electrónico: </p>
        <p><a href="http://limassolfencingclub@cytanet.com.cy" target="_blank">limassolfencingclub@cytanet.com.cy</a></p>
        <p>Fb:</p>
        <p>Club de Esgrima Limassol</p>
        <p>Tel.:</p>
        <p>+357 99343712</p>
        <h2>
        Stanislav Pozdnyakov, campeón olímpico en cuatro ocasiones, elegido presidente del Comité Olímpico de Rusia
        </h2>
        <p><b>
        Stanislav Pozdnyakov ha sido elegido presidente del Comité Olímpico de Rusia.
        </b></p>
        <p>
        Las elecciones tuvieron lugar el 29 de mayo de 2018, durante la reunión del Comité Olímpico que tuvo lugar en la sede del Comité Olímpico de Rusia. Se postularon dos candidatos para presidente y presentaron plataformas para la elección: Sr. Pozdnyakov, cuatro veces campeón olímpico de esgrima, presidente de la Confederación Europea de Esgrima y miembro del Comité Ejecutivo de la Federación Internacional de Esgrima; y Alexander Popov, cuatro veces campeón olímpico de natación y miembro del Consejo para la Cultura Física y el Deporte del Presidente de Rusia.
        </p>
        <p>
        Los resultados de las elecciones incluyeron 214 delegados que votaron por el Sr. Pozdnyakov y 56 por el Sr. Popov. Después de que se anunciaron los resultados de la votación, el Sr. Pozdnyakov agradeció a los delegados por depositar su confianza en él y en su oponente por las elecciones, y prometió hacer todo lo posible para garantizar que el prestigio del movimiento olímpico ruso alcance nuevas metas.
        </p>
        <p>
        "Agradezco a todos los que votaron por mí, gracias por su confianza", dijo el Sr. Pozdnyakov, después de las elecciones. "Haré todo lo posible para que el Comité Olímpico de Rusia sea una de las organizaciones deportivas más fuertes del mundo".
        </p>
        <h2>
        Woa Lanza un Estudio de Referencia de Salud Olímpica
        </h2>
        <p><b>
        La Asociación Mundial de los Juegos Olímpicos ha lanzado el mayor estudio mundial jamás realizado que analizará los problemas de salud a largo plazo de los atletas olímpicos.
        </b></p>
        <p>
        El estudio cuenta con el apoyo de la Comisión médica y científica del COI, la Comisión de atletas del COI y la Comisión de entidades de atletas del COI.
        </p>
        <p>
        La Secretaria General de la Federación Internacional de Esquí (FIS), Sarah Lewis OLY, y el Presidente de la Federación Mundial de Remo (FISA), Jean-Christophe Rollande OLY, los dos primeros atletas olímpicos en completar el estudio de salud, se unieron al Presidente de WOA Joël Bouzou OLY en SportAccord en Bangkok. Más de 10.000 deportistas olímpicos, que ya no compiten a nivel olímpico, serán seleccionados para participar en el estudio. El estudio se promociona a todas las Federaciones Internacionales en la Asamblea General de GAISF mañana.
        </p>
        <p>
        Como parte de la prioridad estratégica de WOA para apoyar a los deportistas olímpicos a través de la transición de vida, el estudio de salud generará nuevos conocimientos sobre la salud general osteomuscular y general a largo plazo de los deportistas olímpicos e identificará los factores de riesgo asociados con el deporte de élite en esta área.
        </p>
        <p>
        La Dra. Debbie Palmer OLY, profesora asociada e investigadora en prevención de lesiones y enfermedades deportivas en la Universidad Edimburgo Napier, lidera el estudio. La Dra. Palmer compitió en patinaje de velocidad de pista corta para Gran Bretaña en tres Juegos Olímpicos de Invierno y anteriormente realizó investigaciones para el Comité Olímpico Internacional como parte del grupo de Investigación científica y médica del COI.
        </p>
        <p>
        El estudio es una colaboración internacional entre Edinburgh Napier University; el Centro de Investigación de Trauma Deportivo de Oslo; Universidad de Nottingham; Arthritis Research UK, Centro para el deporte, el Ejercicio y la Osteoartritis; Universidad de Calgary, Universidad de Alberta; Departamento médico y científico del COI; e Instituto para el deporte, ejercicio y salud, Londres.
        </p>
        <p>
        El presidente de WOA Joël Bouzou OLY dijo: <br>
        "Estamos orgullosos de lanzar el estudio de salud olímpico de WOA, que mejorará en gran medida el limitado conocimiento existente sobre el impacto a largo plazo en la salud de los deportistas olímpicos. Nuestro objetivo es utilizar este análisis para formular las recomendaciones con base en la evidencia y las pautas de mejores prácticas para beneficiar a los atletas olímpicos y otros atletas de élite. Me gustaría agradecer a la Dra. Debbie Palmer por liderar esta pieza vital de investigación y los líderes del SI Sarah Lewis y Jean-Christophe Rolland por ayudarnos a compartir el mensaje importante de este estudio a los olímpicos de todo el mundo".
        </p>
        <p>
        El remero olímpico y presidente de la Federación Internacional de Remo (FISA), Jean-Christophe Rollande, agregó:<br>
        "Se hace mucho hincapié en la necesidad de empujar a los deportistas olímpicos a su límite en la búsqueda de la gloria, pero a medida que pasan de la competición de élite a sus carreras posatléticas, su salud física tiene que ser de suma importancia. Los atletas olímpicos llevan sus cuerpos al extremo, y se sabe poco sobre los efectos a largo plazo, pero a través de este estudio podremos recopilar datos innovadores que ayudarán a modelar la salud de los atletas olímpicos y ayudarlos a medida que avanzan hacia una edad avanzada. Estoy muy orgulloso de respaldar esta iniciativa: es un trabajo verdaderamente increíble lo que está haciendo la Asociación Mundial de los Juegos Olímpicos".
        </p>
        <p>
        Three-time Olympian, Dr Debbie Palmer OLY, who is leading the research project, said:<br>
        "Se sabe que los atletas de élite están expuestos a cargas de competición y entrenamiento de alto impacto, lo que lleva a un aumento de las demandas fisiológicas que pueden asociarse con un mayor riesgo de lesiones. Este estudio busca comprender mejor cuáles son esos riesgos y cómo pueden mitigarse. Al alentar la participación de la mayor cantidad de atletas olímpicos posible, construiremos una mejor imagen de la vida posterior a la jubilación para aquellos que han competido en los niveles más altos del deporte y esperamos que aumenten en gran medida el cuerpo de conocimientos en esta área"
        </p>
      `
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "Recuerdo",
      "index": 70,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg72b.jpg",
      "zoom": null,
      "content": `
      <img id="72-title" class="halfScale" style="top:88px;left:85px" src="/106/es/static/_content/72-t1.png">

      <img id="72-text-1" class="halfScale" style="top:340px;left:85px;" src="/106/es/static/_content/72-text1.png">
      <img id="72-text-2" class="halfScale" style="top:340px;left:85px;display:none" src="/106/es/static/_content/72-text2.png">
      <img id="72-text-3" class="halfScale" style="top:340px;left:85px;display:none" src="/106/es/static/_content/72-text3.png">
      
      <img class="halfScale" id="72-white1" style="top:340px;left:1137px; display: none;" src="/106/es/static/_content/72-b1.png">

      <img class="halfScale" id="72-white2" style="top:481px;left:1137px; display: none;" src="/106/es/static/_content/72-w2.png">

      <img class="halfScale" id="72-white3" style="top:622px;left:1137px; display: none;" src="/106/es/static/_content/72-w3.png">


      <div class="addContentLink" style="top: 339px; left: 1138px; width: 312px; height: 114px;opacity:0" onclick="pg72Show1();"></div>
      <div class="addContentLink" style="top: 480px; left: 1138px; width: 312px; height: 114px;opacity:0" onclick="pg72Show2();"></div>
      <div class="addContentLink" style="top: 619px; left: 1138px; width: 312px; height: 114px;opacity:0" onclick="pg72Show3();"></div>


      <div class="addContentLink" style="bottom:5px;right:70px;width:130px; height:30px;">
        <a href="http://www.fie.org/es" target="_blank"></a>
      </div>
      `,
      "script": `
      function onPageEnter() {
        page72Anim = new TimelineMax()
        page72Anim
          .fromTo(idOf("72-title"), 0.5,{y:-100, opacity:0, }, {y:0, opacity:1, onComplete: addContentLinks},0.5)
      }

      function pg72Show1() {
        idOf("72-text-1").style.display = "block"
        idOf("72-text-2").style.display = "none"
        idOf("72-text-3").style.display = "none"
        idOf("72-white1").style.display = "none"
        idOf("72-white2").style.display = "none"
        idOf("72-white3").style.display = "none"

      }

      function pg72Show2() {
        idOf("72-text-1").style.display = "none"
        idOf("72-text-2").style.display = "block"
        idOf("72-text-3").style.display = "none"
        idOf("72-white1").style.display = "block"
        idOf("72-white2").style.display = "block"
        idOf("72-white3").style.display = "none"
      }

      function pg72Show3() {
        idOf("72-text-1").style.display = "none"
        idOf("72-text-2").style.display = "none"
        idOf("72-text-3").style.display = "block"
        idOf("72-white1").style.display = "block"
        idOf("72-white2").style.display = "none"
        idOf("72-white3").style.display = "block"
      }

      function onPageLeave() {
        page72Anim.stop()
        removeContentLinks()
      }
      `,
      "searchText": "RECUERD O  NECROLÓGICAS ANGEL MARTINEZ VASSALLO Con gran pesar, junto a la Real Federación Española de Esgrima, anunciamos el fallecimiento del maestro español de esgrima Ángel Martínez Vassallo este 5 de abril. Nacido en San Sebastián el 20 de enero de 1952, fue miembro del equipo nacional de florete masculino junior y senior hasta 1978, fecha en la que comenzó su actividad como maestro de armas de la Real Federación Española de Esgrima. Tras varios años desempañando las funciones de entrenador nacional en Sevilla y Madrid, en clubes como el Club de Esgrima Maestro Cervantes, el Club de Esgrima de Madrid y la Sala de Armas Palacio de los Deportes, fue designado Jefe de los Equipos Nacionales Absolutos en 1990, cargo que ocupó hasta 2013.  Fue integrante del Equipo de Maestros Campeón del Mundo de Sable y medalla de bronce de florete en 1978, junto a Joaquín Campomanes Grande, Luis Sánchez-Elvira Jiménez y Antonio Solivera González. Formó parte del equipo de entrenadores que desarrolló la esgrima en España y la llevó a vivir los grandes éxitos conseguidos, que culminaron con las medallas de oro de Manuel Pereira en 1989, el equipo de espada femenina de Rosa Castillejo, Taymi Chapé, Carmen Ruiz y Cristina Vargas en 1994 y el bronce olímpico de José Luis Abajo en Pekín 2008.  ANGEL MARTINEZ VASSALLO  AUSTIN EDISON THOMAS  NOUREDDINE ROBBANA  s Click Above to View  Ángel Martínez Vassallo vivió la esgrima con pasión y la hizo su razón de ser hasta el final de sus días. En nombre de la comunidad mundial de esgrima, compartimos nuestro más sentido pesar con sus familiares, amigos y compañeros.■  W W W.FIE .ORG"
      ,
      "mobileHtml":`
        <h2>Angel Martinez Vassallo</h2>
        <p><b>
        Con gran pesar, junto a la Real Federación Española de Esgrima, anunciamos el fallecimiento del maestro español de esgrima Ángel Martínez Vassallo este 5 de abril.
        </b></p>
        <p>
        Nacido en San Sebastián el 20 de enero de 1952, fue miembro del equipo nacional de florete masculino junior y senior hasta 1978, fecha en la que comenzó su actividad como maestro de armas de la Real Federación Española de Esgrima. Tras varios años desempañando las funciones de entrenador nacional en Sevilla y Madrid, en clubes como el Club de Esgrima Maestro Cervantes, el Club de Esgrima de Madrid y la Sala de Armas Palacio de los Deportes, fue designado Jefe de los Equipos Nacionales Absolutos en 1990, cargo que ocupó hasta 2013.
        </p>
        <p>
        Fue integrante del Equipo de Maestros Campeón del Mundo de Sable y medalla de bronce de florete en 1978, junto a Joaquín Campomanes Grande, Luis Sánchez-Elvira Jiménez y Antonio Solivera González.
        </p>
        <p>
        Formó parte del equipo de entrenadores que desarrolló la esgrima en España y la llevó a vivir los grandes éxitos conseguidos, que culminaron con las medallas de oro de Manuel Pereira en 1989, el equipo de espada femenina de Rosa Castillejo, Taymi Chapé, Carmen Ruiz y Cristina Vargas en 1994 y el bronce olímpico de José Luis Abajo en Pekín 2008.
        </p>
        <p>
        Ángel Martínez Vassallo vivió la esgrima con pasión y la hizo su razón de ser hasta el final de sus días. En nombre de la comunidad mundial de esgrima, compartimos nuestro más sentido pesar con sus familiares, amigos y compañeros. 
        </p>
        <h2>Austin Edison Thomas</h2>
        <p><b>
        La FIE se encuentra profundamente entristecida por el anuncio del fallecimiento de Austin Edison Thomas, presidente de la Federación de Esgrima de Aruba.
        </b></p>
        <p>
        Dedicó toda su vida a la esgrima e hizo pionero este deporte en Aruba. El Sr. Thomas trabajó sin descanso y con extraordinaria perseverancia para implantar y fomentar la esgrima en Aruba y en otros países.
        </p>
        <p>
        El Sr. Thomas nació el 25 de marzo de 1939 y participó en los Juegos Olímpicos de Seúl de 1988, en florete y espada individual.
        </p>
        <p>
        La comunidad mundial de esgrima ha perdido a un amigo de toda la vida, dedicado de manera plena y leal a su cometido. Fue un verdadero ejemplo de compromiso y determinación.
        </p>
        <p>          
        La FIE y la familia internacional de esgrima ofrece su más sincero pésame a los amigos y a la familia del Sr. Thomas, así como a la Federación de Esgrima de Aruba, y expresa sus más sentidas condolencias durante este difícil trance. 
        </p>
        <h2>NOUREDDINE ROBBANA</h2>
        <p><b>
        Con profundo pesar, la FIE se entristece al informar del fallecimiento de Noureddine Robbana de Túnez el 20 de marzo.
        </b></p>
        <p>
        El Sr. Robbana, nacido el 9 de febrero de 1949, tuvo una larga y distinguida carrera en la esgrima a nivel mundial. Más recientemente, en el Congreso Electoral de 2016, fue votado como miembro de la Comisión de Promoción, Comunicación y Publicidad de la FIE. Obtuvo otros logros y nombramientos destacables en el mundo de la esgrima a lo largo de su vida:
        «La FIE ha perdido un miembro comprometido y dinámico, y un fiel amigo totalmente dedicado a la causa de la esgrima», dijo el presidente de la FIE, Alisher Usmanov.
        </p>
        <p>
        En nombre de la comunidad mundial de esgrima, la FIE ofrece sus más sinceras condolencias y su más sentido pésame durante este difícil período a la familia y amigos del Sr. Robanna, y a la Federación Tunecina de Esgrima.
        </p>
      `
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }
    `,
    "mobilePages":[{
      "title": "Escrime XXI No. 106",
      "cssClass": "cover mobile-p1",
      "hideInMenu": false,
      "pageLinks": [{
        "index": 0,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 2,
        "subIndex": 0
      }]
    },
    {
      "title": "Comité Ejecutivo De La FIE",
      "cssClass": "aqua",
      "hideInMenu": false,
      "pageLinks": [{
        "index": 4,
        "subIndex": 0
      }]
    },
    {
      "title": "Prólogo",
      "cssClass": "aqua",
      "hideInMenu": false,
      "pageLinks": [{
        "index": 5,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 6,
        "subIndex": 0
      }]
    },
    {
      "title": "Campeonatos Del Mundo De Esgrima Júnior Y Cadete",
      "cssClass": "purple",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 7,
          "subIndex": 0
        },
        {
          "index": 8,
          "subIndex": 0
        },
        {
          "index": 9,
          "subIndex": 0
        },
        {
          "index": 10,
          "subIndex": 0
        }
      ]
    },
    {
      "title": "Anaheim",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 11,
          "subIndex": 0
        },
        {
          "index": 12,
          "subIndex": 0
        },
        {
          "index": 13,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Budapest",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 14,
          "subIndex": 0
        },
        {
          "index": 15,
          "subIndex": 0
        }
      ]
    },
    {
      "title": "Seúl",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 16,
          "subIndex": 0
        },
        {
          "index": 17,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 18,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 19,
        "subIndex": 0
      }]
    },
    {
      "title": "Moscú",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 20,
          "subIndex": 0
        },
        {
          "index": 21,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Shanghái",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 22,
          "subIndex": 0
        },
        {
          "index": 23,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 24,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 25,
        "subIndex": 0
      }]
    },
    {
      "title": "Cali",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 26,
          "subIndex": 0
        },
        {
          "index": 27,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Atenas",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 28,
          "subIndex": 0
        },
        {
          "index": 29,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 30,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 31,
        "subIndex": 0
      }]
    },
    {
      "title": "Tauberbischofsheim",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 32,
          "subIndex": 0
        },
        {
          "index": 33,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Dubai",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 34,
          "subIndex": 0
        },
        {
          "index": 35,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 36,
        "subIndex": 0
      }]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 37,
        "subIndex": 0
      }]
    },
    {
      "title": "San Petersburgo",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 38,
          "subIndex": 0
        },
        {
          "index": 39,
          "subIndex": 0
        }
      ]
    },
    {
      "title": "Paris",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 40,
          "subIndex": 0
        },
        {
          "index": 41,
          "subIndex": 0
        }
      ]
    },
    {
      "title": "Madrid",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 42,
          "subIndex": 0
        },
        {
          "index": 43,
          "subIndex": 0
        }
      ]
    },
    {
      "title": "Túnez",
      "cssClass": "red",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 44,
          "subIndex": 0
        },
        {
          "index": 45,
          "subIndex": 0
        }
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 46,
        "subIndex": 0
      }]
    },
    {
      "title": "Conozca A Los Atletas",
      "cssClass": "aqua",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 47,
          "subIndex": 0
        },
        {
          "index": 48,
          "subIndex": 0
        }
      ]
    },
    {
      "title": "Noticias De La FIE Y De Las Federaciones Nacionales",
      "cssClass": "green",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 49,
          "subIndex": 0
        },
        {
          "index": 50,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Confederación Panamericana De Esgrima",
      "cssClass": "green",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 51,
          "subIndex": 0
        },
        {
          "index": 52,
          "subIndex": 0
        },
        {
          "index": 53,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Dona Tu Equipamiento De Esgrima",
      "cssClass": "green",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 54,
          "subIndex": 0
        },
        {
          "index": 55,
          "subIndex": 0
        },
        {
          "index": 56,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Día Mundial De La Esgrima",
      "cssClass": "green",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 58,
          "subIndex": 0
        },
        {
          "index": 59,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Brasil: Un Año Después",
      "cssClass": "green",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 60,
          "subIndex": 0
        },
        {
          "index": 61,
          "subIndex": 0
        },
        {
          "index": 62,
          "subIndex": 0
        },
        {
          "index": 63,
          "subIndex": 0
        },
      ]
    },
    {
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 64,
        "subIndex": 0
      }]
    },
    {
      "title": "FED Nepal",
      "cssClass": "green",
      "hideInMenu": false,
      "pageLinks": [{
          "index": 65,
          "subIndex": 0
        },
        {
          "index": 66,
          "subIndex": 0
        },
        {
          "index": 67,
          "subIndex": 0
        }
      ]
    },{
      "title": "Anuncio",
      "cssClass": "advert",
      "hideInMenu": true,
      "pageLinks": [{
        "index": 68,
        "subIndex": 0
      }]
    },
    {
      "title": "Noticias De La FIE",
      "cssClass": "yellow",
      "hideInMenu": false,
      "pageLinks": [{
        "index": 69,
        "subIndex": 0
      }]
    },
    {
      "title": "Recuerdo",
      "cssClass": "darkblue",
      "hideInMenu": false,
      "pageLinks": [{
        "index": 70,
        "subIndex": 0
      }]
    },
  ],
  "mobileTemplate": null,
}


// WEBPACK FOOTER //
// ./src/document.js